export const languageResourceEn = {
  translation: {
    NomLogiciel: 'OpenCash',
    language: 'en',
    Administraion: 'Administraion',
    total: 'Totals',
    DescriptionLogiciel:
      'Banking communication, payment methods, cash management...',
    pdfViewer: {
      Title: 'Print preview',
    },
    success: 'Success',
    error: 'Error',
    message_error_rib: 'Please attach a RIB type document for the new account',
    label_title_liste: 'List of Labels',
    ListSmartTags: 'List of SmartTags',
    find_smart_tags: 'Search a SmartTag by code',
    ListBanque: 'List of Banks',
    find_banque: 'Search for a bank by code, name...',
    find_label: 'Search for a label by section value...',
    lecture_seule: ' (Read only)',
    'List of companies': 'List of companies',
    State: 'Status',
    None: 'None',
    Name: 'Name',
    Code: 'Code',
    update_timestamp: 'Modification date',
    Edit: 'Edit',
    Delete: 'Delete',
    code_society: 'Company',
    Import: 'Import',
    Export: 'Export',
    New: 'New ',
    Element: 'item',
    Elements: 'items',
    View: 'View',
    History: 'History',
    Statement: 'Statement',
    Back: 'Cancel',
    Selection: 'Selection',
    Ok: 'Ok',
    Print: 'Print',
    Entity: 'Entity',
    refresh: 'Refresh',
    error_required: '* This field is required.',
    error_maxLength: '* The maximum number of characters allowed is {{max}}.',
    error_minLength: '* The minimum number of characters allowed is {{min}}.',
    'New company': 'New company',
    'Fax number': 'Fax No.',
    'Phone number': 'Phone No.',
    'Legal informations': 'Legal information',
    Address: 'Address',
    'Country code': 'Country',
    'Closing date': 'Closing date',
    Duplicate: 'Duplicate',
    Download: 'Download',
    Restart: 'Rerun',
    'Upload image': 'Upload picture',
    'Update company successfully': 'Update company successfully',
    'Update company failed': 'Company update failed',
    Save: 'Save',
    'Company detail': 'Company detail',
    '4Eyes State': '4Eyes state',
    'Liste des lots': 'List of batches',
    Emetteur: 'Issuer',
    'N remise': '# remittance',
    Montant: 'Amount',
    Comment: 'Comment',
    Devise: 'Currency',
    pour1: 'For 1',
    Add: 'Add',
    Reissue: 'Reissue',
    Origine: 'Origin',
    Statut: 'Status',
    Confirmation: 'Confirmation',
    Valider: 'Validate',
    'Valider-New': 'Validate and new',
    nextinvoicebutton: 'Following discounts',
    Fermer: 'Close',
    'Recherche grp tiers':
      'Search for a group of third parties by code, name...',
    'Groupe de tiers': 'group of third parties',
    details: 'details',
    Suppression: 'Do you want to delete ',
    Confirmer: 'Confirm',
    Annuler: 'Cancel',
    Creer: 'Create',
    RechercherSociete: 'Search for a company by code, name...',
    ComboEtat: '- State -',
    ComboFlux: '- Flow -',
    ComboFichier: '- Type Fichier -',
    ComboOrigine: '- Origin -',
    ComboStatut: '- Status -',
    ComboGrpTiers: '- Group of third parties -',
    Signature: 'Signature',
    'Nb Operations': 'No.',
    Rappro: 'Reconciliation',
    RechercheLot: 'Search for a batch by batch number, currency number...',
    RechercheTiers:
      'Search for a third party by code, name, account number, company registration number...',
    Groupe: 'Group',
    'New tiers': 'Create a new third party',
    'Details tiers': 'Third-party sheet',
    General: 'General',
    IBAN: 'Bank details',
    'Adresse tiers': "Third party's address",
    'Banque inter': 'Intermediary bank',
    Expand: 'Expand',
    Nom: 'Last name',
    Prenom: 'First name',
    Naissance: 'Date of birth',
    PNaissance: 'Country of birth',
    VNaissance: 'City of birth',
    Company: 'Company',
    Rules: 'Rules',
    NCompte: 'Account No.',
    AutoEmetteur: 'Authorize issuer account',
    AutoTiers: 'Authorize third-party account',
    'Fiche du compte': 'Account sheet',
    'Informations complémentaires': 'Additional information',
    Collapse: 'Collapse',
    Action: 'Actions',
    NoData: 'No data available',
    Loading: 'Loading',
    'n° mobile': 'Mobile phone No.',
    prenom: 'First name',
    nom: 'Last name',
    etat_user: 'State user',
    Etat_user_entite: 'User entity state',
    'N° demande': '#',
    'Type de demande': 'Type of request',
    'Validation date': 'Validation / Denial',
    'Request type': 'type of request',
    'Short name': 'name (short)',
    valideur: 'validator',
    'Request date': 'request date',
    Applicant: 'requester',
    titleChange: 'Change of Entity or Scope',
    Perim: 'Search for a scope',
    Fil: 'Search for an entity',
    scope: 'Scope',
    entity: 'Entity',
    account_management: {
      account_list: 'List of bank accounts',
      search_txt:
        'Search for an account by code, name, account number, company code, company name...',
      account_detail: 'View account statement',
      operation: 'transactions',
      search_detail: 'Search for a transaction by reference, code, text...',
    },
    bool: {
      yes: 'Yes',
      no: 'No',
    },
    calendar: {
      today: 'Today',
      yesterday: 'Yesterday',
      tomorrow: 'Tomorrow',
      last7Days: 'Last 7 days',
      week: 'Current week',
      mounth: 'Current month',
      lastMonth: 'Last month',
      last30days: 'Last 30 days',
      year: 'Current year',
      lastYear: 'Last year',
      mon: 'Mon',
      tue: 'Tue',
      we: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sa: 'Sat',
      sun: 'Sun',
      formatdate: 'DD/MM/YYYY',
      clear: 'Remove',
      last_tree_mounth: 'Last quarter',
      current_tree_mounth: 'Current quarter',
      first_quarter: 'Q1',
      second_quarter: 'Q2',
      third_quarter: 'Q3',
      fourth_quarter: 'Q4',
      first_semestre: 'S1',
      second_semestre: 'S2',
      placeholder: 'DD/MM/YYYY - DD/MM/YYYY',
      placeholder_dateMonth: 'DD/MM',
      placeholder_yearOnly: 'YYYY - YYYY',
      fullCalendarTitle: 'Full Calendar',
      month: 'Month',
      day: 'Day',
      addEvent: 'Add New Event',
      editEvent: 'Edit Event',
      saveEvent: 'Save Event',
      updateEvent: 'Update Event',
      eventTitle: 'Event Title',
      eventDescription: 'Event Description',
      eventTitlePlaceholder: 'Enter event title...',
      eventDescriptionPlaceholder: 'Enter event description (optional)...',
      confirmDelete: 'Are you sure you want to delete the event "{{title}}"?',
      back: 'Back',
    },
    treepicker: {
      placeholder: 'Search',
    },
    data_grid: {
      start: 'Min',
      end: 'Max',
      noDataToExport: 'No data to export',
      pagination: 'Results per page',
      indexpagination: 'on',
      showpagination: 'Show',
      diff_showpagination: 'Showing',
      diffindex: 'of',
    },
    Pays: 'Country',
    expired_session:
      'Session expired. Your authentication token is no longer valid. Please log in again to continue.',
    login: {
      hometitle: 'OpenCash | Authentication',
      login: 'Login',
      forgotpassword: 'Forgot password? ',
      reset: 'Reset',
      saveCredentials: 'Save',
      loginFailed: 'Wrong login/password. Please try again',
      signin: 'Login',
      username_required: 'Email required',
      password_required: 'Password required',
      enter_email: 'Enter your email',
      reset_password: 'Reset password',
      back_to: 'Back to',
      pwd: 'Password',
      confirm_password: 'Password Confirmation',
      language: 'Language preference',
      confirm_error: 'Password does not correspond',
      reset_password_label: 'Reset password',
      send_mail: 'Send an email',
      confirm_new_pwd: 'Confirm new password',
      current_password_required: 'Current password is required',
      current_pwd: 'Current password',
      generic_error: 'An error occurred, please try again',
      info_pwd_label:
        'Your password has expired. You must enter a new password',
      new_pwd: 'New password',
      password_min_length: 'The password must contain at least 8 characters',
      password_must_match: 'Passwords do not match',
      password_updated_success: 'Your password has been updated successfully',
      update: 'Change password',
      update_pwd_label: 'Password update',
      updating: 'Updating...',
    },
    creation_date: 'Creation date',
    execution_date: 'Execution date',
    composant_document: {
      add_title: 'Create a new document',
      edit_title: 'Document sheet',
      txt_errorfile: 'All fields are required except end date',
    },
    notification: {
      title: 'Notifications',
      empty: 'Empty notification',
      show_not_seen: 'Show unread only',
      mark_as_read: 'Mark as read',
      clear_all: 'Clear all',
    },
    dashboard: {
      widget: {
        users: {
          title: 'Users',
          header_title: 'Active',
          left_title: 'Sole signatory',
          middle_title: 'Dual signatories',
          right_title: 'Mobile phones',
          other_title: '',
        },
        jobs: {
          title: 'Jobs',
          header_title: 'Today',
          left_title: 'ToDo',
          middle_title: 'Done',
          right_title: 'Failed',
          other_title: '',
        },
        deleted_batches: {
          title: 'List of rejected or deleted batches',
          numlot: 'Batch No.',
          compte: 'Account',
          montant: 'Amount',
          devise: 'Currency',
          status: 'Type',
          date: 'Refusing date',
          date_execution: 'Execution date',
          user: 'Login',
        },
        treasury_reconciliation: {
          title: 'Cash flow reconciliation',
          header_title: 'Bank movements received today',
          left_title: 'Unreconciled bank movements',
          middle_title: 'Due forecasts',
          right_title: 'Temporary forecasts',
        },
        treasury_account_control: {
          title: 'Cash account control',
          header_title: 'Cash-managed accounts',
          left_title: 'Accounts Ok',
          middle_title: 'Account KO',
          right_title: 'Value balance OK',
          other_title: 'Value balance KO',
        },
        statistic_statements: {
          title: 'Account statements',
          header_title: 'Managed accounts',
          left_title: 'Accounts OK',
          middle_title: 'Accounts KO',
          right_title: '',
          other_title: '',
          tabs: {
            releves_compte: 'Account statements',
            comptes_erreur: 'Accounts in error',
          },
          datagrid: {
            code: 'Code',
            solde: 'Balance',
            devise: 'Currency',
            date: 'Balance date',
            status: 'Status',
            fault: 'Blockage',
            compte: 'Account Name',
            banque: 'Bank',
          },
        },
        current_account: {
          treasury: {
            title: 'Cash flow current accounts',
          },
          associate: {
            title: "Partners' current accounts",
          },
          central: {
            title: 'Master current account',
          },
          tabs: {
            graph: 'Chart',
            list: 'List',
            total: 'Total',
          },
          datagrid: {
            nom: 'Name',
            date: 'Date',
            montant: 'Amount',
            currency: 'Currency',
          },
        },
        received_files: {
          header_title: 'Received files',
          datagrid: {
            flow: 'Flow',
            bank: 'Bank',
            file_format: 'File Format',
            date: 'Date of receipt',
          },
        },
        maps_flows: {
          title: 'Flow breakdown',
          filters: {
            placeholder: 'Type of filter',
            country: 'Country',
            currency: 'Currency',
          },
          currency: {
            placeholder: 'Choose a currency',
          },
        },
        statistics_flows: {
          title: 'Flow statistics',
        },
        comparative_flows: {
          title: 'Flow evolution',
        },
        currencyRate: {
          titleRate: 'Interest rate',
          titleCurrency: 'Exchange rates',
          favori: 'Favourites',
          all: 'All',
          column: {
            name: 'Name',
            date: 'Date',
            currency: 'Exchange rate',
          },
        },
        repository: {
          title: 'Repository',
          header_title: '',
          left_title: 'Companies',
          middle_title: 'Accounts',
          right_title: 'Third parties',
          other_title: '',
        },
        '4eyes': {
          title: '4-Eyes Validation',
          header_title: 'validations',
          left_title: 'third parties',
          middle_title: 'repository',
          right_title: 'users',
          other_title: 'profiles',
        },
        accounting_export: {
          title: 'Accounting Export',
        },
        active_signatory: {
          title: 'Active Signatory List',
          name: 'Name',
        },
        active_users: {
          title: 'Active User List',
        },
        events: {
          title: 'Event log',
        },
        treasury_report: {
          title: 'Print State',
          print: 'Print',
          etat: 'Deferral',
        },
        treasury_zoom_report: {
          title: 'Print Zoom State',
        },
        workflow: {
          title: 'Validation signature book',
          header_title: 'Batches',
          left_title: 'Unassigned',
          middle_title: 'Fraud Monitor',
          right_title: 'Signature book 1',
          other_title: 'Signature book 2',
        },
        management: {
          onglet: 'Tab',
          save: 'Save dashbord',
          modify: 'Unlock dashboard',
          list: 'Select widgets',
          tab_error: ' (Tab in error)',
          modal: {
            title: 'List of widgets',
            add: 'Add',
            delete: 'Delete',
          },
        },
        error: {
          errorWidget: 'Loading error',
          text: 'A loading error has occurred',
          delete: "You can't delete an opening tab",
        },
        groupPosition: {
          title: 'Group Analysis',
          column: {
            group: 'Group',
            forecast: 'Forecasts',
            balance: 'Balances',
            liquid_investment: 'Liquid Investments',
            current_account: 'Current Accounts',
            proper_treasury: 'Own cash flow',
            illiquid_investment: 'Non-Liquid Investments',
            internal_lending: 'Interco loan',
            external_lending: 'External Loan',
            net_treasury: 'Net cash flow',
          },
        },
        accountStatements: {
          byCompany: {
            title: 'Total Bank Balance - Entity Wise',
            column: {
              societe: 'Company',
              montant: 'Amount',
              devise: 'Currency',
              date: 'Date',
            },
          },
          byBank: {
            title: 'Total Bank Balance - Bank Wise',
          },
          byCurrency: {
            title: 'Total Bank Balance - Currency Wise',
          },
        },
        treasury_object: {
          '30_days': '30D',
          '60_days': '60D',
          '90_days': '90D',
          label: 'Faling due in :',
          investments: 'Investment maturities',
          debts: 'Debts maturities',
          column: {
            name: 'Reference',
            due_date: 'Due Date',
            amount: 'Amount',
            currency: 'Currency',
          },
        },
        certificate: {
          title: 'Certificates maturities',
          column: {
            user_id: 'UserID',
            connector: 'Connector',
            signature_date: 'Self-signed Maturity Date',
            signature_date_3skey: 'Signature Maturity Date',
          },
        },
        signatory_book: {
          title: 'My signatory book',
          header_title: 'Batches',
          all_signed: 'No batch to sign',
        },
        rules_statements_alert: {
          title: 'Account statements alert',
          columns: {
            code_compte: 'Account code',
            montant: 'Amount',
            devise: 'Currency',
            category: 'Category',
            label: 'Label',
            op_date: 'Operation date',
            rule_code: 'Rule code',
            update_timestamp: 'Modification date',
          },
        },
        balance: {
          balance_value_on_date: 'Balance in value as of {{date}}',
          solde: 'Balance',
          solde_operation: 'Balances and Forecasts',
          prevision: 'Forecasts',
          affiche: 'Show',
        },
        treasury_transaction_balance: {
          title: 'Treasury - Balance by Transaction',
          affiche: 'Display',
          devise: 'Currency',
          label: 'Label',
        },
      },
    },
    component_document: {
      titleImportfile: 'PDF document',
      importfile: 'File import...',
      btnNameEdit: 'Document Sheet',
      btnNameAdd: 'Document',
      docName: 'Document name',
      docType: 'Type of document',
      docEtat: ' Status',
      dateEnd: 'End date',
      dateStart: 'Start date',
      erroValidationChamp: 'All fields are required except end date',
      errorFormatfile: 'Please import a PDF file',
      titleError: 'Error',
      placeholderDocName: '- If empty name loaded automatically -',
      nbFileAccepted: 'PDF file accepted',
      other_file_type: 'Please insert a pdf file',
    },
    idleModal: {
      title: 'Your session is about to timeout',
      expiration:
        'Your session is about to timeout. You will be automatically logged out.',
      question: 'Do you want to stay logged in?',
      remaining: 'You have {{remainingTime}} seconds before being logged out',
      button: 'Stay logged in',
    },
    datagrid: {
      pageText: 'Page',
      ofText: ' on ',
      perPageText: 'Results per page',
      showingText: 'Show ',
      clearAll: 'Delete all filters',
      clear: 'Delete filter',
      showFilteringRow: 'Show filters',
      hideFilteringRow: 'Do not show filter',
      enable: 'Enabled',
      disable: 'Disabled',
      sortAsc: 'Sort by ascending order',
      sortDesc: 'Sort by descending order',
      unsort: 'Unsorted',
      group: 'Bundle',
      ungroup: 'Unbundle',
      lockStart: 'Freeze to start',
      lockEnd: 'Freeze to end',
      unlock: 'Do not freeze',
      columns: 'Columns',
      autoresizeThisColumn: 'Resize this column',
      autoresizeAllColumns: 'Resize all columns',
      autoSizeToFit: 'Autofit',
      contains: 'Contains',
      startsWith: 'Starts with',
      endsWith: 'Ends with',
      notContains: 'Does not contain',
      inlist: 'Is in the list',
      notinlist: 'Is not in the list',
      neq: 'Different from',
      inrange: 'In the range',
      notinrange: 'Is not in the range',
      eq: 'Equal',
      notEmpty: 'Non-empty',
      empty: 'Is empty',
      lt: 'Less than',
      lte: 'Less than or equal ',
      gt: 'Greater than',
      gte: 'Greater than or equal',
      before: 'Less than',
      beforeOrOn: 'Less than or equal',
      afterOrOn: 'Greater than or equal',
      after: 'Greater than',
      start: 'From',
      end: 'To',
      dragHeaderToGroup: 'Drag here to aggregate',
      noRecords: 'string',
      calendartodayButtonText: 'Today',
      calendarclearButtonText: 'Clear',
      calendarokButtonText: 'Validate',
      calendarcancelButtonText: 'Cancel',
    },
    cash: {
      flux: {
        audit: 'Audit',
        attribution: 'Assignment',
        signer: 'Sign',
        comment: {
          title: 'Batch comment {{batchId}}',
          columns: {
            date: 'Date',
            comment: 'Comment',
            type: 'Type',
            login: 'Login',
          },
          add: 'Add a comment',
        },
        validate: 'Validate control',
        relaunch: 'Run fraud monitor',
        print: 'Print',
        slip: 'Slip',
        edit: 'Are you sure you want to edit the transactions of this batch and toggle to entry mode',
        remettre: 'Toggle to entry mode',
        visualiserPDF: 'Supporting document',
        unauthorize_view:
          'Detailed view is not authorised on this type of flow',
        detail: {
          title: {
            remittance: 'Remittance details {{remittance_number}}',
            operation: 'Operation',
            facture: 'Invoice details {{remittance_number}}',
          },
          columns: {
            beneficiary_name: 'Beneficiary',
            reference_label: 'Reference/Text',
            print: 'View',
            number: 'No.',
            amount: 'Amount',
            currency: 'Currency',
            ara: 'ARA',
            reject: 'Reject',
            rules: 'Rules',
            fraud_monitor: 'Fraud monitor',
            choice: 'Choice',
            delete: 'Delete',
            vsr: 'VSR Status',
          },
          buttons: {
            tracking: 'Tracker',
            print: 'Print Notice',
            back: 'Back',
            validate: 'Confirm control',
            validateChoice: 'Validate choice',
            refuse: 'Reject batch',
            invoice: 'Invoices',
          },
          champ_titles: {
            societe: 'Company',
            compte: 'Account',
            ibanBban: 'IBAN/BBAN',
            lot_number: 'Batch No.',
            origine: 'Origin',
            author: 'Login',
            state: 'Status',
            flow: 'Flow',
            creation_date: 'Creation date',
            execution_date: 'Execution date',
            emitter: 'Issuer',
            operation_number: 'No.',
            amount: 'Remittance amount',
            status: 'Status',
            reason: 'Reason',
            origin_amount: 'Original amount',
            fee: 'Fees',
            fee_type: 'Type of fees',
            tracker_number: 'Tracker No.',
            confirmation_date: 'Date confirmed',
            amount_credited: 'Amount Credited',
            label: 'Label',
            send: 'Sent on',
          },
          tracking_status: {
            ACSC: 'Debit confirmation, proof of payment initiation.',
            G001: 'Settlement in progress. Payment transferred to a non-gpi agent or MI (local interbank exchange system) not supported',
            G005: 'Settlement in progress. Delivered to the beneficiary bank as a gpi.',
            G006: 'Settlement in progress. Delivered to the beneficiary bank as a non-gpi.',
            Gxxx: 'Settlement in progress.',
            ACCC: 'The creditor has been credited.',
            RJCT: 'Rejected',
            PDNG: 'Pending',
          },
          process: {
            treated: 'Processed',
            waiting: 'Waiting',
            credited: 'Credited',
          },
          copy: 'Copy link.',
          copied: 'Copied !',
          invoice: {
            champ_titles: {
              IBAN: 'IBAN',
              reference: 'Reference',
              label: 'Text',
              montant: 'Amount',
              devise: 'Currency',
              tiers: 'Third party',
              ibanBban: 'IBAN/BBAN',
            },
            columns: {
              client_reference: 'Client reference',
              supplier_reference: 'Supplier reference',
              invoice_number: 'Invoice N°',
              date_fact: 'Invoice date',
            },
          },
          coller: 'Paste!',
        },
        EditRemise: 'Change the execution date of remittance {{id}}',
        operation: 'Edit transactions',
        FraudMonitor: {
          table: {
            title: 'List of controlled batches',
            buttons: {
              audit: 'Audit',
              validate: 'Validate control',
              print: 'Print',
            },
            columns: {
              batche_number: 'Batch No.',
              remittance_number: 'Remittance No.',
              flow: 'Flow',
              state: 'Status',
              transmitter: 'Account',
              login: 'Login',
              date: 'Date',
              operation_number: 'No.',
              amount: 'Amount',
              currency: 'Currency',
              origin: 'Source',
              status: 'Type',
            },
            modal: {
              title: {
                audit: 'Audit of the batch No. {{batche_number}}',
              },
              columns: {
                date: 'Date',
                login: 'Login',
                action: 'Action',
              },
              buttons: {
                buttons: 'Close',
              },
            },
          },

          fiche: {},
        },
        Cheque: {
          table: {
            title: 'List of batches of cheque to be printed',
            columns: {
              batche_number: 'Batch No.',
              remittance_number: 'Remittance No.',
              flow: 'Flow',
              state: 'Status',
              transmitter: 'Account',
              login: 'Login',
              date: 'Date',
              operation_number: 'No.',
              amount: 'Amount',
              currency: 'Currency',
              origin: 'Source',
              status: 'Type',
              check_print: 'Print cheques',
            },
            apercu: {
              title: 'Cheque print preview',
              button: 'Validate print',
            },
            range: {
              title: 'Range of cheque numbers',
              next: 'Next number',
              last: 'Last number',
              first_op: 'First transaction No.',
              last_op: 'Last transaction No.',
              account_divider: 'Account settings',
              update: 'Modify the cheque range',
              error:
                'The range entered is greater than the authorised range.\nPlease increase your account range.',
              button: 'Range',
            },
            modal: {
              title: {
                audit: 'Audit of the batch No. {{batche_number}}',
              },
              columns: {
                date: 'Date',
                login: 'Login',
                action: 'Action',
              },
              buttons: {
                buttons: 'Close',
              },
            },
            message:
              'Have you printed the cheque(s)? After validation, you will no longer be able to print the cheque(s).',
          },

          fiche: {},
        },
        Integration: {
          fiche: {},
          table: {
            title: 'Manual import of files',
            addfile: 'Add',
            labelmodel: 'Import template',
            choosefile: 'Select files',
            import_placeholder: 'None',
            smartag: 'SmartTags',
          },
        },
        GestionLots: {
          header: {
            title: 'List of batches',
          },
          columns: {
            flow: 'Flow',
            state: 'Status',
            account: 'Account',
            login: 'Login',
            date: 'Date',
            count: 'No. transactions',
            montant: 'Amount',
            devise: 'Currency',
            origin: 'Source',
            status: 'Type',
            pdf_files: 'PDF',
            comment: 'Com.',
            signing: 'Signature',
            lot_number: 'Batch No.',
            remittance_number: 'Remittance No.',
            amount_max: 'Max',
            amount_min: 'Min',
            source_file_name: 'File name',
            smarttag: 'SmartTags',
            date_transmission: 'Transmission Date',
          },
          modal: {
            title: 'Remittance details {{remittance_num}}',
            audit: 'Audit of batch No. {{batche_number}}',
            titleDelete: 'Comment for deleting batch No. {{batche_number}',
            buttonDelete: 'Delete',
          },
          attributionModal: {
            message_infos_type_pdf: 'Only PDF files are allowed',
            title: 'Assign signatories of batch No. {{num_attribution}}',
            state_signature: 'Signature state',
            flux: 'Flow',
            created_date: 'Creation date',
            operationNumber: 'No. of transactions',
            amount: 'Amount',
            currency: 'Currency',
            name: 'Name',
            one_signature: 'Signature 1',
            college: 'College',
            niveau: 'Levels',
            two_signature: 'Signature 2',
            justificated_piece: 'Supporting document',
            attributed: 'Allocate',
            alert_file: 'You can select up to 3 files only.',
            columns: {
              level: 'Level',
              signataire1: 'Signatory 1',
              signataire2: 'Signatory 2',
              signataire: 'Signatory {{nb}}',
              college1: 'College 1',
              college2: 'College 2',
            },
            title_document_validation: 'Assign signatories',
          },
        },
        HistoriqueLots: {
          actions: {
            writing_generate: 'Generation of account entries',
            message: 'Do you want to resend the batch to the bank?',
          },
          header: {
            title: 'Batch history',
            advance_search_button: 'Advanced search',
            launch_search: 'Search',
            recherche_suppl: '- Specific search -',
            advanced_title: 'Advanced search on transactions',
            search: 'Search for batches by third party, reason, reference...',
            transmission_date: 'Transmission Date',
            exec_date: 'Execution Date',
            recherche_signature: '- Signatories -',
          },
          columns: {
            pdf_files: 'PDF',
            lot_number: 'Batch No.',
            remise_number: 'Remittance No.',
            flow: 'Flow',
            state: 'Status',
            emetteur: 'Account',
            login: 'Login',
            date: 'Date',
            operation_number: 'No.',
            montant: 'Amount',
            devise: 'Currency',
            origine: 'Origin',
            status: 'Type',
            ack: 'ACK',
            delivrance: 'Delivery',
            psr: 'PSR protocol',
            ara1: 'ARA 1',
            transaction_ref: 'Operation reference',
            account_number: 'Account No.',
            third_party: 'Third parties',
            montant_lot: 'Batch amount',
            code_countrie: 'Country code',
            ara_operation: 'ARA Operation',
            valid_1: 'Validator 1',
            valid_2: 'Validator 2',
            sign_1: 'Signatory 1',
            sign_2: 'Signatory 2',
            reject_reason: 'Rejection Reason',
            road_name: 'Street Name',
            road_number: 'Street Number',
            city: 'City',
            postal_code: 'Postal Code',
            town: 'City',
            bp: 'P.O. Box',
            district: 'District',
            region: 'Region',
            reference: 'Reference',
            reason: 'Label',
          },
        },
        Signature: {
          header: {
            title: 'My signature book',
          },
          table: {
            sign: 'Sign',
            reject: 'Reject',
          },
          modal: {
            commentTitle: 'Comment for rejection of batch {{name}}',
            refusTitle: 'Reject',
            titleOTP: 'OTP signature',
            titleEbics: 'Ebics TS signature',
            sendOTP: 'Sign batch',
            sendEbics: 'Electronically sign',
            cancel: 'Cancel',
            champOTP:
              'Enter the code received by text message or the single-use code',
            champEbics: 'Enter key password',
            validate: 'Validate signature',
            decline: 'Reject',
            comment: 'Comment',
            message_confirm_signin: 'Would you like to sign this lot',
            lot_selec: 'Number of Lots : ',
            total: 'Arithmetic sum :',
            mobile_action:
              'Have you validated the signature in your Swift “Digital ID” mobile application?',
            verif_code:
              'Please confirm the following verification code in your mobile application:',
            progression: 'Batch signing progress: {{signedNb}}/{{totalNb}}',
          },

          fiche: {},
        },
        Saisie: {
          fiche: {
            title: {
              new_title: 'New batch of {{code}}',
              edit_title: 'Change of batch No. {{id}} of {{code}}',
              operation: 'List of transactions',
              timeline: 'Select Maturity date',
            },
            champ_titles: {
              account: 'Issuer account',
              currency: 'Transaction currency',
              execution_date: 'Execution date',
            },
            buttons: {
              save: 'Create batch',
              back: 'Cancel',
              send_to_validate: 'Send for validation',
              timeline: 'Payment schedule',
              by_list: 'Entry by list',
            },
            columns: {
              thirdparty: 'Third parties',
              account: 'Account No.',
              amount: 'Amount',
              currency: 'Currency',
              reference: 'Reference',
            },
            modal: {
              title: 'Entry by list',
              columns: {
                code: 'Code',
                name: 'Name',
                account: 'Account No.',
                amount: 'Amount',
                currency: 'Currency',

                note: 'Note',
              },
              champ_titles: {
                reference: 'Common reference',
                reason: 'Common reason',
              },
            },
          },
          table: {
            title: 'List of batches currently being entered',
            columns: {
              batch_number: 'Batch No.',
              flow: 'Flow',
              account: 'Account',
              operation_number: 'No.',
              amount: 'Amount',
              currency: 'Currency',
              execution_date: 'Execution date',
              creation_date: 'Creation date',
              update_date: 'Modification date',
            },
            buttons: {
              new: 'New Batch',
              delete: 'Do you really want to delete ',
            },
          },
          timeline: {
            title: {
              general: 'List of payment schedules',
              operations_list: 'List of transactions',
            },
            columns: {
              rum: 'UMR',
              debtor_code: 'Debtor code',
              debtor_name: 'Debtor name',
              next_due_date: 'Next maturity',
              type: 'Type',
              sequence: 'Sequence',
              reason: 'Reason',
              reference: 'Reference',
              amount: 'Amount',
            },
            champ_titles: {
              date: 'Payment date',
              sample_number: 'Number of withdrawals on portfolio',
              amount: 'Portfolio sum',
              reason: 'Reason',
              reference: 'Reference',
            },
            buttons: {
              addTo: 'add to batch',
              validate: 'Validate',
            },
          },
          operation: {
            title: {
              new_title: 'Add a transaction',
              edit_title: 'Transaction {{name}}',
              address_thirdparty: "Third party's address",
              informations: 'Additional information',
              bank: 'Bank details',
              intermediary_bank: 'Intermediary bank',
              fournisseur_bank: 'Supplier address',
              fournisseur_structure_bank: 'Supplier structured address',
            },
            champ_titles: {
              reference: 'Reference',
              amount: 'Amount',
              name: 'Name',
              reason: 'Reason',
              country: 'Country',
              account_number: 'Account No',
              bank_name: 'Bank address',
              bic: 'BIC',
              address: 'Address',
              clearing: 'Clearing',
              clearing_id: 'ID clearing',
              type: 'Type',
            },
            buttons: {
              save: 'Validate',
              back: 'Cancel',
              search: 'Search',
              import_amount: 'Load amounts',
              excel_export: 'Excel Export',
            },
            placeholder: {
              search: 'Search for a third party by code, name, IBAN...',
            },
            modal: {
              title: 'Select third parties',
              buttons: {
                add: 'Validate',
                close: 'Cancel',
              },
              columns: {
                group: 'Group',
                type: 'Type',
                code: 'Code',
                name: 'Name',
                account: 'Account No.',
                thirdparty: 'Third parties',
                rum: 'UMR',
                reference: 'Reference',
                analysis_note: 'Third-Party Analysis Note',
                bic: 'BIC',
                code_pays: 'Country Code',
                code_pays_tiers: 'Third-Party Country Code',
              },
            },
          },
        },
        Analyse: {
          search: {
            state: '- State -',
            scope: '- Scope - ',
            company: '- Company -',
            bank: '- Bank -',
            pays: '- Country -',
            devise: '- Currency -',
            flux: '- Flow - ',
            category: '- Category - ',
          },
          graph: {
            societe: 'Distribution of flows by company',
            banque: 'Distribution of flows by bank',
            type: 'Distribution of flows by type',
          },
          table: {
            title: 'Flow Analysis',
          },
          onglet: {
            graphe: 'Flow graph',
            analyse: 'Flow analysis',
          },
        },
        send: 'Send',
        ModalSendMessage: {
          title: 'Send email',
          template_email: 'Email template',
          email: 'email',
        },
        EditRemiseMultiple: 'Edit discount execution date',
      },
      statement: {
        RelevesCompte: {
          tab: {
            graphTitle: 'Statements Graph',
            releverTitle: 'Statements Analysis',
          },
          header: {
            title: 'List of bank accounts',
            buttons: {
              export: 'Export',
              import: 'Import',
              releve_inco: 'Unknown Statement',
            },
          },
          filters: {
            state: '-State-',
            scope: '-Scope-',
            companies: '-Company-',
            bank: '-Bank-',
            country: '-Country-',
            devise: '-Currency-',
            format: '-Format-',
            services: '<Selection of service for integration via job>',
          },
          searchInput: {
            caption:
              'Search for an account by code, name, account number, company code, company name...',
          },
          modal: {
            titles: {
              import: 'Import account statement manually',
              export: 'Export account statement',
            },
            buttons: {
              export: 'Export',
              drag_file: 'Add or drop files here',
              drag_one_file: 'Add or drop a file here',
              send: 'Send',
            },
            champ_titles: {
              job: 'Integration by Job',
            },
          },
          columns: {
            state: 'Status',
            code: 'Code',
            name: 'Name',
            iban: 'IBAN',
            company: 'Company',
            bank: 'Bank',
            solde: 'Balance',
            devise: 'Currency',
            date: 'Balance date',
            operation_number: 'No. of movements',
            intraday_number: 'No. Intraday',
            alternative_account: 'Alternative account',
            solde_consolide: 'Consolidated currency balance',
            devise_consolide: 'Consolidation currency',
            pays_compte: 'Bank country',
            pays_soc: 'Company country',
            domiciliation: 'Bank address',
          },
          search_advanced_releve: {
            category_search: 'Category',
            label_search: 'Search for a label',
          },
        },
        DetailRelevesCompte: {
          header: {
            title: 'View account statement {{code}} - {{iban}}',
            print: 'Print',
            relever_electro: 'Electronic statements',
            generation: 'Generation Entries',
            calendar: 'Last business day',
            search: 'Search ...',
          },
          filters: {
            state: '-State-',
            scope: '-Scope-',
            companies: '-Company-',
            bank: '-Bank-',
            country: '-Country-',
            devise: '-Currency-',
          },
          searchInput: {
            caption:
              'Search for an account by code, name, account number, company code, company name...',
          },
          columns: {
            label: 'Text',
            complementary_label: 'Additional text',
            reference: 'Reference',
            tiers: 'Third parties',
            document_number: 'Supporting Document No.',
            category: 'Category',
            transaction_code: 'Code',
            devise: 'Currency',
            operation_date: 'Transaction date',
            value_date: 'Value date',
            debit: 'Debit',
            credit: 'Credit',
            currency: 'Currency',
            payer_name: "Payer's name",
            beneficiary_name: "Beneficiary's name",
            exempted: 'Exempt',
          },
          columns_electro_relever: {
            title: 'List of electronic statements',
            num_doc: 'Document No.',
            date: 'Start date',
            date_fin: 'End date',
            date_add: 'Date added',
          },
          modal: {
            title: 'Transaction details',
          },
        },
        FraisBancaire: {
          table: {
            title: 'Bank charges',
            bankList_placeholder: '- Bank -',
            search: 'Search',
            society_List_placeholder: '- Company -',
            group_compte_list: '- Account Group -',
          },
          columns: {
            frais: 'Text',
            nb_op: 'No. of transactions',
            verif: 'Pricing',
            balance: 'Base/Sum',
            currency: 'Currency',
            amount: 'Fees',
            total: 'Total',
          },
          columns_detail_assiette: {
            code_compte: 'Account code',
            date_opération: 'Operation date',
            label_complet: 'Full label',
            code_category: 'Category code',
            code_opération: 'Operation code',
            code_nature_present: 'Nature code',
            montant: 'Amount',
            devise: 'Currency',
            date_operation: 'Operation date',
          },
        },
        analyse: {
          title: 'Treasury Bank Balances Deposits',
          entity: 'Company',
          benefBank: 'Bank',
          location: 'Country',
          currency: 'Currency',
          consolidation: 'Consolidation',
        },
        agios: {
          column: {
            state: 'State',
            code: 'Code',
            name: 'Name',
            banque: 'BanK',
            company: 'Company',
            iban: 'IBAN',
            devise: 'Currency',
            taux_debit: 'Debit rate',
            taux_credit: 'Credit rate',
          },
          drawer: {
            titleDrawer: 'Overdraft fees calculation result',
            titleCalcul: 'Calculate overdraft fees',
            compte: 'Accounts',
            periode: 'Period',
            titleResult: 'Result',
            assiete: 'Debtor base',
            int: 'Debtor interest',
            assiCredit: 'Creditor base',
            intCredit: 'Creditor interest',
            titleDetail: 'Calculation details',
            accountNbr: 'Accounts Nb :',
            imp: 'Print',
            column: {
              date: 'Date',
              nbJ: 'Nb days',
              position: 'Position',
              tauxDeb: 'Debtor rate',
              int_deb: 'Debtor interest',
              tauxCred: 'Creditor rate',
              intCredit: 'Creditor interest',
            },
          },
          calcul: 'Launch calculation',
          title: 'Calculate overdraft fees',
        },
        anaysePlacement: {
          titleFinanciers: 'Investment by financial institution',
          titleTYpe: 'Distribution by type',
          societe: 'Investments by company',
          addPlacement: 'Add statements',
          title: 'Investment analysis',
        },
        retourFichier: {
          title: 'Return file details',
          table: {
            title: 'List of return files',
            column: {
              nId: 'ID N°',
              flux: 'Flow / Account name code',
              nomFIle: 'File name / IBAN',
              banque: 'Bank / No. of transactions',
              fileFormat: 'File format / Amount',
              receptions: 'Receipt / Remittance',
            },
          },
          fiche: {
            flux: 'Flow',
            emmetteur: 'Issuer',
            reference: 'References',
            data_r: 'Reception Date',
            date_remise: 'Remittance Date',
            nb: 'Nb',
            montantRemise: 'Remittance amount',
            table: {
              num: 'N°',
              tier: 'Third party',
              ultimateT: 'Ultimate third party',
              code: 'Codes',
              ref: 'Reference/Label',
              montant: 'Amount',
              devise: 'Currency',
            },
          },
        },
        mobileBank: {
          title: 'List of banking movements',
          titleVisu: 'List of operations',
          action: {
            misAJourTiers: 'Update Third parties',
            exported: 'Export',
            stateTraiter: "Mark as 'Processed'",
            stateNonTraiter: "Mark as 'Unprocessed'",
          },
          column: {
            state: 'State',
            majTiers: 'Update Third parties',
            export: 'Export',
            userTraitement: 'Processing user',
            date: 'Date',
            dateMandat: 'Mandate date',
            nameOrigin: 'Origin name',
            ibanOrigine: 'Origin IBAN',
            nouvNom: 'New name',
            nouvIban: 'New IBAN',
            bicOrigin: 'Origin BIC',
            nouvBic: 'New BIC',
            visualisation: 'Visualization',
            timestamp_creation: 'Creation date',
          },
          columnVisu: {
            type: 'Type',
            end_to_end_id: 'EndToEndId',
            reason: 'Reason',
            ics: 'I.C.S',
            rum: 'RUM',
          },
          modal_confirm: {
            maj_tiers: 'Do you want to update the Third parties?',
            export: 'Do you want to export the movements?',
            traite: "Do you want to mark the movements as 'Processed'?",
            no_traite: "Do you want to mark the movements as 'Unprocessed'?",
          },
        },
        alert_account: {
          table: {
            header: {
              title: 'List of account statement alerts',
              load_search: 'Launch search',
            },
            columns: {
              state: 'Status',
              account: 'Account',
              label: 'Label',
              reference: 'Reference',
              nature: 'Nature',
              category: 'Category',
              op_date: 'Operation date',
              value_date: 'Value date',
              amount: 'Amount',
              currency: 'Currency',
              type: 'Type',
              entry_number: 'Entry number',
              nature_code: 'Nature code',
              integration_date: 'Integration date',
              ics: 'ICS',
              rum: 'RUM',
              transaction_code: 'Transaction code',
              rule_code: 'Rule code',
              company: 'Company',
              exempted: 'Exempt',
              debit: 'Debit',
              credit: 'Credit',
            },
          },
        },
        unknowAccount: {
          header: {
            title: 'List of Unknown Statements',
          },
          columns: {
            state: 'Status',
            unknow_account: 'Unknown Account',
            solde: 'Balance',
            devise: 'Currency',
            date_solde: 'Balance Date',
            nb_mvt: 'Nb Movements',
          },
          label: {
            delete: 'Delete Temporary Movements',
            black_liste: "Ignore This Account's Statement",
            search: 'Search Bank Accounts',
            unknow: 'Remove From Blacklist',
            delete_account: 'Do you want to delete the temporary movements',
            search_id: 'Do you want to search for bank accounts',
            add_blackList: "Do you want to ignore this account's statement",
            add_unknow: 'Do you want to remove from the blacklist',
          },
        },
      },
      referentiel: {
        Comptes: {
          fiche: {
            titles: {
              edit_title: 'Account {{code}} - {{iban}} sheet',
              new_title: 'Create a new account',
              view_title: 'Account sheet',
              bank_infos: 'Bank details',
              settings: 'Configuration',
              plus_infos: 'Additional information',
              accounting_zone: 'Cost-element fields',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              create: 'Create',
              history: 'History',
              close: 'Close',
            },
            tabs: {
              flow: 'Flow',
              check: 'Cheque',
              account: 'Accounting',
              contacts_agence: 'Agency contacts',
            },
            champ_titles: {
              company: 'Company',
              code: 'Code',
              state: 'Status',
              name: 'Name',
              country: 'Country',
              account_num: 'Account No.',
              bic: 'BIC',
              bank: 'Bank',
              devise: 'Currency',
              domiciliation: 'Bank address',
              emetteur: 'Authorise issuer account',
              tiers: 'Authorise third-party account',
              custom: {
                custom_1: 'Custom1',
                custom_2: 'Custom2',
                custom_3: 'Custom3',
                custom_4: 'Custom4',
                custom_5: 'Custom5',
              },
              balance_continuity_check: 'Balance date continuity',
              alternative_account: 'Alternative account No.',
              sender_code: 'Issuer No.',
              sender_code_vcom: 'VCOM Issuer No.',
              fileformat: 'FileFormat account statement',
              number_next: 'Next cheque No.',
              number_end: 'Last cheque No.',
              cmc7_1: 'CMC7 Line 1',
              cmc7_2: 'CMC7 Line 2',
              account_info: 'Account information',
              accounting: 'Account',
              journal: 'Log Code',
              auxiliary: 'Subsidiary Account',
              customize1: 'Custom1',
              customize2: 'Custom2',
              customize3: 'Custom3',
              customize4: 'Custom4',
              customize5: 'Custom5',
              customize6: 'Custom6',
              customize7: 'Custom7',
              customize8: 'Custom8',
              customize9: 'Custom9',
              customize10: 'Custom10',
              default_placeholder: '<Default main agency contact>',
              contact_agence: 'Agency Contact',
              contactFlux: 'Flow Contact',
              contactPouvoir: 'Authority Contact',
              zone_payable: 'Payable zone of the check',
              autorise_operation: 'Foreign Exchange Operation Authorized',
            },
          },
          table: {
            header: {
              title: 'List of accounts',
              new_account: 'New',
            },
            filters: {
              state: '-State-',
            },
            searchInput: {
              caption: 'Search for an account by code, name or company',
            },
            buttons: {
              rib_print: 'Print  bank account details',
            },
            columns: {
              state: 'Status',
              code: 'Code',
              name: 'Name',
              bank: 'Bank',
              iban: 'IBAN',
              company: 'Company',
              devise: 'Currency',
              date: 'Modification date',
              pays: 'Bank Country',
            },
          },
        },
        Echéancier: {
          fiche: {
            title: {
              edit_title: 'Format {{code}} sheet',
              view_title: 'Payment schedule sheet',
              new_title: 'Create a new payment schedule',
              date_manage: 'Manage Date',
              mandate: 'Mandate',
              flow_custom: 'Custom flow fields',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              create: 'Create',
            },
            champ_titles: {
              mandate: 'Mandate',
              flow: 'Flow',
              value_date: 'Value date',
            },
          },
          table: {
            header: {
              title: 'List of payment schedules',
              new_timeline: 'New',
            },
            columns: {
              state: 'Status',
              company_rum: 'Company/URM',
              code_tiers: 'Debtor third-party',
              nom_tiers: 'Debtor third-party name',
              amount: 'Amount',
              reason: 'Reason',
              expiry_date: '1st maturity',
              next_expiry_date: 'Next maturity',
              last_expiry_date: 'Last maturity',
              periodicity: 'Frequency',
              flow: 'Flow',
            },
          },
        },
        GroupesTiers: {
          fiche: {
            title: {
              edit_title: 'Group sheet',
              view_title: 'Group {{code}} sheet ',
              new_title: 'Create a new group',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              create: 'Create',
            },
            champ_titles: {
              name: 'Name',
              code: 'Code',
            },
          },
          table: {
            header: {
              title: 'List of third-party groups',
              new_thirdpartygroup: 'New',
            },
            columns: {
              code: 'Code',
              name: 'Name',
              date: 'Modification date',
            },
          },
        },
        Mandats: {
          fiche: {
            title: {
              edit_title: 'Mandate {{variable}} sheet',
              view_title: 'Mandate {{variable}} sheet',
              new_title: 'Create a new mandate',
              contact: 'Contact',
              amendments: 'Amendments',
              doc: 'Documents',
              history: 'History',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              new: 'New',
              create: 'Create',
            },
            modal: {
              title: {
                doc: 'Document',
              },
              buttons: {
                join: 'Attach',
                cancel: 'Cancel',
              },
              champ_titles: {
                doc_type: 'Type of document',
                doc_name: 'Document name',
                state: 'Status',
                start_date: 'Start date',
                end_date: 'End date',
                pdf_doc: 'PDF document',
                type: 'Type',
              },
              pdf_file_message: 'Please select a PDF supporting file',
              doc_type: 'You must specify the document type.',
              doc_name: 'You must specify the document name.',
            },
            columns: {
              status: 'Status',
              state: 'Status',
              withdrawal_date: 'Withdrawal date',
              unpaid_date: 'Outstanding debt date',
              reason: 'Reason',
              representation: 'Representation',
              amount: 'Amount',
              reference: 'Reference',
              start_date: 'Start Date',
              end_date: 'End Date',
              date: 'Date',
              doc_name: 'Document Name',
              doc_type: 'Document Type',
              visualisation: 'View',
            },
            champ_titles: {
              company: 'Company',
              internal_code: 'Internal code',
              descrip: 'Contract description',
              interne: 'Internal reference',
              state: 'Status',
              rum: 'Unique Mandate Reference (UMR)',
              payment: 'Payment',
              NumContrat: 'Contract No.',
              email: 'Email',
              fax: 'Fax',
              name: 'Name',
              first_name: 'First name',
              payment_type: 'Type of payment',
              mandate_type: 'Mandate type',
              sequence_type: 'Sequence type',
              creation_date: 'Creation date',
              closing_date: 'Closing date',
              signature_date: 'Signature date',
              third_party_code: 'Debtor third-party code',
              third_party_name: 'Debtor third-party name',
              prev_rum: 'Former UMR',
              updated_state: 'Mandate State changed',
            },
          },
          table: {
            header: {
              title: 'List of mandates',
              new_mandat: 'New',
            },
            columns: {
              state: 'Status',
              company_rum: 'Company/URM',
              type: 'Type',
              sequence: 'Sequence',
              signing: 'Signature',
              code_tiers: 'Debtor third-party',
              nom_tiers: 'Debtor third-party name',
              code: 'Code',
            },
          },
        },
        Scopes: {
          fiche: {
            title: {
              edit_title: 'Scope {{name}} sheet',
              view_title: 'Scope {{name}} sheet',
              new_title: 'Create a new scope',
              user_member_list: 'List of member users',
              companies_member_list: 'List of member companies',
              accounts_member_list: 'List of member accounts',
              tiersGrp_member_list: 'List of groups of third-party members',
              list_flux: 'List of Flows',
            },
            modal: {
              user_list: 'Select users',
              company_list: 'Select companies',
              account_list: 'Select accounts',
              third_party_group_list: 'Select third-party group',
              flux_list: 'Flow Selection',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              create: 'Create',
              add: 'Add',
              close: 'Cancel',
              history: 'History',
            },
            champ_titles: {
              code: 'Code',
              name: 'Name',
              first_name: 'First name',
              state: 'Status',
              new: 'New',
              iban: 'IBAN',
            },
          },
          table: {
            header: {
              title: 'List of scopes',
              new_scope: 'New',
            },
            columns: {
              state: 'Status',
              code: 'Code',
              name: 'Name',
              date: 'Modification date',
              flux: 'Flow',
              devise: 'Currency',
            },
          },
        },
        Societes: {
          fiche: {
            title: {
              edit_title: 'Company sheet',
              new_title: 'Create a new company',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              create: 'Create',
              history: 'History',
            },
            champ_titles: {
              title_adress: 'Company address',
              title_infos_complet: 'Complementary informations',
              button_charge_adress_structure: 'Charge structured address',
              title_adress_structure: 'Company structured address',
              name: 'Name',
              code: 'Code',
              fax_num: 'Fax No.',
              tel_num: 'Phone No.',
              legal_infos: 'Legal information',
              state: 'Status',
              adresse: 'Address',
              country: 'Country',
              cloture_date: 'Closing date',
              logo: 'Logo',
              date: 'Modification date',
              capital: 'Capital',
              capital_currency: 'Capital currency',
              title_list_mandant: 'List of principals',
              ordre: 'Order',
              type_mandat: 'Type of mandate link',
              mandat_name: 'Mandate name',
              fonction: 'Function',
              date_start: 'Start date',
              date_end: 'End date',
              long_name: 'Long name',
              tva: 'VAT No.',
              form_legacy: 'Legal Form',
            },
            columns: {
              state: 'Status',
            },
            modal_mandant: {
              title: 'Principal profile',
              ordre: 'Order',
              type_mandat: 'Type of mandate link',
              mandat_name: 'Mandate',
              nomination: 'Nomination',
              comment: 'Comment',
              date_start: 'Start date',
              date_end: 'End date',
              type_mandant: 'Mandate type',
              function: 'Function',
              modal_add_user: {
                title: 'Select a user',
                state: 'State',
                login: 'Login',
                name: 'Name',
                last_name: 'First name',
              },
              modal_add_society: {
                title: 'Select a company',
                state: 'State',
                name: 'Name',
                code: 'Code',
                society: 'Company',
              },
            },
          },
          table: {
            header: {
              title: 'List of companies',
              new_company: 'New',
            },
            columns: {
              state: 'Status',
              code: 'Code',
              name: 'Name',
              date: 'Modification date',
              ics: 'ICS',
              country: 'Country',
            },
          },
          drawer: {
            title: 'Management',
            gestion_fx: 'FX Management',
            companyb2b: 'B2B Company',
            holdingb2b: 'B2B Holding',
          },
        },
        Tiers: {
          fiche: {
            title: {
              title_adress: 'Bank address',
              title_adress_structure_banque: 'Bank structured address',
              title_adress_tiers: 'Third party address',
              title_adress_structure_tiers: 'Third party strucured address',
              title_adress_bank_intermediaire: 'Intermediary bank address',
              title_adress_structure_bank_intermediare:
                'Intermediary bank structured address',
              edit_title: 'Third-party sheet',
              view_title: 'Third-party {{lastname}} sheet',
              new_title: 'Create a new third party',
              bank_infos: 'Bank details',
              third_address: "Third party's address",
              intermediate_bank: 'Intermediary bank',
              text_lecture_seule: 'Read only - 4-Eyes change waiting',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              create: 'Create',
              checkAccount: 'Check account',
              checkBic: 'Check BIC',
            },
            champ_titles: {
              grp: 'Group',
              state: 'Status',
              type: 'Type',
              code: 'Code',
              name: 'Name',
              siret: 'Company registration number',
              tva: 'VAT',
              country: 'Country',
              account_num: 'Account No',
              devise: 'Currency',
              clearing: 'Clearing',
              clearing_id: 'Clearing code / Bank code',
              domiciliation: 'Bank address',
              adresse: 'Address',
              country_code: 'Country Code',
              prenom: 'First name',
              birth_date: 'Birth date',
              country_birth: 'Country of birth',
              city_birth: 'City of birth',
              mail: 'Email',
              tiersType: 'Third party payment type',
            },
            list_operation: {
              title: 'List of transactions',
              button_title: 'Transactions',
              montant: 'Amount',
              currency: 'Currency',
              date: 'Transaction date',
              label: 'Text',
              lot_number: 'Batch N°',
              remittance_number: 'Remittance N°',
              flow: 'Flow',
              onglet_operation: 'Transaction',
              onglet_mandat: 'Mandate',
              onglet_timeline: 'Timeline',
              onglet_analyse: 'Analysis',
              button_contre_appel: 'Callback',
              title_commentaire_panel: 'Comment',
              confirm_message:
                'Do you confirm you have performed the callback for this Third Party?',
            },
          },
          table: {
            header: {
              title: 'List of third parties',
              new_third: 'New',
            },
            columns: {
              state: 'Status',
              type: 'Type',
              code: 'Code',
              name: 'Name',
              account_num: 'Account No.',
              devise: 'Currency',
              grp: 'Group',
              country: 'Country',
              date: 'Modification date',
              control: 'Control',
              thirdparty_country_code: 'Third party country',
              siret: 'SIRET',
              tva: 'VAT',
              type_payement: 'Payment type',
            },
          },
        },
        validation4Yeux: {
          title: 'Select 4-Eyes validators',
          alert: 'Please select a 4-Eyes validator',
          columns: {
            login: 'Login',
            last_name: 'Name',
            first_name: 'First name',
          },
        },
        Bank: {
          invalidIBAN:
            'IBAN is invalid. Format: {{default_form}}, Example: {{example}}',
          invalidBIC: 'Field must be 8 or 11 characters long',
          invalidBBAN:
            'Invalid BBAN. Format: {{default_form}}, Example: {{example}}',
          invalidIBAN_simple: 'IBAN is invalid',
          invalidBBAN_simple: 'Invalid BBAN',
          bbanInfos: ' Format: {{default_form}}, Example: {{example}}',
        },
      },
      settings: {
        filialeusers: {
          modal: {
            title: 'Select a user',
          },
          fiche: {
            title: {
              edit_title: 'User {{name}}  sheet',
              new_title: 'Create a new user',
              view_title:
                'User profile {{name}}sheet (Read only - 4-Eyes Change waiting)',
              group_users: 'Member of',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              history: 'History',
              reinitialise: 'Reset TOTP',
              reinitialise_pwd: 'Reset Password',
              message_confirm_pwd: 'Do you want to reset the password',
            },
            placeholder: 'Select a user',
            login: 'Login',
            email: 'Email',
            name: 'Name',
            prenom: 'First name',
            langue: 'Language',
            smart: 'Smart-tags',
            nPhone: 'Phone',
            nFax: 'Fax',
            nMobile: 'Mobile phone',
          },
          table: {
            header: {
              title: 'List of users',
              new_user: 'New',
              list_pouvoir: 'User Authorization List',
              detail_pouvoir: 'Detailed Authorization List',
              title_button: 'Print Authorization Summary',
            },
            columns: {
              user_entity_state: 'User entity status',
              user_state: 'Status',
              login: 'Login',
              name: 'Name',
              prenom: 'First name',
              email: 'Email',
              nMobile: 'Mobile phone No.',
              date: 'Modification date',
            },
          },
        },
        groupusers: {
          fiche: {
            title: {
              edit_title: 'User profile {{name}} sheet',
              new_title: 'Create a user profile',
              view_title:
                'User profile sheet {{name}} (Read only - 4-Eyes Change waiting)',
              members: 'Members',
              authorizations: 'Authorizations',
              flow: 'Flow',
              accounting: 'Accounting',
              accounting_export: 'Accounting export',
              setting: 'Configuration',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              history: 'History',
              create: 'Create',
            },
            champ_titles: {
              code: 'Code',
              state: 'Status',
              name: 'Name',
              users: 'Users',
              users_grp: 'User profiles',
              smart_tag: 'SmartTags',
            },
            columns: {
              login: 'Login',
              name: 'Name',
              first_name: 'First name',
              state: 'Status',
              flow: 'Flow',
              readings: 'Statements',
              repository: 'Repository',
              settings: 'Configuration',
              treatments: 'Processing',
              accounting: 'Accounting',
              accounting_export: 'Accounting export',
              rates_and_currencies: 'Interest rates and Currencies',
            },
          },
          modal: {
            title: 'Select a user',
            buttons: {
              add: 'Add',
              close: 'Cancel',
            },
          },
          table: {
            header: {
              title: 'List of user profiles',
              new_groupuser: 'New',
              synthesis: 'Summary of user profiles',
              export_droit: 'Excel Export of Rights',
            },
            columns: {
              state: 'Status',
              code: 'Code',
              name: 'Name',
              date: 'Modification date',
            },
          },
        },
        SmartTags: {
          fiche: {
            title: {
              edit_title: 'Smart Tag Sheet {{code}}',
              create: 'Create a new Smart Tag',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              archive: 'Store',
            },
            champ_titles: {
              users: 'Users',
              users_grp: 'User profiles',
            },
          },
          table: {
            header: {
              title: 'List of SmartTags',
            },
            columns: {
              code: 'Code',
            },
          },
        },
        FourYeux: {
          fiche: {
            title: {
              default: 'Request validated',
              creation: 'Creation request',
              modification: 'Change request',
              suppression: 'Deletion request',
              revoke: 'Cancel request',
            },
            buttons: {
              back: 'Back',
              save: 'Validate request',
              refuse: 'Deny request',
              create: 'Create',
              revoke: 'Cancel request',
              alert: 'Please view the RIB document before validating.',
            },
            champ_titles: {
              initiale: 'Initial sheet',
              demande: 'Change request',
            },
          },
          table: {
            header: {
              title: '4-Eyes validation',
            },
            columns: {
              code: 'Code',
              state: 'Status',
              libelle: 'Text',
              date: 'Modification date',
              demand_number: '#',
              demand_type: 'Type of request',
              short_name: 'Name (long)',
              denomination: 'Name',
              demandeur: 'Requestor',
              demand_date: 'Request date',
              validator: 'Validator',
              validation_date: 'Validation / Denial',
            },
          },
        },
        pouvoirSignature: {
          table: {
            header: {
              title: 'List of powers of attorney',
              synthese: 'Summary of powers of attorney',
            },
          },
          fiche: {
            title_form: 'Power of attorney sheet',
            title_create: 'Create a new power of attorney',
            code: 'Code',
            code_placeholder: 'Power of attorney code',
            name: 'Name',
            name_placeholder: 'Power of attorney name',
            type: 'Type',
            etat: 'Status',
            flux: 'Flow',
            devise: 'Currency',
            titleTab1: 'College of signatories',
            titleTab2: 'List of member companies',
            titleTab3: 'List of member accounts',
            signatoryType: 'Signatory type',
            table_colleg_signature: {
              coll1: 'College 1',
              coll2: 'College 2',
              niveau: 'Level',
              type: 'Threshold type',
              seuil: 'Lower threshold',
              seuil_sup: 'Upper threshold',
              ordre: 'Order',
              pouvoir_descr: 'Description',
            },
            table_societe_member: {
              code: 'Code',
              name: 'Name',
              state: 'Status',
            },
            table_compte_member: {
              code: 'Code',
              name: 'Name',
              iban: 'IBAN',
              state: 'Status',
            },
            modalSignature: {
              title: 'Add colleges of signatories',
              add: 'Add',
              cancel: 'Cancel',
              niv_signature: 'Signature level',
              college_1: 'College 1',
              college_2: 'College 2',
              college: 'College {{nb}}',
              ordre: 'Order',
              type_seuil: 'Threshold type',
              seuil_inf: 'Lower threshold',
              seuil_supp: 'Upper threshold',
              error_colleg1: 'Please choose a college 1',
              error_threshold: 'Incorrect threshold value(s)',
              pouvoir_descr: 'Power descriptions',
            },
            modal_company_member: {
              title: 'Select companies',
            },
            modal_compte_member: {
              title: 'Select bank accounts',
            },
            buttons: {
              back: 'Cancel',
            },
          },
        },
        college: {
          table: {
            header: {
              title: 'List of signatory colleges',
              synthese: 'Summary of signatory colleges',
            },
            columns: {
              state: 'Status',
              code: 'Code',
              name: 'Name',
              electronic_signature: 'Electronic signature',
              date: 'Modification date',
            },
          },
          fiche: {
            title: {
              edit_title: 'College {{code}} sheet',
              new_title: 'Create a new signatory college',
              signatories: 'Signatories',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              history: 'History',
            },
            champ_titles: {
              code: 'Code',
              name: 'Name',
              state: 'Status',
              signature: 'Signature',
            },
            columns: {
              state: 'Status',
              first_name: 'First name',
              name: 'Last name',
              login: 'Login',
            },
          },
          modal: {
            title: 'Select a user',
            buttons: {
              add: 'Add',
              close: 'Cancel',
            },
          },
          history: {
            title: {
              edit_title: 'Sheet change history: {{time}}',
            },
            columns: {
              state: '4-Eyes State',
              timestamp_creation: 'Creation date',
              update_timestamp: 'Validation date',
              login_creation: 'Creation',
              login_validation: 'Validation',
            },
            buttons: {
              back: 'Cancel',
            },
          },
        },
      },
      treatment: {
        jobs: {
          message: 'Do you want to rerun the job',
          header: {
            title: 'Jobs Queue',
          },
          columns: {
            job_number: 'Job No.',
            status: 'Status',
            type: 'Type',
            priority: 'Priority',
            recursive: 'Recurring',
            date: 'Creation date',
            programmation_date: 'Scheduled for',
            start_date: 'Processing start time',
            end_date: 'Processing end time',
            error_code: 'Error code',
            server: 'Server',
            description: 'Description',
          },
          change_failed: 'Do you want to set the job to Failed',
          change_failed_placeholder: 'Set to Failed',
          relance_placeholder: 'Restart',
        },
        controle: {
          header: {
            title: 'List of control requests',
            add: 'Third-party control',
          },
          columns: {
            etat: 'Status',
            date_envoye: 'Sending date',
            type: 'Type',
            libelle: 'Text',
            login: 'Login',
            nb: 'No',
            ok: 'Ok',
            di: 'Diam.',
            nok: 'NOK',
            vis: 'View',

            nb_high_risk: 'No. High Risk',
            nb_no_verif: 'No. Not Verified',
            nb_risk: 'No. Risky',
            nb_verif: 'No. Verified',
          },
          newSSid: {
            thirdG: 'Group of third parties',
            thirdP: 'Individual third party',
            placeholder:
              'Enter the first 3 letters of the third party you are searching for',
          },
        },
        details: {
          title: 'List of control requests',
          fermer: 'Close',
          titleDrawer: 'Reason',
          columns: {
            state: 'Status',
            code: 'Code',
            name: 'Name',
            nCompte: 'Account No.',
            idEnv: 'Company Registration Number / VAT',
            typeT: 'Third-party type',
            codeP: 'Country Code',
            noteP: 'Analysis Note',
            reason: 'Reason',
            date_analyse: 'Request Date',
          },
        },
      },
      accounting: {
        writing: {
          fiche: {
            title: {
              edit_title: 'Entry {{libelle}} sheet',
              view_title: 'Entry sheet',
              new_title: 'Create a new account entry',
              caracteristic: 'Characteristics',
              accounting_caracteristic: 'Accounting Characteristics',
              reconciliation: 'Accounting reconciliation',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
            },
            champ_titles: {
              account: 'Account',
              placeholder_account: 'Select account Code ',
              libelle: 'Text',
              operation_date: 'Transaction Date',
              writing_number: 'Entry No.',
              category: 'Category',
              state: 'Status',
              amount: 'Amount',
              writing_type: 'Entry Type',
              code_sens: 'Direction Code',
            },
            placeholder: {
              amount: 'Transaction amount',
              category: 'Enter Category Code',
              writing_number: 'Entry number',
            },
          },
          table: {
            header: {
              title: 'List of entries',
              error_selected: 'Error',
              txt_error: 'The selected entries have not the same state',
              visualisation: 'Session View ',
            },
            filters: {
              state: '-State-',
              scope: '- Scope -',
              title: 'Bulk entry change',
              operationDate: 'Transaction date',
              category: '- Category -',
              title_import: 'Import entries',
              selected_file: 'Select files',
              aucun_file: 'No file selected',
            },
            columns: {
              state: 'Status',
              libelle: 'Text',
              montant: 'Amount',
              devise: 'Currency',
              categorie: 'Category',
              operation_date: 'Transaction date',
              reference: 'Entry No.',
              account: 'Account',
              company: 'Company',
              code_sens: 'Direction',
              writing_type: 'Entry type',
              modif: 'Edit',
              user: 'User',
              opening_balance: 'Opening Balance',
              ending_balance: 'Closing Balance',
              session_entries_id: 'SessionID',
            },
          },
          action: {
            title: 'Action',
            edit_masse: 'Bulk change',
            print: 'Print',
            importer: 'Import',
          },
          visu_session: {
            title: 'List of Sessions',
            columns: {
              id: 'ID',
              account: 'Account',
              date: 'Date',
              opening_balance: 'Opening Balance',
              ending_balance: 'Closing Balance',
              devise: 'Currency',
              state: 'Status',
            },
            activate: 'Set to Active',
            confirm_validation_msg:
              'Do you want to activate the journal entry session',
          },
        },
        rules: {
          fiche: {
            title: {
              edit_title: 'Rule {{code}} sheet ',
              view_title: 'Rule {{code}} sheet ',
              new_title: 'Create a new Rule',
              rapprochement_criteria: 'Reconciliation Criteria',
              operation_linked: 'List of transaction codes linked',
              members: 'List of members',
              rappro: 'Reconcile by amount',
              modal_title: 'List of companies',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              new: 'New',
              create: 'Create',
            },
            champ_titles: {
              state: 'Status',
              code: 'Code',
              name: 'Name',
              order: 'Order',
              category: 'Category',
              mode: 'Mode',
              rapprochement_by_date: 'Reconcile by date',
              rapprochement_by_label: 'Reconcile by text',
              rapprochement_by_ref: 'Reconcile by reference',
              date_difference: 'Difference Date',
              detail_flux: 'Fog flux detail',
              placeholder_detail_flux: 'Detail',
              download_model: 'Download excel template',
            },
            error_critere:
              'At least one matching criterion is required to validate this rule.',
            columns: {
              code: 'Code',
              name: 'Name',
            },
          },
          table: {
            header: {
              title: 'List of rules',
              new_rule: 'New',
            },
            columns: {
              state: 'Status',
              code: 'Code',
              name: 'Name',
              date: 'Modification date',
              automanuel: 'Auto Manual',
              order: 'Order',
            },
          },
        },
        historique: {
          title: 'Reconciliation history',
          show_details: 'View details',
          session_selection: 'Select Session',
          deraprochement: 'Unreconciliation Session',
          scope: 'Scope',
          company: 'Company',
          code: 'Enter code',
          mvt_bancaire: 'Reconciled bank movements',
          ecriture_rapprochement: 'Reconciled account entries',
          category: 'Category',
          writing_date: 'Entry Date',
          rappro_date: 'Reconc. Date',
          columns: {
            account: 'Account',
            category: 'Cat.',
            date: 'TXN Date',
            label: 'Text',
            amount: 'Amount',
          },
          modal: {
            title: {
              session_list: 'List of sessions',
            },
            buttons: {
              visualize: 'View',
            },
            columns: {
              date_num: 'Date/No.',
              user: 'User',
              mvt_number: 'No. movements',
              wrt_number: 'No. Ent.',
              nb_mvt: 'Nb Movements',
              nb_prevision: 'Nb Forecasts',
            },
          },
          detail: {
            columns: {
              account: 'Account',
              amount: 'Amount',
              label: 'Text',
              date: 'Value Date',
              op_date: 'TXN Date',
              category: 'Category',
              gap: 'Difference',
              state: 'Status',
              sel: 'Sel.',
              referency: 'Entry No.',
            },
            buttons: {
              validate: 'Unreconcile',
              save: 'Validate',
              back: 'Back',
            },
            titles: {
              general: 'Reconciliation - Details',
              movement: 'Reconciled bank movements',
              detail: 'Reconciliation',
              writing: 'Reconciled account entries',
            },
            champ_titles: {
              number: 'No.',
              movement_total: 'Movements Total',
              gap: 'Difference',
              writtingTotal: 'Entries Total',
            },
          },
          message: 'Do you want to resend the batch to the bank?',
        },
        rapprochement: {
          header: {
            title: 'Reconciliation',
            manuel: 'Manual rule',
            montant: 'Amount 1/1',
            montantNN: 'Amount N/N',
            rapprocher: 'Reconcile',
            comment: 'Comments',
            eclatement: 'Split',
            date_cloture: 'Closing date',
            title_rappro: 'Reconciliation - Details',
            total_movements: 'Movements Total',
            gap: 'Difference',
            total_entries: 'Entries total',
            number: 'No.',
            nodata: 'No data',
            message_validation:
              'Warning all accounts do not have the same closing date. The smallest date has been selected.',
          },
          modal: {
            titles: {
              burst: 'Split entry',
              comment: 'Movement comments',
            },
            comment: 'Comment',
            new: 'New',
            total: 'Entry Total',
            rest: 'Remaining to be split',
          },
          cards: {
            closed_banking_infos: 'Bank movements to be reconciled',
            closed_writing: 'Entries to be reconciled',
          },
          columns: {
            title: {
              account: 'Account',
              cat: 'Cat',
              currency: 'Cur.',
              account_id: 'TXN Code',
              op_date: 'TXN Date',
              label: 'Text',
              date: 'Date',
              hour: 'Time',
              comment: 'Comment',
              referency: 'Entry No.',
              login: 'Login',
              amount: 'Amount',
              ref: 'Reference',
              direction: 'Direction',
              reconcil_number: 'Supporting Document No.',
              com: 'Com.',
              company: '- Company -',
              account_code: '- Account Code -',
              category: '- Category -',
              entry_type: 'Entry type',
              creation_timestamp: 'Creation date',
              complementary_label: 'Additional label',
              group_compte: '- Account Group -',
            },
          },
          footer: {
            total_forecasts: 'Entries Total',
          },
          detail: {
            table_mvt: {
              sel: 'Sel.',
              cat: 'Category',
              op_date: 'Transaction Date',
              amount: 'Amount',
              ref: 'Reference',
              dat: 'Transaction Date',
            },
            table_rappro: {
              account: 'Account',
              diff: 'Discrepancy',
              state: 'Status',
            },
          },
        },
        consultation: {
          table: {
            header: {
              title: {
                general: 'View balancing items',
                selecte_date: 'Select date',
              },
              champ_titles: {
                scope: 'Scope',
                company: 'Company',
                start_date: 'Start Date',
                end_date: 'End Date',
              },
              select: {
                account: '- Account -',
                company: '- Company -',
                scope: '- Scope -',
              },
            },
            buttons: {
              init: 'Initialise',
              close: 'Close',
              add: 'validate',
              print: 'Print',
              print1: 'Unreconciled bank movements',
              print2: 'Unreconciled entries',
              print3: 'Entries period',
            },
            columns: {
              history: {
                bank_balance: 'Bank balance',
                movement_number: 'No. mvts',
                amount: 'Unreconciled movements total',
                number_writing: 'No. entries',
                sum_amount: 'Unreconciled entries total',
                accounting_balance: 'Balance',
                currency: 'Currency',
                current_date: 'Outstanding Balance Date',
                imp: 'Final statement',
              },
              table: {
                account_code: 'Code',
                name: 'Name',
                society_code: 'Company',
                balance_date: 'Closing Date',
                book_balance: 'Closing Balance',
                valid_closing_date: 'Last Closing Date validated',
                valid_closing_balance: 'Last Closing Balance validated',
              },
            },
          },
          detail: {
            title: {
              init: 'Initialisation of the balancing item',
              info: 'Select closing information',
              mouvement: 'Select unreconciled movements',
              writing: 'Create unreconciled accounting entries',
              sub_info: 'Please select unreconciled banking movements',
              sub_info_writing: 'Please create unreconciled accounting entries',
              bank_balance: 'Bank balance on {{date}}',
              accounting_balance: 'Balancing item on {{date}}',
              validation: 'Validation of accounting initialisation',
              element_selected:
                'Selected unmatched bank movements: ( {{nbr}} items ) ',
              tooltip: 'View selected items',
            },
            buttons: {
              next: 'Next',
              add: 'Add',
              save: 'Validate',
              print: 'Show',
            },
            error: {
              date: 'The transaction date should not exceed the chosen date',
            },
            columns: {
              category: 'Category',
              date: 'Transaction Date',
              label: 'Text',
              amount: 'Amount',
              operation_date: 'TXN date',
              currency: 'Currency',
              modification: 'Edit',
            },
            champ_titles: {
              balance_date: 'Balance Date',
              balance_accounting: 'Balance',
              account: 'Account code',
              total: 'Unreconciled movements total',
              number: 'No.',
              total_writing: 'Unreconciled entries total',
              operation_date: 'Transaction Date',
              label: 'Text',
              category: 'Category',
              amount: 'Amount',
              total_movement_not_reconciled: 'Unreconciled Movements Total',
              number_movement_not_reconciled: 'No. of unreconciled movements',
              total_writing_not_reconciled: 'Unreconciled Entries Total',
              number_writing_not_reconciled: 'No. of unreconciled entries',
              difference_balance: 'Entered balance difference',
            },
          },
        },
        closure: {
          select: {
            account: '- Account -',
            company: '- Company -',
            scope: '- Scope -',
          },
          table: {
            title: 'Accounting closure',
            closing: 'Close',
            state: 'Status',
            code: 'Code',
            bank_balance: 'Bank balance',
            operation_number: 'No. transactions',
            sum_operation_non_reconcil: 'Unreconciled movements total',
            entry_number: 'No. entries',
            sum_entry_non_reconcil: 'Unreconciled entries total',
            accounting_balance: 'Balancing item',
            currency: 'Currency',
            current_date: 'Outstanding balance date',
            closing_state: 'Final statement',
            modal: {
              title: 'Account closure',
              confirm_closing: 'Do you want to close this (these) account(s)?',
              next_date: 'Next closing date',
            },
          },
          error: 'The accounts selected do not have the same closing date',
          unselected_error: 'You must select one account at least',
          history: {
            bank_balance: 'Bank balance',
            movement_number: 'Number of movements',
            non_reconcil_movement: 'Total unreconciled movements',
            accounting_entries_number: 'Number of entries',
            non_reconcil_entries: 'Total unreconciled entries',
            accounting_balance: 'Accounting balance',
            currency: 'Currency',
            current_balance_date: 'Closing date',
            cancel_closing: 'Reopen closing',
            state: 'Closure state',
            confirm_closing:
              'You are about to cancel this closure and return to the previous reconciliation session. Do you want to continue?',
            last_closing: 'Last closure',
            user: 'User',
          },
          action: 'Action',
          export_excl: 'Export Details',
          imprime_detail: 'Print Details',
        },
        movement: {
          title: 'List of unmatched movements',
        },
      },
      accounting_export: {
        rules: {
          fiche: {
            title: {
              edit_title: 'Rule generation {{code}} sheet ',
              view_title: 'Rule generation sheet',
              new_title: 'Create a new rule',
              treso_criteria: 'Cash flow Criterion',
              releve_criteria: 'Statement Criterion',
              flow_criteria: 'Flow Criterion',
              filter_condition_imputation: 'Filter and post condition',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              add: 'Add',
            },
            champ_titles: {
              state: 'Status',
              code: 'Code',
              name: 'Name',
              mode: 'Generate day book',
              validation: 'Validate day book',
              type: 'Type',
              interface_generation: 'Generation interface',
              export_interface: 'Export interface',
              event: 'Event',
              category: 'Category',
              direction_type: 'Direction Type',
              direction: 'Direction',
              flow: 'Flow',
              sub_type: 'Subtype',
              all_wording: 'All texts (By default)',
              find_wording: 'Searched text',
              accounting_account: 'Acc.',
              grouping: 'Grouping',
            },
          },
          table: {
            header: {
              title: 'List of Rules',
              new_groupuser: 'New',
            },
            filters: {
              state: '-State-',
              interface_generation: '-Generation interface-',
            },
            columns: {
              title: {
                state: 'Status',
                code: 'Code',
                name: 'Name',
                date: 'Modification date',
                interface_generation: 'Generation interface',
                export_interface: 'Export interface',
                category_flux: 'Category/Flow',
                auto_manuel: 'Auto/Manual',
              },
            },
          },
        },
        brouillards: {
          table: {
            header: {
              title: 'List of day book generations',
              show: 'View',
            },
            modal: {
              title: 'List of sessions',
              buttons: {
                show: 'View',
                close: 'Cancel',
              },
            },
          },
          alert: 'Please select a rule to view',
          detail: {
            Number: 'Number',
            title: 'Generate View',
            Back: 'Back',
            fog_validate: 'Validate Day Book',
            getting_file: 'Retrieve file',
            session: 'Mass modification',
          },
          columns: {
            generation_interface: 'Interface generation',
            rule: 'Rule',
            event_type: 'Event Type',
            event_subtype: 'Event Subtype',
            category_flux: 'Category/Flow',
            company: 'Company',
            account: 'Account',
            amount_value: 'Amount',
            currency: 'Currency',
            accounting_date: 'Posting date',
            creating_date: 'Creation date',
            title_modal: 'Modify an entry',
          },
        },
        interfaces: {
          fiche: {
            title: {
              new_title: 'Create a new generation interface',
              edit_title: 'Format {{code}} generation interface sheet ',
              general: 'General',
              company: 'List of member companies',
              account: 'List of member accounts',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              add: 'Add',
              close: 'Close',
            },
            modal: {
              title: {
                info: 'List of keywords',
                company: 'Select companies',
                account: 'Select bank accounts',
              },
              information: {
                now: 'YYMMDD date format',
                year: 'Year in 2 characters followed by date',
                hour1: 'HHMMSS time format',
                hour2: 'HHMMSSCCC time format',
                bank_name: 'Bank name',
                interface_code: 'Interface code',
              },
            },
            champ_titles: {
              state: 'Status',
              code: 'Code',
              name: 'Name',
              connector: 'Connector',
              file_format: 'File format',
              naming: 'Naming',
              mode_generation: 'Generation mode',
            },
          },
          table: {
            header: {
              title: 'List of generation interfaces',
            },
            columns: {
              code: 'Code',
              name: 'Name',
              format: 'Format',
              connector: 'Connector',
              state: 'Status',
              update_timestamp: 'Modification date',
            },
          },
        },
      },
      ratecurrency: {
        currency: {
          currencyTitle: 'Currency {{name}} sheet ',
          detailsColumns: {
            cours: 'Exchange rate',
            last_update: 'Last updated',
            update_timestamp: 'Date',
          },
          header: {
            title: 'List of currencies',
          },
          columns: {
            cours: 'Exchange rate',
            name: 'Name',
            favorite: 'Favourites',
            update_timestamp: 'Last updated',
            code: 'Code',
          },
          modal: {
            message: 'Do you want to bookmark',
            message_unfav: 'You want to remove the bookmark',
          },
        },
        rates: {
          rateTitle: 'Key interest rate {{name}} sheet ',
          detailsColumns: {
            cours: 'Exchange rate',
            last_update: 'Last updated',
            update_timestamp: 'Date',
          },
          header: {
            title: 'List of key interest rates',
          },
          columns: {
            cours: 'Exchange rate',
            name: 'Name',
            favorite: 'Favorites',
            update_timestamp: 'Last update',
          },
          modal: {
            message_fav: 'Do you want to bookmark',
            message_unfav: 'You want to remove the bookmark',
          },
        },
        placeholder: {
          add_favory: 'Add to favorites',
          remove_favory: 'Remove from favorites',
        },
      },
    },
    administration: {
      communication: {
        chiffrement: {
          table: {
            title: ' Lists of encryptions',
            delete_msg: 'Do you want to delete ',
            headerTitle: {
              code: 'Code',
              encrypt_type: 'Encryption Type',
              start_date: 'Start Date',
              end_date: 'Due Date',
            },
          },
          fiche: {
            title: 'Create a new encryption',
            edit: 'Encryption {{code}} sheet',
            code: 'Code',
            error: 'Error',
            error_msg: 'Required field',
            type_chiffrement: 'Encryption Type',
            extension: 'GPG extension',
            cle_chiffrement: 'Key-ID GPG',
            pass_phrase: 'Passphrase GPG',
            placeholder_type: '- Type -',
            type_naming: 'Naming type',
          },
          widget_chiffrement: {
            title: 'GPG encryption deadlines',
            table: {
              code: 'Code',
              date_start: 'Start Date',
              date_end: 'Due Date',
              groupe: 'Group',
            },
          },
        },
        fichiers_teletransmis: {
          modal: {
            title: {
              visualisation: 'View companion file',
            },
            buttons: {
              close: 'Closed',
            },
            columns: {
              tag: 'Tag',
              value: 'Value',
            },
          },
          table: {
            header: {
              title: 'List of uploaded files',
            },
            filters: {
              search: {
                place_holder: 'Search for a file by content...',
              },
              flow: 'Flow',
            },
            columns: {
              flux: 'Flow',
              file_name: 'File name',
              banque: 'Bank',
              file_format: 'File format',
              reference: 'Reference',
              date_transmission: 'Transmission date',
              size: 'Size',
            },
          },
        },
        post_traitement: {
          table: {
            header: {
              title: 'List of post-processing',
            },
            columns: {
              code: 'Code',
              name: 'Name',
              update_timestamp: 'Modification date',
              posttraitement_action: 'Action',
            },
          },
          fiche: {
            title: {
              new_title: 'Create a new post-processing',
              edit_title: 'Post-processing {{code}} sheet ',
              ftp: 'FTP delivery',
              file_import: 'Files import',
              services: 'Services',
            },
            modal: {
              title: {
                services: 'Select services',
                info: 'List of keywords',
                member: 'Member Selection',
              },
              information: {
                now: 'YYMMDD date format',
                year: 'Year in 2 characters followed by date',
                hour1: 'HHMMSS time format',
                hour2: 'HHMMSSCCC time format',
                bank_name: 'Bank name',
                interface_code: 'Interface code',
                flux_code: 'Flow Code',
                fileformat: 'FileFormat of received file ',
                filename: 'Name of received file',
              },
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              add: 'Add',
              close: 'Close',
            },
            placeholder: {
              naming: 'Naming remote file',
              connector: 'Connector',
              import_interface: 'Import interface',
              record_size: 'Size of records (case of fixed lines)',
            },
            champ_titles: {
              code: 'Code',
              name: 'Name',
              file_format: 'FileFormat',
              retraitement: 'Adjustment',
              record_size: 'Size of records',
              connector: 'Connector',
              naming: 'Naming',
              import_interface: 'Import interface',
              filter: 'Filter',
              select: 'Selection',
              noeud: 'XML Node',
              balise: 'Flat File Record Tag',
              position: 'Account Information Position',
              longuer: 'Account Information Length',
              member: 'Members',
            },
            columns: {
              bank: 'Bank',
              flow: 'Flow',
              code: 'Code',
              name: 'Name',
              file_format: 'FileFormat',
            },
          },
        },
        fraud_monitor: {
          table: {
            title: 'List of Fraud Monitor Rules',
            columns: {
              state: 'Status',
              type: 'Type',
              code: 'Code',
              name: 'Name',
              flow: 'Flow',
              update_timestamp: 'Modification date',
            },
          },
          fiche: {
            title: {
              new_fraud_monitor: 'Create new Fraud Monitor control rule',
              edit_fraud_monitor: 'Fraud monitor {{code}} sheet',
              detail: 'Detail',
              filtre: 'Filter',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              add: 'Add',
            },
            placeholder: {
              currency: 'Currency',
              country: 'Country',
              flow: 'All flows',
              selectFiliale: 'All entities',
              selectSociete: 'All companies',
              selectBanque: 'All banks',
              selectFlux: 'All flows',
              selectPays: 'All countries',
              selectDevise: 'All currencies',
            },
            champ_titles: {
              code: 'Code',
              name: 'Name',
              flow: 'Flow',
              state: 'Status',
              rule_type: 'Type of rule',
              period: 'Current period',
              approval: 'Approvals',
              filiale: 'Entity',
              societe: 'Comapny',
              banque: 'Bank',
              pays: 'Country',
              devise: 'Currency',
              origin: 'Origin',
              inclus: 'Included',
              exclus: 'Excluded',
              tiers_name: 'Third-Party List Name',
            },
          },
        },
        connector: {
          table: {
            title: 'List of connectors',
            services: 'List of services',
            columns: {
              code: 'Code',
              state: 'Status',
              mode: 'Mode',
              name: 'Name',
              partner: 'Partner',
              bank: 'Bank',
              type: 'Type',
              update_timestamp: 'Modification date',
              planning_status: 'Schedule Status',
              recurrency: 'Recurrence',
              frequence: 'Frequency',
            },
            test_ftp: {
              test: 'Test connection',
              path: 'Path',
            },
          },
          fiche: {
            title: {
              edit: 'Connector {{code}} sheet ',
              new: 'Create a new connector',
              services: 'Services',
              ebics: 'Ebics',
              ftp: 'FTP',
              swift_net: 'SwiftNet',
              bureau: 'Service Bureau',
              user_id: 'UserID',
              certificat: 'Certificats',
            },
            buttons: {
              add: 'Add',
              validate: 'Validate',
              export: 'Export',
              import: 'Import',
              close: 'Cancel',
              generate_SSH: 'Generate SSH key pair',
              migrate: 'BTF Mapping',
            },
            champ_titles: {
              state: 'Status',
              code: 'Code',
              mode: 'Mode',
              name: 'Name',
              proxy: 'Proxy',
              protocol: 'Protocol',
              partner: 'Partner',
              bank: 'Bank',
              subsidiary: 'Subsidiary (optional)',
              host_id: 'HostID',
              partner_id: 'PartnerID',
              order_id: 'OrderID',
              url: 'URL',
              urlauth: 'Authentification URL',
              version: 'Version',
              login: 'Login',
              password: 'Password',
              host: 'Host',
              ftp_protocole: 'Protocol',
              transmit: 'Transmission ',
              reception: 'Reception',
              emergency_host: 'Backup host',
              port: 'Port',
              transfer_mode: 'Transfer mode',
              encryption: 'FTP encryption',
              component: 'FTP component',
              encryption_gpg: 'GPG encryption Transmission',
              encryption_gpg_reception: 'GPG encryption Reception',
              responder_dn: 'Responder DN',
              responder_bic: 'Responder BIC',
              requestor_dn: 'Requestor DN',
              requestor_bic: 'Requestor BIC',
              service_name: 'Service Name',
              file_info: 'FileInfo',
              ack_responder: 'Ack Responder',
              compression: 'Compression',
              delivery_notification: 'Delivery Notification',
              connector: 'Connector',
              bulk_payment_pricing: 'Bulk Payment Pricing',
              bulk_paument_plafond: 'Bulk Payment Cap',
              payload: 'Payload',
              payload_ext: 'Extension payload',
              passphrase_lau: 'Passphrase LAU',
              companion_file: 'Companion file',
              extension: 'Extension',
              authentification: 'Authentication',
              ssh_key: 'SSH key',
              api_method: 'API Method',
              api_body: 'API Parameter',
              api_username: 'Username',
              api_authorization_type: 'Authorization',
              api_header: 'Header',
              domain: 'Domain',
              grantype: 'Guarantor Authorization Type',
              url_auth: 'Authentication URL',
              ssh_type: 'SSH Key Type',
              AuthAPIType: 'Authentication Type',
              AuthAPIBody: 'Authentication Body',
            },
            columns: {
              flow: 'Flow',
              code: 'Code',
              name: 'Name',
              electronic_signature: 'Electronic signature',
              file_format: 'FileFormat',
              file_type: 'FileType',
              beginning_hour: 'Start time',
              end_time: 'End time',
              user_id: 'UserId',
              login: 'Login',
              alias: 'Alias',
              serial_number: 'Series No.',
              expiration_date: 'Exp. Date Self-signed',
              expiration_date_signature: 'Exp. Date Signature',
              ini: 'INI',
              hia: 'HIA',
              hpb: 'HPB',
            },
            placeholder: {
              encryption_none: 'No encryption',
            },
            modal: {
              title: {
                newService: 'Add service',
                editService: 'Change service',
                newUserId: 'Add UserID',
                editUserId: 'Change UserID',
                loading: 'loading...',
                import: 'Import certificates',
                gestionEbics: 'Ebics management',
                newCertificat: 'Add a Certificate',
                editCertificat: 'Edit a Certificate',
              },
              tabs: {
                general: 'General',
                planning: 'Scheduling',
                immediate_execution: 'Immediate execution',
              },
              buttons: {
                certificateBackup: 'Retrieving SConnect certificate',
              },
              champ_titles: {
                flow: 'Flow',
                code: 'Code',
                name: 'Name',
                electronic_signature: 'Electronic signature',
                file_format: 'FileFormat / Request Type',
                messaging: 'e-mail',
                file_type: 'FileType',
                FileLogicalName: 'File Logical Name',
                meaning: 'Direction',
                user_id: 'UserId',
                login: 'Login',
                certificate: 'Certificate',
                certificate_base_64: 'Base64-encoded certificate',
                password: 'Password of imported certificates',
                certificateA: 'A00 certificate',
                certificateE: 'E00 certificate',
                certificateX: 'X00 certificate',
                planning_status: 'Status of schedule',
                beginning_hour: 'Start date',
                end_time: 'End date',
                recurring: 'Recurring',
                frequency: 'Frequency (min)',
                ebics_msg_namevalue: 'Message Name Value',
                ebics_service_container: 'Service container',
                ebics_service_name: 'Service Name',
                ebics_service_option: 'Service Option',
                ebics_service_scope: 'Service Scope',
                ebics_msg_name_variant: 'Variant',
                ebics_msg_name_version: 'Version',
                ebics_format: 'Format',

                beginning_date: 'Start date',
                end_date: 'End date',
              },
              columns: {
                CERT: 'Generating self-signed certificates',
                HEV: 'Retrieving Ebics server version',
                INI: 'Sending A00 signature key',
                HIA: 'Sending encryption and authentication keys',
                Impression: 'Print Ebics initialisation letters',
                HPB: "Retrieving partner's encryption and authentication certificates",
                HCA: 'Renewal of Self-Signed Certificates',
                HCS: 'Renewal of Self-Signed Certificates and Key Certificates',
              },
              HCS: {
                next: 'Next',
                previous: 'Previous',
                step: 'Step',
                wait: 'Renewal of current certificates ...',
                nextStep:
                  'Now insert your old key and enter your password then click Next to continue.',
                step1: {
                  txt1: 'You are about to renew your self-signed certificates. You must do this three months before the certificate expiry date.',
                  txt2: 'Warning! Not all banks manage this renewal method. If this is the case, you must manually reset the certificates.',
                  txt3: 'Insert your new key and click Next to continue',
                },
              },
            },
          },
        },
      },
      interfaces: {
        imports: {
          table: {
            title: 'List of import interfaces',
            columns: {
              state: 'Status',
              code: 'Code',
              name: 'Name',
              flow: 'Flow',
              format: 'Format',
              import_type: 'Type of import',
              entity_selection: 'Select entity',
              updated_date: 'Modification date',
              type: 'Type',
            },
            title_modal_import: 'Add export interface',
            message_modal_confirm:
              'The flow already exists. Do you want to modify the items in this flow?',
          },
          fiche: {
            title: {
              edit_import: 'Import interface {{code}} sheet',
              new_import: 'Create a new import interface',
              entity_list: 'List of entities',
              general: 'General',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              add: 'Add',
              close: 'Close',
            },
            modal: {
              title: 'Select entities',
            },
            champ_titles: {
              code: 'Code',
              description: 'Description',
              type: 'Type',
              flow: 'Flow',
              import_type: 'Import type',
              state: 'Status',
              file_format: 'File format',
              encryption: 'Encryption',
              entity_selection: 'Select entity',
              no_encryption: 'No encryption',
              duplicate: 'Duplicate check',
              email_rules: 'Error emails',
            },
            columns: {
              state: 'Status',
              code: 'Code',
              name: 'Name',
            },
          },
          detail: {
            table: {
              title: 'List of interface records',
              buttons: {
                back: 'Back',
              },
              columns: {
                database_field: 'Database field',
                registration: 'Record',
                heading: 'Section',
                default_value: 'Value by default',
                method: 'Method',
                update_timestamp: 'Modification date',
              },
            },
            fiche: {
              title: {
                edit: 'Record sheet',
                new: 'Create a new record',
              },
              champ_titles: {
                database_field: 'Database field',
                heading: 'Section',
                method: 'Method',
                correspondence: 'Match',
                default_value: 'Value by default',
                order: 'Order',
              },
              buttons: {
                back: 'Cancel',
                save: 'Validate',
              },
            },
          },
        },
        exports: {
          table: {
            title: 'List of export interfaces',
            columns: {
              code: 'Code',
              name: 'Name',
              format: 'Format',
              updated_date: 'Modification date',
            },
            title_modal_import: 'Add export interface',
            message_modal_confirm:
              'The export interface already exists. Do you want to modify the items in this interface?',
          },
          fiche: {
            title: {
              edit_export: 'Export interface {{code}} sheet',
              new_export: 'Create a new export interface',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
            },
            champ_titles: {
              code: 'Code',
              description: 'Description',
              type: 'Type',
              file_format: 'File format',
              formatting: 'Format',
            },
          },
          detail: {
            table: {
              title: 'List of interface records',
              buttons: {
                back: 'Back',
              },
              columns: {
                database_field: 'Database field',
                registration: 'Record',
                heading: 'Section',
                default_value: 'Value by default',
                method: 'Method',
                comment: 'Comment',
                update_timestamp: 'Modification date',
              },
            },
            fiche: {
              title: {
                edit: 'Record sheet',
                new: 'Create a new record',
              },
              champ_titles: {
                database_field: 'Database field',
                heading: 'Section',
                method: 'Method',
                correspondence: 'Match',
                default_value: 'Value by default',
                order: 'Order',
              },
              buttons: {
                back: 'Cancel',
                save: 'Validate',
              },
            },
          },
          detailIsPdf: {
            table: {
              title: 'Create a new record',
              buttons: {
                back: 'Back',
              },
              columns: {
                champs: 'Field',
                heading: 'Section',
                database: 'Database',
                chp_dtb1: 'Field 1',
                chp_dtb2: 'Field 2',
                chp_dtb3: 'Field 3',
                chp_dtb4: 'Field 4',
                chp_dtb5: 'Field 5',
                chp_dtb6: 'Field 6',
                chp_dtb7: 'Field 7',
                chp_dtb8: 'Field 8',
                method: 'Method',
                mask: 'Mask',
                mise_en_page: 'Format overload',
                polise: 'Font',
                taille: 'Size',
                alignement: 'Alignment',
                gras: 'Bold',
                soulign: 'Underline',
              },
            },
          },
        },
        formats: {
          table: {
            title: 'List of file formats',
            columns: {
              code: 'Code',
              name: 'Name',
              type: 'Type',
              updated_date: 'Modification date',
              length: 'Rec. length',
              separator: 'Separator',
              comment: 'Comment',
            },
            buttons: {
              import: 'Import',
            },
            modal: {
              title: 'Import a format',
              champ_titles: {
                upload: 'Upload',
              },
            },
          },
          fiche: {
            title: {
              edit_format: 'Format {{code}} sheet',
              new_format: 'Create a new format',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
            },
            champ_titles: {
              code: 'Code',
              name: 'Name',
              type: 'Type',
              length: 'Rec. length',
              separator: 'Separator',
              multi: 'Multi-Cheques per page',
              offset: 'Offset',
              header: 'With header',
            },
          },
          detail: {
            table: {
              title: 'List of format records',
              buttons: {
                back: 'Back',
              },
              columns: {
                order: 'Order',
                code: 'Code',
                type: 'Type',
                update_timestamp: 'Modification date',
                length: 'Rec. length',
                separator: 'Separator',
              },
            },
            fiche: {
              title: {
                edit: 'Record {{code}} sheet ',
                new: 'Create a new record',
              },
              champ_titles: {
                code: 'Code',
                type: 'Type',
                order: 'Order',
              },
              buttons: {
                back: 'Cancel',
                save: 'Validate',
              },
            },
          },
          heading: {
            table: {
              title: 'List of fields',
              buttons: {
                back: 'Back',
              },
              columns: {
                order: 'Order',
                label: 'Text',
                type: 'Type',
                position: 'Position',
                length: 'Length',
                update_timestamp: 'Modification date',
              },
            },
            fiche: {
              title: {
                edit: 'Record sheet',
                new: 'Create a new record',
                propriety: 'Properties',
                visu_export_comptable: 'Display to view Accounting Export',
              },
              champ_titles: {
                label: 'Text',
                type: 'Type',
                order: 'Order',
                mask: 'Mask',
                separator: 'Separator',
                line_if_item: 'Line if section',
                position: 'Position {{cord}}',
                length: 'Length',
                height: 'Height',
                thickness: 'Thickness',
                visible: 'Display Visible',
                field_length: 'Display Length',
              },
              buttons: {
                back: 'Cancel',
                save: 'Validate',
              },
            },
          },
        },
        import_rule: {
          table: {
            header: {
              title: 'List of import rules',
            },
            modal: {
              remove: {
                title: 'Do you really want to delete this import rule',
              },
            },
            columns: {
              state: 'Status',
              connector: 'Connector',
              partner: 'Partner',
              import_interface: 'Import interface',
              format: 'Format',
              condition: 'Condition',
              extension: 'Extension',
              directory: 'Directory',
            },
          },
          fiche: {
            title: {
              create_import_rule: 'Creation of new import rules',
              edit_import_rule: 'Change import rules',
              conditions: 'Conditions',
            },
            champ_titles: {
              state: 'Status',
              connector: 'ERP Connector',
              import_interface: 'Import interface',
              type: 'Type',
              treatment_after_import: 'Post-import processing',
              file_name: 'File name',
              directory: 'Directory',
              extension: 'File extension',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
            },
          },
        },
        export_rule: {
          table: {
            header: {
              title: 'List of export rules',
            },
            modal: {
              remove: {
                title: 'Do you really want to delete this export rule',
              },
            },
            columns: {
              state: 'Status',
              rule_code: 'Rule Code',
              rule_name: 'Rule Name',
              method: 'Method',
              periodicity: 'Frequency',
              launch_time: 'Launch Time',
              last_launch: 'Launched for the last time',
              file_name: 'File Name',
              update_timestamp: 'Modification date',
              extension: 'Extension',
              directory: 'Directory',
            },
          },
          fiche: {
            title: {
              create_export_rule: 'Create of new Export rules',
              edit_export_rule: 'Change export rules {{code}}',
              conditions: 'Conditions',
              request_content: 'Request Content',
            },
            champ_titles: {
              state: 'Status',
              rule_code: 'Rule Code',
              rule_name: 'Rule Name',
              method: 'Method',
              periodicity: 'Frequency',
              end_point: 'End Point',
              type: 'Type',
              file_name: 'File name',
              directory: 'Directory',
              extension: 'File extension',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
            },
          },
        },
        flux: {
          table: {
            title: 'List of flows',
            headerTitle: {
              code: 'Code',
              nom: 'Name',
              type: 'Type',
              support: 'Support',
              process_signature: 'Signature process',
              confidential: 'Confidentiality',
              interface_export: 'Export interface',
              date: 'Modification date',
            },
            title_modal_confirm: 'Add flows',
            list_missing_champ: 'Missing fields: ',
          },
          fiche: {
            title: 'Create a new flow',
            code: 'Code',
            nom: 'Name',
            type: 'Type',
            support: 'Support',
            creation_title_fiche: 'Create a new flow',
            edit_tile_fiche: 'Flow sheet',
            flow_code_placeholder: 'Flow code',
            flow_nom_placeholder: 'Flow name',
            caracteristique: {
              title: 'Characteristics',
              flux_confidentiel: 'Confidential flow',
              process_signature: 'Signature process',
              interface_export: 'Export interface y default',
              methode_attribution: 'Allocation method',
              controle_mandat: 'Mandate control',
              control_date: 'Date management',
              autorisation: 'Lot split authorization',
              type_doc: 'Document type',
            },
            masque_saisie: {
              title: 'Input mask',
              coordonne_bank: 'Bank details',
              bank_intermediaire: 'Intermediary bank',
              type_dest: 'Recipient type',
              saisie_liste: 'Entry by list',
            },
            tresorerie: {
              title: 'Cash flow',
              prevision_emmet: 'Issuer Forecast',
              prevision_tiers: 'Third Party Forecast',
              type_prev: 'Forecast type',
              nature_tiers: 'Third Party Nature',
              nature_emmet: 'Issuer nature',
              categ_tiers: 'Third party category',
              categ_emmet: 'Issuer category',
              exonere: 'Cash transfer',
              title_code_cature: 'Select nature code',
              title_categorie: 'Select category',
              add: 'Add',
              annuler: 'Cancel',
            },
            pays_emmet: {
              title: 'Authorised issuing countries',
            },
            pays_dest: {
              title: 'Authorised recipient countries',
            },
            authorized_currencies: {
              title: 'Authorised currencies',
            },
            authorized_bank: {
              title: 'Authorised banks',
            },
            interface_export: {
              title: 'Specific export interfaces by bank',
              title_Modal: 'Select export interface by bank',
              add: 'Add',
              annuler: 'Cancel',
              bank: 'Bank',
              interf_exp: 'Export interface',
              headerTable: {
                code: 'Code',
                interface_export: 'Export interface',
              },
            },
            mask: {
              title_mask_remise: 'Remittances masks',
              title_mask_operation: 'Transactions masks',
              title_mask_compta: 'Accounting account masks',
              headerTable: {
                name: 'Field name',
                interface_export: 'Export interface',
                type_champ: 'Field type',
                libelle: 'Text',
                visible: 'Visible',
                obligatoire: 'Required',
                edit: 'Editable in input form',
                taille_saisie: 'Input size',
              },
              title_Modal: 'Input mask',
              add: 'Add',
              annuler: 'Cancel',
              name_champ: 'Field name',
              maskTitle: 'Mask',
            },
            modalSetting: {
              title: 'Configuration',
              seuil: 'Generation threshold',
              seuilPlaceholder:
                'Number of transactions beyond which the generation will be made when importing the file',
              mailBox: 'MailBox',
              flux_post: 'Post-generation flow',
              demate_connector: 'Demat Connector',
              demate_connector2: 'Demat Connector 2',
              accepts_operation_zero: 'Allow zero amount in entry',
              control_adress_tiers: 'Third party address control in entry',
              add_mvt: 'Add movements in CC',
              mail_box_edit_date: 'Edit date authorization',
              CheminDateModif: 'Modification Date Path',
            },
            sous_type: 'Subtype',
            methodeAttribution: 'Validator assignment method',
            typeDoc_compte: 'Account document type',
            typeDoc_societe: 'Company document type',
          },
        },
      },
      customisation: {
        listes: {
          table: {
            title: 'Drop-down list',
            columns: {
              code: 'Code',
              name: 'Name',
            },
          },
          fiche: {
            title: {
              edit_liste: 'List {{code}} sheet ',
              new_liste: 'Create a new list',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
            },
            champ_titles: {
              code: 'Code',
              name: 'Name',
            },
          },
          detail: {
            table: {
              title: 'List of drop-down list values {{list_code}}',
              buttons: {
                back: 'Back',
              },
              columns: {
                code: 'Code',
                label: 'Text',
              },
            },
            fiche: {
              title: {
                edit: 'Field {{value}} sheet',
                new: 'Create a list field',
              },
              champ_titles: {
                value: 'Value',
              },
              buttons: {
                back: 'Cancel',
                save: 'Save',
              },
            },
          },
        },
        accounting_field: {
          table: {
            title: 'List of accounting customisations',
            columns: {
              label: 'Text',
              name: 'Field name',
              visible: 'Visible',
              obligatory: 'Required',
              entered_size: 'Input size',
            },
          },
          modal: {
            remove: {
              title: 'Do you really want to delete this field',
            },
          },
          fiche: {
            title: {
              edit: 'Field sheet',
              new: 'Create a new cost-element field',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
            },
            champ_titles: {
              mask: 'Mask',
              name: 'Field name',
            },
          },
        },
        dynamic_method: {
          table: {
            title: 'List of dynamic methods',
            columns: {
              code: 'Code',
              name: 'Name',
              state: 'Status',
              update_timestamp: 'Modification date',
            },
            title_drawer: 'List of interfaces',
            import_rules: 'Import',
            export_rules: 'Export',
            picto_name: 'Link',
          },
          fiche: {
            title: {
              edit: 'Dynamic method {{code}} sheet',
              new: 'Create a new dynamic method',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
            },
            champ_titles: {
              state: 'Status',
              code: 'Code',
              name: 'Name',
              syntax: 'Syntax',
              dynamic_code: 'Dynamic code',
              keywords: 'Keywords',
            },
          },
        },
        fiche: {
          title: {
            edit_title: 'Change a new custom third party',
            view_title: 'Custom third-party sheet ',
            new_title: 'Create a new custom third party',
            cut_off: 'Cut-Off',
          },
          buttons: {
            back: 'Cancel',
            save: 'Validate',
            create: 'Validate',
            add: 'Add',
          },
          champ_titles: {
            champnom: 'Field name',
            pays: 'Country',
            masque: 'Mask',
            type_custom: 'Field type',
            custom_filtre: 'Custom Filter in Record by Value',
          },
        },
        table: {
          header: {
            title: 'List of third party customisations',
            new_custom: 'New',
          },
          columns: {
            name: 'Field name',
            libelle: 'Text',
            pays: 'Country',
            isvisible: 'Visible',
            isobligatoire: 'Required',
            taille: 'Input size',
          },
        },
        correspondance: {
          table: {
            title: 'List of lookup tables',
            columns: {
              code: 'Code',
              nom: 'Name',
            },
            title_import_correspondance: 'Add correspondences',
          },
          fiche: {
            title: {
              edit: 'Lookup table {{code}} sheet',
              new: 'Create a lookup table',
            },
            champ_titles: {
              code: 'Code',
              name: 'Name',
            },
          },
          fiche_champs: {
            title: {
              edit: 'Lookup table {{entry_val}} sheet',
              new: 'Create a lookup table detail',
            },
            champ_titles: {
              disloq_value: 'Entry value',
              out_value: 'Exit value',
              french: 'French',
              english: 'English',
            },
          },
          table_champs: {
            title: {
              edit: 'List of lookup table values {{entry_val}}',
              new: 'Create a lookup table detail',
            },
            champ_titles: {
              id: 'Id',
              entry_code: 'Entry code',
              out_code: 'Exit code',
              libelle: 'Text',
            },
          },
        },
        email_template: {
          table: {
            title: 'List of templates',
            columns: {
              name: 'Name',
              object: 'Purpose',
              type: 'Type',
              update_timestamp: 'Modification date',
            },
          },
          fiche: {
            title: {
              edit: 'Template {{code}} sheet',
              new: 'Create a notification template',
              body: 'Template body',
            },
            champ_titles: {
              model_name: 'Template name',
              model_object: 'Template purpose',
              webhook_url: 'Webhook URL',
              notification_type: 'Notification type',
              template_type: 'Template type',
            },
          },
        },
        email_rule: {
          table: {
            title: 'List of notification rules',
            columns: {
              name: 'Name',
              code: 'Code',
              flow: 'Flow',
              update_timestamp: 'Modification date',
            },
          },
          fiche: {
            title: {
              edit: 'Change of notification rules: {{code}}',
              new: 'Creation of new notification rules',
              conditions: 'Conditions',
              smartags: 'Recipients',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
            },
            champ_titles: {
              code: 'Code',
              name: 'Name',
              flow: 'Flow',
              template: 'Template',
              batch_state: 'Batch state',
              condition: 'Condition',
              value: 'Value',
              emails: 'E-mail addresses',
              smartags_users: 'Smart Tags users',
              smartags_grp_users: 'Smart Tags user group',
              smartags_grp_admins: 'Smart Tags admin group',
              email: 'Email language',
            },
          },
        },
        email_report_rule: {
          table: {
            title: 'List of scheduled reports',
            execute_imediat: 'Immediate execution',
            columns: {
              name: 'Name',
              code: 'Code',
              heure: 'Launch time',
              update_timestamp: 'Modification date',
              type: 'Type',
              mode_envoi: 'Sending mode',
            },
            titleModal: 'List of values',
            columnsMember: {
              name: 'Name',
              code: 'Code',
            },
          },
          fiche: {
            title: {
              edit: 'Scheduled report {{code}} sheet',
              new: 'Create a new scheduled report',
              conditions: 'Conditions',
              smartags: 'Recipients',
              state: 'Tasks',
              connecteur: 'Connector',
              list_valeur: 'List of values',
              titleModal_currency: 'List of currencies',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
            },
            champ_titles: {
              code: 'Code',
              name: 'Name',
              flow: 'Flow',
              template: 'Template',
              type: 'Type',
              condition: 'Condition',
              day: 'Days',
              treso: 'Treasury report',
              emails: 'Emails adresses',
              smartags_users: 'Users smart Tags',
              utilisateur: 'Users',
              smartags_grp_admins: 'Administraor groups smart tags',
              mond: 'Monday',
              tues: 'Tuesday',
              wed: 'Wednesday',
              thur: 'Thursday',
              fri: 'Friday',
              sat: 'Saturday',
              sund: 'Sunday',
              user_reference: 'Referring User (Language and Scope)',
              heure_lance: 'Launch time',
              email: 'Language of the sent emails',
              reference_user: 'Reference user',
              mode_env: 'Sending mode',
              type_export: 'Type',
              placeholder_type: '- Export type -',
              interf: 'Interface',
              date: 'Date',
              user: 'Reference User',
              last_month: 'Previous month',
            },
          },
        },
        custom_fields: {
          table: {
            title: 'List of field masks',
            columns: {
              code: 'Code',
              label: 'Text',
              liste: 'List',
              visible: 'Visible',
              obligatory: 'Required',
              entered_size: 'Input size',
            },
          },
          buttons: {
            new: 'New Batch',
            delete: 'Do you really want to delete',
          },
          fiche: {
            save: 'Validate',
            create: 'Validate',
            creation_title: 'Create a new field mask',
            edit: 'Field mask {{code}} sheet',
            forme: {
              code: 'Code',
              code_label: 'Field mask code',
              visible: 'Visible',
              size_forme: 'Input size',
              size_forme_label: 'Field input size',
              list: 'List',
              fr: 'French',
              fr_label: 'Input field caption',
              fr_label_txt: 'Hint text of language field above',
              type_champ: 'Field type',
              obligatoire: 'Required',
              edit_saisie: 'Editable in input form',
              masque: 'Input mask',
              en: 'English',
              el_placeholder: 'Input field caption',
              en_label: 'Hint text of language field above',
              fr_trad: 'French',
              en_trad: 'English',
              es_trad: 'Spanish',
            },
          },
        },
      },
      audit: {
        auditConnexion: {
          table: {
            header: {
              title: 'Connexion audit',
            },
            columns: {
              login: 'Login-API Code',
              date: 'Date',
              auth: 'Authentication',
              ipadresse: 'IP address',
              platform: 'Platform',
              os: 'OS',
              navigator: 'Browser type',
              version: 'Version',
            },
          },
        },
        auditService: {
          table: {
            header: {
              title: 'Service audit',
            },
            columns: {
              service: 'Services',
              state: 'Status',
              date: 'Date',
              libel: 'Text',
            },
          },
        },
        hashFile: {
          table: {
            header: {
              title: 'Imported files',
            },
            columns: {
              file_name: 'File name',
              value_hash: 'Hash',
              date: 'Date',
              type_file: 'File type',
              user: 'User',
              state: 'Status',
              user_update: 'Modified By',
              date_update: 'Modification Date',
            },
            confirm_to_delete:
              'Are you sure you want to delete this Hash? Warning, this action will be irreversible',
          },
        },
        histoApi: {
          table: {
            header: {
              title: 'API Call',
              modal_title: 'JSON viewer',
            },
            columns: {
              key: 'Key',
              method_name: 'Method name',
              date: 'Date',
              code_retour: 'HTTP Return code',
              label_retour: 'Return Label',
              param_appel: 'Parameters',
              body_retour: 'Return body',
              duree_appel: 'Call time',
            },
            modal: {
              balise: 'Tag',
              value: 'Value',
            },
          },
        },
        gdpr: {
          title: 'GDPR',
          journaux: 'Logs',
          search_tiers: 'Third Party Search',
          search_flux: 'Flow Search',
          title_tiers: 'Third Party',
          title_flux: 'Flow List',
          alert_title:
            'Warning! This process is irreversible. The third party and all its flows will be anonymized. Do you want to continue',
          anonym: 'Anonymization',
          placeholder: {
            search: 'Search for a third party by code, name, IBAN',
          },
          column_tiers: {
            type: 'Type',
            code: 'Code',
            name: 'Name',
            num_compte: 'Account No.',
            devise: 'Currency',
            pays: 'Country',
            date_modif: 'Modification date',
          },
          column_flux: {
            num_lot: 'Batch No.',
            num_remise: 'Remittance No.',
            flux: 'Flow',
            libele: 'Text',
            date_operation: 'Operation date',
            state: 'Status',
            beneficiary_name: 'Beneficiary',
            date_transmission: 'Transmission Date',
          },
        },
        histoFile: {
          table: {
            header: {
              title: 'Operations scheduling',
            },
            columns: {
              file_name: 'File name',
              code_compte: 'Account code',
              code_society: 'Company code',
              code_flux: 'Flow code',
              amount_total: 'Total amount',
              nb_flux: 'Number of flows',
              date_create: 'Batch creation date',
              num_lot: 'Batch No.',
              user: 'User',
              currency: 'Currency',
              placeholder_flux: '- Flow -',
              placeholder_type_flux: '- Flow type -',
              state_detail: 'Detail Status',
            },
          },
        },
        trustedThird: {
          table: {
            header: {
              title: 'Scheduling of operations',
            },
            columns: {
              currency: 'Currency',
              name: 'Name',
              iban: 'IBAN',
              uptade_date: 'Date modified',
            },
            modal_detail: {
              title: 'Trusted third party details',
              desactive_btn: 'Deactivate',
              message_confirm: 'Do you want to deactivate this third party',
              culumn: {
                average_amount: 'Average amount',
                sum_amount: 'Sum of amounts',
                total_amount: 'Total amount',
                month_year: 'Month Year',
                nb_operation: 'Number of operations',
                amount_max: 'Maximum amount',
              },
            },
          },
        },
      },
      parametrage: {
        Categories: {
          fiche: {
            title: {
              edit_title: 'Category sheet',
              view_title: 'Category {{code}} sheet',
              new_title: 'Create a new category',
              operations: 'List of transaction codes linked',
              flows: 'List of bank flows linked',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              new: 'New',
              create: 'Create',
              movement: 'Update Movements',
            },
            champ_titles: {
              code: 'Code',
              direction: 'Direction',
              libelle: 'Text',
              default_category: 'Default Category',
            },
            modal: {
              update:
                'Do you want to apply the category to the selected movements of transaction codes',
              title: 'Select transaction codes',
              flow_title: 'Select flow codes',
              filters: {
                type: 'Type',
              },
            },
          },
          table: {
            header: {
              title: 'List of categories',
              new_category: 'New',
            },
            columns: {
              code: 'Code',
              libelle: 'Text',
              date: 'Modification date',
              default_category: 'Default Category',
            },
          },
        },
        GlobalUser: {
          table: {
            error_mes: {
              text: 'The maximum number of active users has been reached.',
            },
            header: {
              title: 'List of user groups',
              synthese: 'Summary of user rights',
              new: 'New',
            },
            columns: {
              login: 'Login',
              first_name: 'First name',
              last_name: 'Last name',
              email: 'Email',
              mobile_number: 'Mobile phone No',
              date: 'Modification date',
              interrupteur: 'TOTP',
              totp: 'TOTP Type',
              is_locked: 'Locked',
            },
          },
          fiche: {
            title: {
              edit_title: 'User {{name}} sheet',
              add_title: 'Create a new user',
              message_confirm_initialise:
                'Do you want to reset the TOTP parameters of this user',
            },
            champ_titles: {
              etat: 'Status',
              email: 'Email',
              login: 'Login',
              firstname: 'First name',
              lastname: 'Last name',
              langue: 'Language',
              tel: 'Phone',
              fax: 'Fax',
              mobile: 'Mobile phone',
              recepemail: 'Reception email',
            },
            group_user: {
              title: 'Groups of users',
              name: 'Name',
              code: 'Code',
              action: 'Action',
            },
            alert: {
              pdf_file: 'Please import a PDF file',
              file_import: 'PDF file format required for import',
            },
            appareil_connected: {
              title: 'Connected devices',
              name: 'Name',
              date1: 'Creation date',
              date2: 'Last connected',
              action: 'Action',
            },
            document: {
              title: 'Documents',
              date: 'Date',
              doc_name: 'Document name',
              doc_type: 'Document type',
              state: 'Status',
              date1: 'Start date',
              date2: 'End date',
              action: 'Action',
              confirm_delete:
                'This document is linked to several messages sent to banks. Are you sure you want to delete the document',
            },
            errors: {
              phoneNumber: 'The phone number should only contain digits',
              phoneMinLen: 'The phone number must have at least 10 digits',
              phoneMaxLen: 'The phone number must have at most 15 digits',
              faxError: 'Invalid fax',
              mobilError: 'Invalid mobile',
            },
          },
        },
        GroupAdmin: {
          fiche: {
            title: {
              edit_title: 'Admin group {{name}} sheet',
              view_title: 'Admin group {{name}} sheet',
              new_title: 'Create a new admin group',
              member: 'Members',
              autorisation: 'Authorizations',
              headerTitle: 'Admin group sheet',
              createheaderTitle: 'Create a new group',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              new: 'New',
              add: 'Add',
            },
            champ_titles: {
              code: 'Code',
              name: 'Name',
              state: 'Status',
              prenom: 'First name',
              login: 'Login',
              flux: 'Flow',
              releve: 'Statements',
              referentiel: 'Repository',
              settings: 'Configuration',
              treatment: 'Processing',
              accounting: 'Accounting',
              accounting_export: 'Accounting export',
              smart_tags: 'Smart Tags',
            },
          },
          table: {
            header: {
              title: 'List of admin groups',
              new_groupadmin: 'New',
            },
            columns: {
              nom: 'Name',
              date: 'Modification date',
              state: 'Status',
              code: 'Code',
            },
          },
        },
        Label: {
          fiche: {
            title: {
              edit_title: 'Label {{label}} sheet ',
              view_title: 'Label {{label}} sheet ',
              new_title: 'Create a new label',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              create: 'Create',
            },
            champ_titles: {
              libelle: 'Custom text',
              libelle_origine: 'Original text',
              rubrique_value: 'Section value',
              sheet: 'Sheet',
              rubrique: 'Section',
              color: 'Colour',
              add_fiche: 'Add Sheet',
              add_rubrique: 'Add Section',
              add_color: 'Add Colour',
            },
            error: {
              err_message: 'Error',
              field_message: 'Required field',
            },
          },
          table: {
            header: {
              title: 'List of labels',
              new_label: 'New',
            },
            columns: {
              label: 'Label',
              date: 'Modification date',
              rubrique_value: 'Section value',
              sheet: 'Sheet',
            },
          },
        },
        Perimetre: {
          fiche: {
            title: {
              edit_title: 'Scope {{name}} sheet',
              view_title: 'Scope {{name}} sheet',
              new_title: 'Create a new scope',
              member: 'Member',
              autorisation: 'Authorizations',
              entities_list: 'List of entities',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              new: 'New',
              create: 'Create',
            },
            champ_titles: {
              code: 'Code',
              name: 'Last name',
              state: 'Status',
              prenom: 'First name',
              login: 'Login',
              flux: 'Flow',
              releve: 'Statements',
              referentiel: 'Repository',
              settings: 'Configuration',
              treatment: 'Processing',
              accounting: 'Accounting',
              accounting_export: 'Accounting export',
            },
          },
          table: {
            header: {
              title: 'List of scopes',
              new_perimetre: 'New',
            },
            columns: {
              label: 'Text',
              date: 'Modification date',
              state: 'Status',
              code: 'Code',
              first_name: 'First names',
            },
          },
        },
        Banques: {
          fiche: {
            title: {
              edit_title: 'Bank {{name}} sheet',
              view_title: 'Bank sheet',
              new_title: 'Create a new bank',
              cut_off: 'Cut-Off',
              added_cutoff_title: 'Add Cut-off',
              creation_title_banque: 'Create a new bank',
              edit_tile_banque: 'Account {{name}} sheet',
              tarif: 'Fee',
              tarif_modal: 'Select fee',
              add_tarif_title: ' Add Fee',
              category: 'Category',
              code: 'Code',
              placeholder_category: '- Category -',
              message_category: 'Category already exists',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              create: 'Create',
              add: 'Add',
            },
            champ_titles: {
              code: 'Code',
              name: 'Name',
              flux: 'Flow',
              hour: 'Time',
              exec_condition: 'Execution condition',
              mounthly_fees: 'Monthly fee',
              annual_fees: 'Yearly fee',
              month_annual_fees: 'Yearly fee month',
              movement_commission: 'Transaction fee',
              bank_fees_type: 'Bank charges type',
              type: 'Type',
            },
            columns: {
              condition: 'Execution condition',
              hour: 'Time',
              flow: 'Flow',
              code: 'Code',
              label: 'Text',
              tarif: 'Fee',
              mois: 'Month',
              currency: 'Currency',
            },
            columns_contact: {
              title: 'Contacts',
              name: 'Name',
              last_name: 'First name',
              phone: 'Phone',
              mail: 'Email',
              adress: 'Address',
              agence: 'Agency',
              flux: 'Flow',
              pouvoir: 'Authority',
              agenceName: 'Agency Name',
            },
          },
          infos_personalise: {
            title: 'Personal Informations ',
            birth_date: 'Date of birth',
            birth_country: 'Country of birth',
            birth_place: 'Place of birth',
            nationality: 'Nationality',
            num_cin: 'CIN number',
            date_validate_cin: 'CIN validation date',
          },
          table: {
            header: {
              title: 'List of banks',
              new_bank: 'New',
              el_authorized: '( Allowed items: {{nombre}} )',
              message_ele_atteint:
                'The maximum number of banks authorized has been reached',
              el_authorized_treso:
                'Number of accounts managed in cash: {{nombre}}',
              message_ele_treso:
                'The maximum number of accounts managed in cash has been reached',
            },
            columns: {
              name: 'Name',
              code: 'Code',
            },
          },
          contact: {
            title: 'Create a new contact',
            title_edit: 'Contact sheet',
            last_name: 'First Name',
            name: 'Name',
            title_civil: 'Civil status',
            mail: 'Email',
            phone: 'Phone',
            fax: 'Fax',
            mobile: 'Mobile',
            contact_agence: 'Contact agency',
            contact_Flux: 'Contact Flow',
            contact_pouvoir: 'Contact Authority ',
            title_adress: 'Address',
            type_aress: 'Address type',
            department: 'Service',
            Sub_Departement: 'Sub-departement',
            street_name: 'Street name',
            build_number: 'Street number',
            floor: 'Floor',
            post_box: 'P.O Box',
            room: 'Room',
            town_location_name: 'Place',
            post_code: 'Post code',
            town_name: 'City name',
            country: 'Country',
            districtName: ' District',
            districk_name: 'District name',
            country_Sub_Division: 'Region',
            civility: 'Civility',
            error_champ_obligatoire:
              'Please complete the mandatory fields: Last name, First name, Civility, Country, and City ',
            error_champ_ville_obligatoire: 'City name required',
            name_agence: 'Agency name',
          },
        },
        Filiales: {
          fiche: {
            title: {
              edit_title: 'Subsidiary {{code}} sheet',
              new_title: 'Create a new entity',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              create: 'Create',
            },
            champ_titles: {
              code: 'Code',
              name: 'Name',
              state: 'Status',
            },
          },
          table: {
            header: {
              title: 'List of entities',
              new_filiale: 'New',
            },
            columns: {
              code: 'Code',
              state: 'Status',
              libelle: 'Text',
              date: 'Modification date',
            },
          },
        },
        smarttag: {
          fiche: {
            title: {
              edit_title: 'Change a smart tag',
              view_title: 'Smart tag {{code}} sheet ',
              new_title: 'Smart tag sheet',
              add_title: 'Create a new smart tag',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              create: 'Create',
              add: 'Add',
            },
            champ_titles: {
              champcode: 'Code',
              color: 'Color',
            },
          },
          table: {
            header: {
              title: 'List of SmartTags',
              new_smart: 'New',
            },
            columns: {
              code: 'Code',
            },
          },
        },
        groupe_tresorerie: {
          fiche: {
            title: {
              edit_title: 'Cash group {{name}} sheet',
              view_title: 'Cash group {{name}} sheet',
              new_title: 'Create a new cash group',
              companies_member_list: 'List of member companies',
              member_list: 'Member',
            },
            modal: {
              user_list: 'Select users',
              company_list: 'Select companies',
              account_list: 'Select accounts',
              third_party_group_list: 'Select third-party group',
            },
          },
          table: {
            title: 'List of cash groups',
          },
        },
        account_statement: {
          table: {
            title: 'Manage account statements',
            etat: '- State -',
            search_txt:
              'Search for an account by code, name, account number, company code, company name...',
            headerTitle: {
              etat: 'Status',
              code: 'Code',
              name: 'Name',
              iban: 'IBAN',
              company: 'Company',
              solde: 'Balance',
              devise: 'Currency',
              date_solde: 'Balance date',
              nbMvt: 'No of movements',
            },
            confirme_update_row: 'Do you want to validate your modification',
            select_cat: 'Selection of operation codes',
            category_code: 'Category code',
          },
          details: {
            title: 'List of account days',
            reintegration: 'Reintegrate statements',
            delete_temp: 'Delete temporary statements',
            purge: 'Complete purge of account statements',
            all: 'All',
            production: 'Production',
            temp: 'Temporary',
            new_day: 'New day',
            delete_day: 'Delete day',
            headerTitle: {
              date_debut: 'Start date',
              solde_debut: 'Start balance',
              date_fin: 'End date',
              solde_fin: 'End balance',
              prod: 'Prod',
              last_releve: 'Last statement integrated',
              statements: 'No. transactions',
              currency: 'Currency',
              balance_diff: 'Balance difference',
              mvt_total: 'Sum of the day',
              update_timestamp: 'Modification date',
              create_timestamp: 'Creation date',
            },
            confirmNewday: {
              title: 'Statement sheet',
              txt: 'You can only create days either before or after statements are already produced. What do you want to create?',
              before: 'Before ',
              after: 'After',
              cancel: 'Cancel',
            },
          },
          new_day_time: {
            alert_date: 'Start date must be lower than end date',
            valider: 'Validate',
            cancel: 'Cancel',
            solde_initial: 'Start balance',
            date_initial: 'Start Date',
            solde_final: 'Final balance',
            date_final: 'End date',
            remove_day_time: 'Are you sure you want to delete',
            add_operation: 'Add a transaction line',
            purge_account:
              'Are you sure you want to purge the production account statements of this account',
            remove_temp:
              'Are you sure you want to purge the temporary account statements of this account',
            headerTitle: {
              libeller: 'Text',
              operation_date: 'Transaction Date',
              date_valeur: 'Value Date',
              operation_code: 'Transaction code',
              num_ecriture: 'No. Entry',
              exo: 'Ex',
              montant: 'Amount',
            },
            modalCode: {
              title: 'Select transaction codes',
              select: 'Select',
              cancel: 'Cancel',
              headerTitle: {
                code: 'Code',
                name: 'Name',
                sens: 'Direction',
              },
            },
          },
          modal_add_balance: {
            title: 'Balance initialization',
            date_initiale: 'Initial date',
            solde_initial_balance: 'Initial balance',
          },
        },
        document_type: {
          fiche: {
            title: {
              new_title: 'Create a new type of document',
              edit_title: 'Document type {{name}} sheet',
            },
            champ_titles: {
              name: 'Name',
              code: 'Code',
              table_type: 'Table type',
            },
            table_type: 'Table',
          },
          table: {
            title: 'List of document types',
            columns: {
              code: 'Type code',
              name: 'Type name',
              table_type: 'Table type',
            },
          },
        },
        group_widget: {
          fiche: {
            title: {
              edit_title: 'Widget group {{code}} sheet',
              view_title: 'Widget group sheet',
              new_title: 'Smart tag sheet',
              add_title: 'Create a new widget group',
            },
            champ_titles: {
              code: 'Code',
              name: 'Name',
              user: 'Select users',
            },
          },
          table: {
            header: {
              title: 'List of widget groups',
            },
          },
          table_user: {
            title: 'List of users',
            champ_titles: {
              champlogin: 'Login',
              champname: 'Name',
            },
          },
          table_widget: {
            title: 'List of widgets',
            champ_titles: {
              champcode: 'Code',
              champname: 'Name',
            },
          },
          modal_widget: {
            title: 'List of users',
            champ_titles: {
              champlogin: 'Login',
              champname: 'Name',
            },
          },
        },
        settings: {
          fiche: {
            title: {
              foureyes_title: '4-Eyes Configuration',
              foureyes_description:
                '4-Eyes module configuration (Tables, Fields, Tracking)',
              group_setting_title: 'Group configuration',
              group_description: 'Group configuration',
              mobile_setting_title: 'List of member accounts',
              mobile_description: 'Group authentication configuration',
              signature_setting_title: 'Signature configuration',
              signature_description: 'EBICS signature configuration',
            },
            champ_titles_fouryeux: {
              table_name: 'Table name',
            },
            champ_titles_group: {
              logo: 'Logo',
              session: 'Keep session alive',
              currency: 'Currency',
              code_swift: 'SWIFT code',
              ai_choice: 'AI Choice',
              number_ai_calls: 'AI call made',
              paid_ai_calls: 'Llamada AI permitida',
              title_card: 'AI Settings',
            },
            champ_titles_mobile: {
              mobile: 'Mobile phone',
              authentication_token_validity: 'Authentication token lifetime',
              signature_token_validity: 'Signature token lifetime',
              webservice_restAPI_key: 'API key Webservice REST',
              state: 'Status',
              code: 'Code',
              clientid: 'ClientID',
              modified_date: 'Modification date',
            },
            champ_titles_security: {
              itle_button_active_transaction: 'Activate Transaction',
              local_authentication: 'Local authentication',
              state: 'Status',
              sisid: 'SIS ID',
              complex: 'Complex',
              minimum_length: 'Minimal length',
              minimum_length_description: 'Password minimal length',
              validity_period: 'Lifetime',
              validity_period_description: 'Password lifetime',
              stored_number: 'Number saved',
              stored_number_description: 'Number of passwords saved ',
              test_number: 'Number of attempts (0 not blocked)',
              test_number_description:
                'Number of password attempts before getting blocked',
              linkedin_authentication: 'Linkedin authentication',
              openidconnect: 'OpenIDConnect authentication',
              identifier: 'ID provided in LinkedIn developer console',
              secret_code: 'Secret code provided in LinkedIn developer console',
              urlauth_description:
                'URL Auth provided in LinkedIn developer console',
              urltoken_description:
                'URL Token provided in LinkedIn developer console',
              urlconfig_description: 'OpenIDConnect settings URL',
              urlconfig_Allowed_Domain: 'OpenIDConnect Allowed Domain',
              Label_urlconfig_Allowed_Domain: 'Allowed Domain',
              attributupn: 'Attribute containing UPN',
              number_requested_batch: 'Number of saved passwords',
              last_date: 'Last transaction date',
              title_button_active_transaction: 'Activate Transaction',
              docusign: 'Electronic document signature',
              legisway: 'Legisway',
              trustpair: 'Trustpair',
            },
            champ_titles_signature: {
              signature_mode: 'Signature method',
            },
            modalkeysapi: {
              title: 'Add API key',
              state: 'Status',
              code: 'Code',
              clientid: 'ClientID',
              clientid_description: 'Client application ID',
              clientsecret: 'ClientSecret',
              clientsecret_description: 'Secret code provided in ADFS console',
              attribut_upn: 'UPN attribute',
              scope: 'Scope',
              third: 'Third parties',
              treasury: 'Cash flow',
              import_file: 'Import files',
              number_requested_batch: 'No. of requests per batch',
              service: 'Service',
            },
            champ_titles_iban: {
              ibanCom: 'IBAN.COM',
              state: 'State',
              email: 'Address',
              client: 'API Key',
            },
            doc_sign: {
              integration_key: 'Integration key',
              secret_key: 'Secret key',
              userId: 'User ID',
              private_key: 'Private key',
              integration_key_desc:
                'Integration key provided by the electronic signature platform',
              secret_key_desc:
                'Secret key provided by the electronic signature platform',
              userId_desc:
                'User ID provided by the electronic signature platform',
            },
            trustpair: {
              api_token: 'API Token',
              api_env: 'Environment',
              api_type: 'API Type',
            },
            common_fields: {
              initialisation_date: 'Transaction initialisation date',
              oneshot: 'One-shot execution',
              launch_job: 'Launch Transaction',
            },
          },
          table: {
            title: 'General settings',
            columns: {
              elements: 'items',
              foureyes_setup: '4-Eyes Configuration',
              group_setting: 'Group configuration',
              mobile_setting: 'Mobile phone configuration',
              security_settings: 'Security configuration',
              signature: 'Signature',
              search: 'Search for a section, text...',
            },
          },
        },
        quality: {
          title: {
            list_title: 'List of Function',
            edit_title: 'Modification of a {{code}} function',
            view_title: 'Sheet of a {{code}} function',
            new_title: 'Create a new function',
            fiche_title: 'Sheet of a function',
          },
          champ_document: {
            title: 'List of Labels',
            label: 'Label',
            langue: 'Language',
          },
          modal_add_langue: {
            title_add: 'add a Label',
            title_edit: 'Sheet of Label',
            error_English: 'Language: English already added',
            error_Fr: 'Language: French already added',
            error_Lang: 'Language already exist',
          },
        },
        power_ebam: {
          table: {
            title: 'List of power description',
            column: {},
          },
          fiche: {
            title: 'Creation of a new eBAM power',
            title_edit: 'Modification of eBAM power',
            table_ebam: {
              column: {
                title: 'eBAM codes',
                code: 'Code',
                num_code: 'eBAM code',
                description: 'Description',
                title_modal: 'Select an eBAM code',
                label_lang: 'Language',
                description_attach: 'Family Code Description',
                descri: '',
              },
            },
          },
        },
        ebam: {
          liste: 'List of eBAM code',
          fiche: {
            title: 'eBAM Code Sheet',
            type: 'Type',
            codeNum: 'Digital Code',
            code: 'Code',
            titleRegroupment: 'Regrouping',
            regroupement: 'Regrouping',
            titleLabelListe: 'List of Labels',
          },
        },
        bank_holiday: {
          title: {
            list_title: 'Holiday Dates List',
            edit_title: 'Edit Holiday Date {{code}}',
            view_title: 'Holiday Date Record {{code}}',
            new_title: 'Create New Holiday Date',
          },
          champ_titles: {
            date: 'Holiday Date',
            specific_date: 'Holiday for a Specific Year',
          },
        },
        rules_account_statement: {
          table: {
            title: 'List of statement rules',
            columns: {
              code: 'Code',
              name: 'Name',
              flow: 'Flow',
              category: 'Category',
              type: 'Type',
              update_timestamp: 'Modification date',
              state: 'Status',
            },
          },
          fiche: {
            new_title: 'Statement rule sheet',
            edit_title: ' Statement rule sheet - {{name}}',
            company_liste: 'List of companies',
            bank_title: 'List of banks',
            card: {
              state: 'Status',
              code: 'Code',
              name: 'Name',
              category: 'Category',
              type: 'Type',
              selection: 'Selection',
              comment: 'Description',
              language: 'Language',
            },
            critere: {
              title: 'Search criteria ',
              category: 'Category',
              label: 'Label',
              fourchette_amount: 'Amount range',
              min: 'Min',
              max: 'Max',
              reference: 'Reference',
              rum: 'RUM',
              inclus_ref: 'Included in the list',
              exclus_ref: 'Excluded from the list',
              yes: 'Yes',
              no: 'No',
              inclus: 'Included',
              exclus: 'Excluded',
              integrate: 'Integrate',
              columns_reference: {
                reference: 'Reference',
                description: 'Description',
                date: 'Date',
                user: 'User',
              },
              modal_reference: {
                reference: 'Reference',
                description: 'Description',
                add_ref: 'Add a Reference',
              },
              columns_rum: {
                rum: 'RUM',
                description: 'Description',
                date: 'Date',
                user: 'User',
              },
              modal_rum: {
                rum: 'RUM',
                description: 'Description',
                add_rum: 'Add RUM',
              },
            },
            ventilation: {
              title: 'Breakdown',
              categorie_ventilation: 'Breakdown category',
            },
            columns: {
              code: 'Code',
              name: 'Name',
            },
            account_groupe_title: 'List of Account Groups',
          },
        },
        custom_report: {
          fiche: {
            comment: 'Comment',
            date: 'Date',
          },
          table: {
            title: 'List of Comments',
            create_comment: 'Create Comment',
            update_comment: 'Edit Comment',
            columns: {
              comment: 'Comment',
              user: 'User',
              date: 'Date',
              update_timestamp: 'Modification Date',
            },
          },
        },
      },
    },
    treasury: {
      remuneration: {
        personnalise_rates_ref: {
          table: {
            title: 'List of personalised reference rates',
            personnalise_rates_button: 'Personalised rates',
            columns: {
              plancher: 'Floor',
              name: 'Name',
              plancher_rates: 'Interest Rate Floor',
              plafond_rates: 'Interest Rate Cap',
              plafond: 'Cap',
            },
            message_confirm:
              'The date already exists in the table, do you want to continue?',
            title_modal_rate: 'List of Rates',
            modal: {
              date: 'Update Date',
              name: 'Name',
              cours: 'Rate',
              confirmMessage:
                ' Do you want to update the rates as of {{date}}. \n All lines with a value will either be created or updated',
            },
          },
          fiche: {
            edit_title: 'Personalised reference rate{{name}} sheet',
            new_title: 'Create a new personalised reference rate',
            champ_titles: {
              debut_date: 'Start date',
              finish_date: 'End date',
              rate_type: 'Interest rate type',
              value: 'Value',
              condition: 'Fixing Condition',
              plancher_rates_floor: 'Interest rate floor - Floor',
              plafond_rates_cap: 'Interest rate cap - Cap',
              plancher_rates: 'Interest rate Floor',
              plafond_rates: 'Interest Rate Cap',
              name: 'Name',
              taux_value: 'Rate value',
            },
          },
          cours: {
            title: 'Exchange rate {{name}}',
            columns: {
              update_timestamp: 'Modification date',
              rate: 'Exchange rate',
            },
            button: {
              update: 'Update',
              verify: 'Rate Control',
            },
            modal: {
              start_date: 'Start date',
              end_date: 'End date',
              rate: 'Exchange rate',
              title: 'Add an exchange rate',
              update: 'Update exchange rate',
            },
            titleDrawer: 'List',
            visu: 'Rate Control',
            columnsDrawer: {
              date: 'Date',
              error: 'Error',
              aucunErreur: 'No error found',
            },
          },
        },
        personnalise_rates: {
          table: {
            title: 'List of personalised rates',
            columns: {
              name: 'Name',
              rates: 'Key interest rate',
              rate_marge: 'Rate/Margin',
              base_calcul: 'Calculation basis',
              rate_type: 'Rate Type',
              conv: 'Convention',
            },
            button_charg_rate: 'Load Rates',
          },
          fiche: {
            edit_title: 'Personalised rate {{name}} sheet',
            new_title: 'Create a new personalised rate',
            champ_titles: {
              base_calcul: 'Calculation Basis',
              conv: 'Convention',
              type: 'Type',
              rate_value: 'Rate Value',
              rate_marge: 'Rate/Margin',
              comment: 'Comment',
              plancher_rates_floor: 'Interest rate floor - Floor',
              plafond_rates_cap: 'Interest rate cap - Cap',
              plancher_rates: 'Interest Rate Floor',
              plafond_rates: 'Interest Rate Cap',
              name: 'Name',
              value_floor_rate: 'Personalized ceiling rate',
              value_rate_cap: 'Personalized floor rate',
            },
            cap_floor_area: 'Cap and Floor in Rate+Margin',
          },
        },
      },
      quotidienne: {
        forecast: {
          fiche: {
            titles: {
              edit_title: 'Forecast {{code}} sheet',
              new_title: 'Create a new forecast',
              view_title: 'Format sheet {{code}}',
              general: 'General',
              characteristics: 'Characteristics',
              date_management: 'Manage Date',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              create: 'Create',
              reconciliation: 'Reconciliation',
              realization: 'Force',
            },
            champ_titles: {
              account: 'Account',
              label: 'Text',
              nature: 'Nature',
              amount: 'Amount {{type}}',
              op_date: 'Transaction date',
              value_date: 'Value date',
              category: 'Category',
              num_entry: 'Entry No.',
              exo: 'Exempt from transaction fee',
              type: 'Type',
              state: 'Status',
              first_due: 'First maturity',
              last_due: 'Last maturity',
              next_due: 'Next maturity',
              sequence: 'Frequency',
              in_progress: 'Number of pending forecasts',
              change: 'debit or credit',
            },
            realization: {
              title: 'Forecast Sheet',
              message:
                'Are you sure you want to force the creation of the forecast',
            },
            rapprochement: {
              title: 'Cash flow reconciliation',
            },
            modal: {
              title: 'Cash flow reconciliation',
              rappro_prev: 'Reconciled forecasts',
              rappro_mvt: 'Reconciled movements',
              num_mvt: 'Number of movements',
              num_prev: 'Number of forecasts',
              amount_mvt: 'Amount of movements',
              amount_prev: 'Amount of forecasts',
              user: 'User',
              date: 'Date',
              number: 'No. of reconciliations',
              title_user: 'Audit',
              creation_date: 'Creation date',
              user_creation: 'Creation user',
              date_modification: 'Update',
              user_modification: 'Update user',
              columns: {
                label: 'Text',
                ref: 'Reference',
                category: 'Category',
                ope_code: 'TXN Code',
                ope_date: 'TXN Date',
                value_date: 'Value date',
                amount: 'Amount',
                curr: 'Cur.',
                exo: 'Ex',
                nature: 'Nature',
                entry_number: 'No. Entry',
              },
            },
          },
          table: {
            header: {
              title: 'List of forecasts',
              mass_update: 'Bulk change',
              prev_generation: 'Generate temp. forecast',
              prev_auto: 'Auto forecast',
              import: 'Import',
              more_action: 'Other',
              generation: 'Generate intradays',
              generation_title: 'List of intradays',
              generation_btn: 'Generate forecasts',
            },
            columns: {
              state: 'Status',
              account: 'Account',
              label: 'Text',
              num_entries: 'No. Entry',
              nature: 'Nature',
              category: 'Category',
              exo: 'Ex',
              op_date: 'Transaction date',
              value_date: 'Value date',
              amount: 'Amount',
              currency: 'Currency',
              type: 'Type',
              origin: 'Source',
              user: 'User',
              update: 'Modification date',
              creation: 'Creation',
              ref: 'Reference',
              id_source: 'Source File ID',
            },
            mass_update: {
              title: 'Bulk forecast change',
              nature: 'Nature',
              type: 'Type',
              value_date: 'Value date',
              t2a: 'Switch forecasts from temporary to active',
              d2a: 'Switch forecasts from deleted to active',
              all2d: 'Switch forecasts to deleted',
              j1_update: 'Change Value D+1',
              update: 'Validate',
              close: 'Cancel',
              category: 'Category',
            },
            import: {
              title: 'Import account statement manually',
              model: 'Import template',
            },
          },
          automatic: {
            table: {
              header: {
                title: 'List of auto forecasts',
                new: 'New',
              },
              filters: {
                state: '-State-',
              },
              columns: {
                state: 'Status',
                account: 'Account code',
                label: 'Text',
                num_entries: 'No. Entry',
                nature: 'Nature',
                category: 'Category',
                exo: 'Ex',
                start_date: 'Start date',
                end_date: 'End date',
                next_due_date: 'Due date',
                amount: 'Amount',
                currency: 'Currency',
                type: 'Type',
                num_forecast: 'No pending forecasts',
                user: 'User',
                update: 'Edit',
              },
            },
            fiche: {
              titles: {
                edit_title: 'Auto forecast {{code}} sheet',
                new_title: 'Create a new auto forecast',
              },
              buttons: {
                generate: 'Generate forecasts',
              },
              generation: {
                title: 'Generating forecasts',
                message: 'Do you want to generate forecasts again',
              },
            },
          },
          temporary_prev_generation: {
            titles: {
              main_title: 'Manage temporary forecasts',
              temporary_forecast: 'Temporary forecasts',
              forecast_to_keep: 'Forecasts to be kept',
              active_forecast: 'Active forecasts',
              edit_modal: 'Change Forecasts to be kept',
            },
            champ_titles: {
              type: 'Type',
              value_date: 'Value Date',
              label: 'Text',
            },
            buttons: {
              generate: 'Generate',
            },
            modal: {
              title: 'List of forecasts',
              message:
                'Do you want to switch all temporary forecasts with no similar active forecasts to active ?',
            },
          },
        },
        cashpooling: {
          title: {
            general: 'Cashpooling',
            position_value: 'Value Positions',
            flow_proposal: 'Cash flow proposals',
            remove: 'Do you want to delete the flow',
          },
          select_grp_compte_cashpooling: 'Cash pooling account group',
          select_grp_compte_parametrage: 'Configuration account group',
          buttons: {
            validate: 'Validate proposals',
            new: 'New',
          },
          columns: {
            account: 'Account',
            balance: 'Balance Before',
            balance_after: 'Balance After',
            value_date: 'Date',
            authorized: 'Authorized',
            currency: 'Currency',
            date: 'Date',
            amount: 'Amount',
            credit_account: 'Account credited',
            debit_account: 'Account debited',
          },
          modal: {
            title: {
              new_flow: 'Create a new cash flow',
              edit_flow: 'Change cash flow',
            },
            buttons: {
              add: 'Validate',
              close: 'Cancel',
            },
            placeholder: {
              nature: '- Nature -',
              label: 'Auto caption if empty',
            },
            champ_titles: {
              debit_account: 'Account debited',
              credit_account: 'Account credited',
              label: 'Text',
              current_account: 'Current account',
              debit_nature: 'Debit Nature',
              credit_nature: 'Credit Nature',
              amount: 'Amount',
              value_date: 'Value Date',
              error_devise_compte:
                'Please select accounts of the same currency.',
            },
          },
          flow_list_placeholder: '-Default Treasury Flow-',
        },
        historique: {
          title: {
            general: 'Cash flow reconciliation history',
            bank_mvt: 'Reconciled bank movements',
            prov: 'Reconciled forecasts',
            detail_mvt: 'Reconciliation - Details',
          },
          buttons: {
            show_details: 'View Details',
            show_sessions: 'View Session',
          },
          filters: {
            account: 'Account',
            rappro_date: 'Reconciliation Date',
            value_date: 'Value Date',
            group: 'Group',
          },
          columns: {
            account: 'Account',
            category: 'Cat.',
            date: 'Val. Date',
            label: 'Text',
            amount: 'Amount',
          },
          alert: {
            rappro_session: 'There is no unreconciliation to be done',
          },
          modal: {
            title: {
              session_list: 'List of sessions',
            },
            columns: {
              date_num: 'Date/No.',
              user: 'User',
              value_date_movement: 'Mvt Date',
              value_date_prev: 'Forecast date',
              category: 'Cat.',
              nature: 'Nature',
              label: 'Text',
              amount: 'Amount',
              number: 'No.',
              nb_mvt: 'Nb Movements',
              nb_prevision: 'Nb Forecasts',
            },
            groups: {
              mvts: 'Movements to be reconciled',
              prevs: 'Forecasts to be reconciled',
            },
            buttons: {
              visualize: 'View',
              dereconciliation: 'Unreconcile',
            },
          },
        },
        research: {
          table: {
            header: {
              title: 'List of searches',
              load_search: 'Search',
            },
            filters: {
              account_group: 'Account groups',
              account: 'Accounts',
              amount_min: 'From',
              amount_max: 'To',
            },
            columns: {
              state: 'Status',
              account: 'Account',
              label: 'Text',
              reference: 'Reference',
              nature: 'Nature',
              category: 'Category',
              op_date: 'Execution date',
              value_date: 'Value Date',
              amount: 'Amount',
              currency: 'Currency',
              type: 'Type',
              entry_number: 'No. Entry',
              nature_code: 'Nature Code',
              integration_date: 'Integration date',
            },
            ventilation: {
              title: 'Breakdown',
              nature: 'Nature',
              label: 'Text',
              amount: 'Amount',
              total: 'Total',
              gap: 'Difference',
            },
            mass_update: {
              title: 'Bulk change',
              message:
                'Do you want to change the nature code and/or the category of the selected items',
            },
            visualisation: {
              headers: {
                detail: 'Transaction details',
                treasury_rappro: 'Cash flow reconciliation',
                accounting_rappro: 'Accounting reconciliation',
              },
              columns: {
                compte: 'Account',
              },
            },
          },
        },
        ventilation: {
          title: {
            general: 'Cash Breakdown',
          },
          buttons: {
            show_ventilate_manual: 'Manual Breakdown',
            show_ventilate_automatic: 'Rule Breakdown',
          },
          columns: {
            account: 'Account',
            category: 'Category',
            date: 'Value Date',
            label: 'Text',
            amount: 'Amount',
            compte: 'Account',
            devise: 'Currency',
          },
          modal: {
            title: {
              general: 'Movements to be reconciled',
              ventilate: '- Nature -',
              error_nature_not_selected: 'Please select a nature code',
            },
            columns: {
              value_date_movement: 'Mvt Date',
              category: 'Cat.',
              nature: 'Nature',
              label: 'Text',
              amount: 'Amount',
              number: 'No.',
            },
            buttons: {
              ventilate: 'Breakdown',
            },
          },
        },
        value: {
          title: {
            general: 'View cash flow dashboard',
            state_items: 'List of reports',
            unfold_nodes: 'Unfold all nodes',
            search_items: 'Search',
          },
          buttons: {
            sheet_in_value: 'Cash Flow Dashboard',
          },
          columns: {
            groups: '-Groups-',
            company: '- Company -',
            bank: '- Bank -',
            currency: '- Currency -',
            country: '- Country -',
            state: '-States-',
          },
          modal: {
            title: {
              value_sheet: 'Cash Flow Dashboard',
              details: 'Day details',
            },
            footer: {
              debit: 'Debit total',
              credit: 'Credit total',
              daily: 'Day total',
            },
          },
        },
        reconciliation: {
          headers: {
            title: 'Cash flow reconciliation',
            details: 'Cash reconciliation - Details',
            accounts: 'Accounts',
            viewType: 'View',
          },
          inputs: {
            total_movements: 'Movements Total',
            gap: 'Difference',
            total_forecasts: 'Forecast Total',
            number: 'No.',
            confirmTxt:
              'There is a difference. Do you want to validate the reconciliation',
            confirmTitle: 'Reconciliation',
          },
          cards: {
            movements: 'Bank movements to be reconciled',
            rappro: 'Reconciliation',
            forecasts: 'Forecasts to be reconciled',
          },
          buttons: {
            manual: 'Launch manual rules',
            next_account: 'Next account',
            montant: 'Amount 1/1',
            montantNN: 'Amount N/N',
            reconcile: 'Reconcile',
          },
          columns: {
            selected: 'Sel.',
            category: 'Category',
            value_date: 'Value date',
            label: 'Text',
            amount: 'Amount',
            account: 'Account',
            state: 'Status',
            balanced: 'Balanced',
            unbalanced: 'Not balanced',
          },
          message: {
            all_treated: 'All the accounts have been processed',
          },
        },
      },
      reporting: {
        analyse: {
          title: 'Analysis of nature/category codes',
          filters: {
            groups: 'Groups',
          },
          buttons: {
            validate: 'Show',
          },
          columns: {
            year: 'Year',
            january: 'January',
            february: 'February',
            march: 'March',
            april: 'April',
            may: 'May',
            june: 'June',
            july: 'July',
            august: 'August',
            september: 'September',
            october: 'October',
            november: 'November',
            december: 'December',
          },
        },
        analyseSolde: {
          title: 'Balance Analysis',
          filters: {
            groups: 'Groups',
            company: 'Companies',
            year: 'Years',
          },
          buttons: {
            validate: 'Show',
          },
          column: {
            societe: 'Companies',
            january: 'January',
            february: 'February',
            march: 'March',
            april: 'April',
            may: 'May',
            june: 'June',
            july: 'July',
            august: 'August',
            september: 'September',
            october: 'October',
            november: 'November',
            december: 'December',
          },
        },
      },
      settings: {
        natural_code: {
          table: {
            title: 'List of Nature codes',
            columns: {
              code: 'Code',
              name: 'Name',
              exo: 'Ex',
              sense: 'Direction',
              category: 'Category',
              update_timestamp: 'Modification date',
            },
            btn_grp_account: 'Nature Code Group',
          },
          fiche: {
            title: {
              edit_title: 'Nature Code {{code}} Sheet',
              new_title: 'Create a new Nature Code',
              organization: 'Organisation',
            },
            champ_titles: {
              type: 'Type',
              code: 'Code',
              name: 'Name',
              sense: 'Direction',
              level: 'Level',
              grouping: 'Regroup',
              order: 'order',
              category: 'Category',
              exo: 'Exempt from transaction fee',
            },
          },
          groupe_code_nature: {
            title: 'Nature Code Groups',
            title_modal_membre: 'Nature Code Group Selection',
            sens: 'Direction',
            champs: {
              code: 'Code',
              name: 'Name',
              date_create: 'Creation Date',
              comment: 'Comment',
              title_fiche: 'Nature Code Group Record {{code}}',
            },
          },
        },
        account_group: {
          table: {
            title: 'List of Account Groups',
            columns: {
              code: 'Code',
              name: 'Name',
              state: 'Status',
              update_timestamp: 'Modification date',
            },
            buttons: {
              type_new: 'New Type',
            },
            error_devise:
              'You have selected lines containing different currencies',
          },
          fiche: {
            title: {
              edit_title: 'Account Group {{code}} sheet',
              new_title: 'Create a new Account Group',
              new_title_type: 'Create a new type of Account Group',
              member: 'List of members',
              nb_selected: '(Number of selected members: {{nb}})',
              nbs_selected: '(Number of selected members: {{nb}})',
              edit_type_title: 'Edit a type of Account Group - {{code}}',
            },
            champ_titles: {
              type: 'Type',
              code: 'Code',
              name: 'Name',
              cashpool_level: 'Cash pooling level',
              description: 'Description',
              state: 'Status',
              sub_type: 'Subtype',
              devise: 'Overdraft Authorization Currency',
              group_decouvert: 'Group Overdraft Authorization',
              add_decouvert: 'Amount',
              title_modal_add_decouvert: 'Add Overdraft Authorization',
              generation_mode: 'Generation mode',
              label_virement_society: 'Intra-Company Transfer Label',
              label_virement_group: 'Intra-Group Transfer Label',
              label_virement_account: 'Current Account Transfer Label',

              account_credit_code: 'Credit account code',
              account_credit_name: 'Credit account name',
              account_debit_code: 'Debit account code',
              account_debit_name: 'Debit account name',
              flow: 'Default flow',
            },
            buttons: {
              add_account_group: 'Add an account group',
            },
            columns: {
              code: 'Code',
              name: 'Name',
              state: 'Status',
              code_name: 'Code-Name',
              iban: 'IBAN',
              company: 'Company',
              rounding: 'Rounded',
              currency: 'Currency',
              amount: 'Target balance',
              pivot: 'Master account',
              member_decouvert: 'Overdraft Authorization',
            },
          },
          modal: {
            title: {
              account: 'Select bank accounts',
              account_group: 'Select account group',
              update: 'Change account group',
            },
            choice: {
              nope: 'No',
              yes: 'Yes',
            },
            buttons: {
              add: 'Add',
              close: 'Cancel',
            },
            champ_titles: {
              pivot: 'Master account',
              amount: 'Threshold',
              arounding: 'Rounded',
            },
          },
        },
        reports: {
          table: {
            title: 'List of cash reports',
            columns: {
              code: 'Code',
              name: 'Name',
              update_timestamp: 'Modification date',
            },
          },
          fiche: {
            title: {
              edit_title: 'Format {{code}} sheet ',
              new_title: 'Create a new State',
              member: 'List of members',
              fiche: 'Characteristics',
              fiche_zoom: 'Zoom Characteristics',
              diffusion: 'Spread',
            },
            champ_titles: {
              type: 'Type',
              code: 'Code',
              name: 'Name',
              selection: 'Selection',
              period_type: 'Period Type',
              period: 'Period',
              unit: 'Unit',
              forecast: 'Forecast',
              category: 'Category',
              nature: 'Nature',
              min_amount: 'Min. amount',
              max_amount: 'Max. amount',
              label: 'Text',
              mode: 'Mode',
              mail_adress: 'E-mail addresses',
              user_smart_tag: 'Smart Tags Users',
              user_groupsmart_tag: 'Smart Tags user group',
              detail: 'Detail',
              ecart: 'Gap',
              elem: 'Element',
            },
            columns: {
              code: 'Code',
              name: 'Name',
            },
          },
          modal: {
            title: 'Select members',
            buttons: {
              add: 'Add',
              close: 'Cancel',
            },
          },
        },
        treasury_rules: {
          table: {
            title: 'List of cash Rules',
            columns: {
              code: 'Code',
              name: 'Name',
              auto: 'Auto/Manual',
              ordre: 'Order',
              update_timestamp: 'Modification date',
              state: 'Status',
              category: 'Category',
              releve: 'On Statement',
              prevision: 'On Forecast',
              flux: 'On Flow',
            },
          },
          fiche: {
            title: {
              edit_title: 'Cash Rule {{code}} sheet',
              new_title: 'Create a new Account Group',
              new_title_type: 'Create a new type of Account Group',
              new_rule_title: 'Create a new Rule',
              member: 'List of members',
              criteria_reconciliation: 'Reconciliation Criteria',
              member_selection: 'Select members',
            },
            champ_titles: {
              type: 'Type',
              code: 'Code',
              name: 'Name',
              category: 'Category',
              selection: 'Selection',
              mode: 'Mode',
              execution_order: 'Execution order',
              cashpool_level: 'Cash pooling level',
              description: 'Description',
              state: 'Status',
              deviation_allowed: 'Difference permitted',
              rappro_number: 'Reconcile by document Number',
              ecart_autorise: 'Difference permitted',
              nature: 'Nature',
              libelle: 'Text',
              placeholder_category: 'Enter Category Code',
              placeholder_selection: '- Selection -',
              placeholder_gap: 'Amount difference permitted',
              placeholder_rule_code: 'Rule code',
              placeholder_rule_name: 'Rule name',
              placeholder_montant_autorise: 'Amount difference permitted',
              placeholder_libelle: 'Contains text',
              applique_releve: 'To be applied to statements',
              applique_temporaire: 'To be applied to temporary forecasts',
              applique_flux: 'To be applied to flows',
              flux: 'Flow',
              ventilation: 'Allocation Criteria',
            },
          },
        },
        etablish_externe: {
          table: {
            title: 'List of external establishments',
            button_account_title: 'Bank accounts',
            columns: {
              etablish_name: 'Establishment',
            },
          },
          fiche: {
            title: 'Create a new external establishment',
            titleEdit: 'External establishment {{name}} sheet',
          },
        },
        etablish_externe_compte: {
          table: {
            title: 'List of bank accounts of external establishments',
            columns: {
              etablish_name: 'Establishments',
            },
          },
          fiche: {
            title: 'Create a new external account',
            titleEdit: 'Account {{name}} sheet',
          },
        },
      },
      currentAccount: {
        Liste: {
          fiche: {
            titles: {
              edit_title: 'Current account {{code}} sheet',
              new_title: 'Create a new current account',
              view_title: 'Current account sheet',
              characteristics: 'Characteristics',
              rate_management: 'Manage interest rates',
              interest_management: 'Manage interests',
              agiosManagement: 'Overdraft fees management',
              flow_management: 'Flow',
              cashpool: 'Bank CashPool',
              billing: 'Invoicing',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              create: 'Create',
            },
            champ_titles: {
              p_company: 'Parent company',
              c_company: 'Subsidiary',
              type: 'Type',
              name: 'Name',
              start_date: 'Start date',
              end_date: 'End date',
              cashpool_management: 'CashPool Management',
              state: 'Status',
              currency: 'Currency',
              interest_management: 'Manage interests',
              value_date: 'Value date',
              p_account: 'Parent company account',
              c_account: 'Subsidiary account',
              credit_note: 'Credit note',
              debit_note: 'Debit note',
              invoice_counter: 'Invoice counter',
              banking_cashpool:
                'Upload banking movements to the current account',
              email: 'Emails',
              inmail_facturation: 'Invoicing by e-mail',
              facturation_ref: 'Invoice reference',
            },
            table_rate: {
              title: 'Select interest rates',
              name: 'Name',
              margin: 'Margin',
              margin_rate: 'Margin/Rate',
              basis: 'Base',
              fix_var: 'Fixed/Var',
              start_date: 'Start date',
              end_date: 'End date',
              debit: 'Debit',
              credit: 'Credit',
            },
            table_account: {
              title: 'Select bank accounts',
              state: 'Status',
              name: 'Code-Name',
              iban: 'IBAN',
              company: 'Company',
              bank: 'Bank',
              category: 'Category',
              label: 'Text',
              sense: 'Direction',
              start_date: 'Start date',
            },
            modal_rate: {
              title: 'Change rate link',
              start_date: 'Start date',
              end_date: 'End date',
              debtor: 'Debit interest rate',
              creditor: 'Credit interest rate',
              floor: 'Floor amount',
              cap: 'Cap. amount',
            },
            modal_account: {
              title: 'Change account link',
              category: 'Category searched',
              label: 'Searched text',
              inverse_sign: 'Reverse entry direction',
              start_date: 'Start date',
              value_date: 'Date choice',
            },
            info_modal: {
              title: 'List of keywords',
              label: {
                now: '<DATE>',
                year: '<DATEQUANTIEME>',
                hour1: '<HEURE>',
                hour2: '<HEURE_LONG>',
                p_company: '<CODESOCIETE_MERE>',
                c_company: '<CODESOCIETE_FILLE>',
                name: '<NOM>',
              },
              value: {
                now: 'YYMMDD date format',
                year: 'Year in 2 characters followed by date',
                hour1: 'HHMMSS time format',
                hour2: 'HHMMSSCCC time format',
                p_company: 'Parent company code',
                c_company: 'Subsidiary code',
                name: 'Current account name',
              },
            },
          },
          table: {
            header: {
              title: 'List of current accounts',
              new_account: 'New',

              confirme_purge:
                'You are about to purge the statements of the selected current accounts. Warning! This operation is permanent. Do you want to continue?',
              purge: 'Purge',
            },
            filters: {
              state: '-State-',
              type: '-Type',
            },
            searchInput: {
              caption: 'Search for a current account by code, name or company',
            },
            columns: {
              state: 'Status',
              name: 'Current account name',
              parent_company: 'Parent company',
              child_company: 'Subsidiary',
              type: 'Type',
              balance: 'Balance',
              currency: 'Currency',
              end_date: 'Balance date',
              date: 'Modification date',
              credit_rate: 'Credit rate',
              debit_rate: 'Debit rate',
              periode: 'Calculation Period',
            },
            button: {
              history: 'History',
              statement: 'Statement',
            },
          },
          releve: {
            header: {
              title: 'View current account statement {{name}}',
              addfile: 'Import',
              modal: 'Transaction details',
              import: 'Import current account statement',
            },
            fields: {
              label: 'Transaction text',
              amount: 'Amount',
              valueDate: 'Value date',
            },
          },
          history: {
            header: {
              title: 'Current account history {{name}}',
            },
            columns: {
              label: 'Text',
              start_date: 'Start date',
              end_date: 'End date',
              amount: 'Amount',
              currency: 'Currency',
            },
            modal: {
              title: 'View interest calculation',
              start_date: 'Period start date',
              num_days: 'No. days',
              position: 'Position',
              rate: 'Interest rate',
              debtor_interest: 'Debit interest',
              creditor_interest: 'Credit interest',
            },
          },
        },
        Calculation: {
          table: {
            header: {
              title: 'Calculation of current accounts',
              calculate: 'Start calculation',
            },
            filters: {
              type: '-Type',
            },
            columns: {
              name: 'Current account name',
              parent_company: 'Parent company',
              child_company: 'Subsidiary',
              type: 'Type',
            },
            modal: {
              title: 'Current account calculation',
              month_end_calculation: 'Month-end calculation',
              calculate: 'Calculate',
              close: 'Cancel',
              errorMessage: 'Please enter start date and end date',
              period: 'Calculation period',
              last_balance_date: 'Last balance date (for advanced calculation)',
              last_rate_date: 'Last rate date (for advanced calculation)',
            },
          },
        },
        Analyse: {
          balance_title: 'Current account balances',
          analysis_title: 'Current accounts analysis',
          header: {
            balance_date: 'Balance date',
            interest_date: 'Interest dates range',
          },
          columns: {
            debit: 'Borrowing Company Condition',
            credit: 'Lending Company Condition',
            provision_interest: 'Provision interest',
            final_interest: 'Final interest',
            current_account: 'Current accounts',
          },
        },
        AccountRemunerer: {
          table: {
            header: {
              title: 'List of remunerated accounts',
              new_account: 'New',
            },
            filters: {
              state: '-State-',
              type: '-Type',
            },
            searchInput: {
              caption:
                'Search for a remunerated account by code, name or company',
            },
            columns: {
              state: 'State',
              name: 'Account name',
              etab: 'Institution',
              company: 'Company',
              credit_rate: 'Credit rate',
              balance: 'Balance',
              currency: 'Currency',
              end_date: 'Date of balance',
              date: 'Edition date',
            },
            button: {
              history: 'History',
              statement: 'Statement',
            },
          },
          fiche: {
            new_title: 'Interest-bearing account sheet',
            edit_title: 'Interest-bearing account {{code}} sheet',
            titles: {
              characteristics: 'Characteristics',
              rate_management: 'Rate management',
              interest_management: 'Interest management',
              agiosManagement: 'Agios management',
              flow_management: 'Flow',
              cashpool: 'Banking cashpool',
              billing: 'Invoicing',
            },
            champ_titles: {
              p_company: 'Financial Institution',
              c_company: 'Company',
              name: 'Name',
              start_date: 'State date',
              end_date: 'End date',
              state: 'State',
              currency: 'Currency',
              interest_management: 'Interest management',
              value_date: 'Value date',
              p_account: 'Parent Company Account',
              c_account: 'Child Company Account',
              credit_note: 'Credit note',
              debit_note: 'Debit note',
              invoice_counter: 'Invoice counter',
              banking_cashpool:
                'Upload of bank movements to the current account',
              email: 'Emails',
              inmail_facturation: 'Invoicing by email',
              facturation_ref: 'Invoice reference',
              interest: 'Interest',
              modeCalcul: 'Calculation mode',
              compteSocieter: 'Company Account',
              remote: 'Transfer of bank movements to the account',
            },
            compl_fields: {
              first_interest_date: 'First interest date',
              init_stmt_btn: 'Initialize statement',
              init_amount: 'Opening balance',
              confirm_purge:
                'This account already has statements.\nDo you want to delete them all?\n\nWarning: this action is irreversible.',
            },
          },
          visualisation: {
            title: 'View statement of interest-bearing account {{name}} ',
            columns: {
              label: 'Label',
              complementary_label: 'Complementary label',
              reference: 'Reference',
              tiers: 'Third party',
              document_number: 'Document N°',
              category: 'Category',
              transaction_code: 'Code',
              operation_date: 'Operation date',
              value_date: 'Value date',
              debit: 'Debit',
              credit: 'Credit',
              currency: 'Currency',
              devise: 'Currency',
            },
          },
        },
        AccountCapital: {
          table: {
            header: {
              title: 'List of capitalisation contracts',
              new_account: 'New',
            },
            searchInput: {
              caption:
                'Search for a capitalisation contract by code, name or company',
            },
            columns: {
              name: 'Capitalisation contract name',
              rate: 'Rate',
              date: 'Start date',
              end_date: 'End date',
              state: 'State',
              etab: 'Establishment',
              company: 'Company',
              balance: 'Balance',
              currency: 'Currency',
              date_modification: 'Modification Date',
            },
            filters: {
              state: '-State-',
              type: '-Type-',
            },
            button: {
              history: 'History',
              statement: 'Statement',
            },
          },
          fiche: {
            new_title: 'Capitalisation contract sheet',
            edit_title: 'Capitalisation contract {{code}} sheet',
            champ_titles: {
              liq: 'Liquidity',
            },
          },
          visualisation: {
            title: 'View statement of capitalisation contract',
          },
        },
      },
      evenement: {
        listes: {
          title: 'List of events',
          fiche: {
            title_fiche: 'Event {{label}} no. {{number}} sheet',
            title_cache: 'Cash Pooling Transfers',
            title_compte: 'Interests of current accounts',
            title_echeance: 'Payment due date',
            title_placement: 'Investment',
            imprime: 'Print',
            champs: {
              type: ' Type',
              sub_type: 'Subtype',
              etat: 'Status',
            },
            modal: {
              title: 'Change calculation',
              amount: 'Amount',
              date: 'Date',
              batch_warning:
                'IMPORTANT: The transfer flow is present in the signature book; please remove it from the batch.',
            },
            culumns: {
              name: 'Name',
              emetter: 'Issuer',
              benefic: 'Beneficiary',
              amount: 'Amount',
              devise: 'Currency',
              etat: 'Status',
              date: 'Date',
            },
            generate_entries: 'Generating entries',
            validate_entries: 'Validate',
            archivage: 'Realise',
            envoi_mail: 'Send by Email',
            msg_confirm_mail: 'Do you want to send the statement by email ',
          },
        },
        liste: {
          table: {
            title: 'List of personalised reference rates',
            columns: {
              event_num: 'Event No.',
              type: 'Type',
              sub_type: 'Subtype',
              libelle: 'Text',
              nb: 'No',
              amount: 'Amount',
              currency: 'Currency',
              state: 'Status',
              date: 'Creation date',
              login: 'Login',
            },
          },
          fiche: {
            edit_title: 'Personalised reference rate{{name}} sheet',
            new_title: 'Create a new personalised reference rate',

            champ_titles: {},
          },
        },
      },
      debt: {
        list: {
          title: {
            credit_line: 'List of credit lines',
          },
          columns: {
            name: 'Name',
            type: 'Type',
            lender_company: 'Lending Company',
            borrowing_company: 'Borrowing Company',
            currency: 'Currency',
            amount: 'Amount',
            available_amount: 'Available amount',
            state: 'Status',
            start_date: 'Start date',
            end_date: 'End date',
          },
          buttons: {
            delete: 'Delete',
            addTirage: 'New draw',
            btn_paiement: 'Payment of maturities',
          },
        },
        detail: {
          drawer: {
            title: 'Maturity details',
            card_payement: 'Paiment',
            champ_titles: {
              state: 'Status',
              timeline: 'Maturity',
              start_date: 'Start Date',
              end_date: 'End Date',
              payment_date: 'Payment date',
              timeline_date: 'Maturity Date',
              capital_amount_paid: 'Paid-in or repaid Capital Amount',
              capital: 'Capital Amount',
              interests_amount: 'Interest Amount',
              capital_interests: 'Capital Interests',
              flow: 'Flow',
              compte_mere: 'Parent account',
              compte_fils: 'Subsidiary account',
            },
            buttons: {
              save_continue: 'Validate - Next',
            },
          },
          modal: {
            title: 'New',
            change_date: 'Change the date of the first maturity',
            alert:
              'Do you want to add a maturity after the maturity selected? All the following maturities will be shifted',
            buttons: {
              yes: 'yes',
              no: 'no',
            },
          },
          columns: {
            timeline_number: 'Mat. No.',
            period: 'Period',
            description: 'Description',
            number_day: 'No. Days',
            timeline_date: 'Maturity Date',
            payment_date: 'Payment Date',
            capital: 'Capital',
            k_movement: 'K movement',
            interests: 'Interests',
            accumulated_interest: 'Total interest',
            remaining_capital: 'Outstanding capital',
            due_amount: 'Maturity',
            state: 'Status',
          },
          title: 'View payment schedule {{name}}',
          titleCalculInt: 'Interest calculation',
          msgCalcul: 'Are you sure you want to run the interest calculation',
          buttons: {
            add: 'Add',
            calcul: 'Calculate interests',
            calculInteret: 'Maturities calculation',
            calculEchues: 'Calculation of unmatured maturities',
            calculEcheances: 'Calculation of all maturities',
            mes1: 'Are you sure you want to run the calculation of unmatured maturities',
            mes2: 'Are you sure you want to run the calculation of ALL maturities',
            mes3: 'Are you sure you want to replace ALL your deadlines with the selected file',
            mes4: '{{errorMessage}}\n Would you like to continue anyway',
          },
        },
        fiche: {
          title: {
            timeline: {
              new: 'Create a new maturity',
              edit: 'Debt subject {{name}} sheet',
              renew: 'Renewal of debt subject {{name}}',
            },
            echeance: {
              new: 'Create a new maturity',
              edit: '{{name}}',
            },
            credit_line: {
              new: 'Create a new credit line',
              edit: 'Credit line {{name}} sheet',
            },
            characteristic: 'Characteristics',
            interest_management: 'Manage interests',
            rate_management: 'Manage interest rate',
            capital_amortization: 'Capital depreciation',
            forecast_management: 'Manage forecasts',
            mail_alert: 'Email Alert',
            readonly: 'Read only',
            doc: 'Documents',
          },
          buttons: {
            add: 'Add',
            validate: 'Validate',
            close: 'Cancel',
            join: 'Attach',
          },
          modal: {
            title: {
              rate: 'Select Interest Rates',
              edit_rate: 'Change rate link',
              doc: 'Document',
              confirm_evt: 'Do you want to generate the payment event',
              confirm_pymt: 'Do you want to pay these maturities',
            },
            columns: {
              margin: 'Margin/Rate',
              base: 'Basis',
              fixe_variable: 'Fixed/Var',
            },
            champ_titles: {
              start_date: 'Start date',
              end_date: 'End date',
              doc_type: 'Type of document',
              doc_name: 'Document Name',
              state: 'Status',
              pdf_doc: 'PDF document',
            },
          },
          columns: {
            margin: 'Margin',
            date: 'Date',
            doc_name: 'Document Name',
            doc_type: 'Document Type',
            state: 'Status',
            visualization: 'View',
          },
          champ_titles: {
            type: 'Type',
            name: 'Name',
            start_date: 'Start Date',
            end_date: 'End Date',
            first_maturity_date: '1st Maturity Date',
            amount: 'Amount',
            rate: 'Interest rate',
            break: 'Fraction of shares',
            interests: 'Interests',
            period: 'Capital Interests',
            debit_nature: 'Debit nature',
            credit_nature: 'Credit nature',
            commission: 'Commission',
            borrowing_company: 'Borrowing company',
            lender_company: 'Lending company',
            state: 'Status',
            currency: 'Currency',
            flow: 'Flow',
            child_account: 'Subsidiary Account',
            parent_account: 'Parent company Account',
            emails: 'Emails',
            liquidity: 'Liquidity',
            without_amort: 'Without depreciation',
            with_amort: 'With depreciation',
            interest_calculation_mode: 'Interest calculation method',
          },
          placeholder: {
            flow: '<Payment excluding Opencash flow>',
          },
          alert: {
            break_change:
              'The first maturity date will be automatically set according to the new fraction of shares chosen',
          },
        },
        payement: {
          payed: 'Pay maturities',
          icne: 'Calculate accrued interest not yet due',
          titleSelectDate: 'Select date',
          date: 'Date:',
          column: {
            tirage_name: 'Amount drawn',
            credit_line_name: 'Credit line',
            num: 'No.',
            periode: 'Period',
            nbrJ: 'No. Days',
            dateEch: 'Payment Schedule Date',
            dateP: 'Payment date',
            capital: 'Capital',
            echeance: 'Maturity',
            interet: 'Interests',
            mouvement: 'K movement',
            capitalRest: 'Outstanding Capital',
            cumulRes: 'Remaining Total',
            cumulInt: 'Total interest',
            status: 'Status',
          },
        },
        emprunt: {
          titlecreation: 'Create a new loan',
          edit: 'Loan {{name}} sheet',
          title: 'List of loans',
          newTirage: 'New maturity',
          capital: 'Capital',
        },
        placement: {
          compteTitre: {
            title: 'List of securities accounts',
            lender_company: 'Financial institution',
            borrowing_company: 'Company',
            valeur: 'Value',
            titleDrawer: 'Create a new value',
            titleEdit: 'Edit value',
            visualisation: {
              title: '{{name}} securities account statement details',
              column: {
                label: 'Text',
                quantite: 'Quantity',
                date_v: 'Value date',
                cours: 'Rate/Purchase rate',
                amount: 'Amount',
                position: 'Position',
                value: 'Gain or loss',
                devise: 'Currency',
              },
              drawer: {
                title: 'Create a new transaction',
                edit: 'Update transaction {{name}} ',
                achat: 'Purchase',
                vente: 'Sale',
                dateOperation: 'Operation date',
                dateValeur: 'Value date',
                prix: 'Price',
                messQuantite: 'Please enter amount or quantity.',
                quantite: 'Quantity',
                montantT: 'Total amount',
                erreur_msg: 'Available stock quantity : {{quantiteMax}}',
              },
            },
          },
          fiche: {
            title: 'Security account {{name}} sheet',
            payementManagement: 'Payment management',
            etabFinance: 'Financial institution',
            emprunteur: 'Company',
            compteEtablissement: 'Financial institution account',
            compteSocieté: 'Company account',
          },
          compteTerme: {
            title: 'List of term deposits',
            ficheTitle: 'Term deposit {{name}} sheet',
            payment: 'Payment',
            timeline: 'Maturities management',
            generate_event: 'Events generation',
            message: 'Do you want to generate events',
            renew: 'Renew',
          },
        },
        consultation: {
          title: 'Maturities view',
          titlePlct: 'Investment view',
          column: {
            timeline_name: 'Maturity',
            company_code: 'Company',
            start_date: 'Start',
            end_date: 'End',
            counterpart: 'Counterpart',
            directing_rate: 'Rate',
            rate_margin: 'Margin',
            calculation_base: 'Basis',
            rate_type: 'Rate type',
            f_capital: 'Capital frequency',
            depreciation_type: 'Depreciation type',
            f_interest: 'Interest frequence',
            nominal: 'Nominal',
            amount: 'Amount',
            next_due_date: 'Next maturity',
            interest: 'Interest',
            icne: 'Calculate accrued interest not yet due',
            depreciated_capital: 'Depreciated K',
            period: 'Period',
            price: 'Purchase rate',
            quantity: 'Quantity',
            value: '+/- Unrealised',
            last_rate: 'Actual rate',
            nbJr: 'N° days',
            nbJrICNE: 'ICNE N° days',
            society: 'Company',
            market_room: 'Trading Room',
            intermediare: 'Intermediary',
            nbJrCome: 'Nb Days Remaining',
            nbJrICNECome: 'Interest Accrued',
            periode: 'Calculation Period',
            nbJour: 'Nb Days',
            date_interet: 'Interest Date',
          },
        },
        analyse_plct: {
          title: 'Investment analysis',
          period_1: 'Reference period 1',
          period_2: 'Reference period 2',
          column: {
            return: 'Return',
            net_change: 'Net change',
            period_1: 'Period 1',
            period_2: 'Period 2',
          },
        },
        value_gestion: {
          table: {
            title: 'List of values',
            button_chargement_cours: 'Loading rates',
            columns: {
              status: 'State',
              type: 'Type',
              code: 'ISN code ',
              mnemonic: 'Mnemonic',
              lastrate: 'Last rate',
              ratedate: 'Rate date',
              favorite: 'Favorite',
            },
          },
          fiche: {
            title_new: 'Create a new value',
            title_edit: 'Edit value : {{code}}',
            first_card_title: 'General',
            code_isin: 'ISIN code ',
            code_nemonic: 'Mnemonic',
            name: 'Name',
            second_card_title: 'Characteristics',
            type: 'Type',
            place_cotation: 'Quotation Place',
            third_tilte: 'Audit',
            date_creation: 'Creation date',
            date_modif: 'Update',
          },
          visualise: {
            table: {
              title: 'Rate of value',
              rate: 'Rate',
              date: 'Rate date',
            },
            modal: {
              title: 'Add new rate',
            },
          },
          chargement: {
            table: {
              title: 'Liste des valeurs',
              column: {
                rate: 'Rate',
                date: 'Update',
                code: 'Code',
                type: 'Type',
                name: 'Name',
              },
            },
            modal: {
              title: 'Add new rate',
              date: 'Last update',
            },
          },
        },
        analyse_dept: {
          title: 'Debt Analysis',
          placement_etab: 'Debt by Financial Establishment',
          repartition_type: 'Debt Distribution by Type',
          placement_societe: 'Debt by Company',
        },
      },
      Budgets: {
        scenario: {
          list: {
            title: 'List of Budget Scenarios',
            culumn: {
              etat: 'Status',
              code: 'Code',
              name: 'Name',
              type: 'Type',
              period: 'Period',
              user: 'User',
              date_modif: 'Modification Date',
            },
          },
          fiche: {
            titleNew: 'Creation of a New Scenario',
            editTitle: 'Scenario Record {{code}}',
            title_code_list: 'List of Nature Codes',
            title_category_list: 'List of Category Codes',
            code_natureAll_placehoder: '- All Nature Codes -',
            code_categoryAll_placehoder: '- All Category Codes -',
            champs: {
              etat: 'Status',
              code: 'Code',
              descri: 'Description',
              caracteristic: 'Characteristics',
              annee: 'Year',
              type: 'Selection Type',
              type_code: 'Code Type',
              periode: 'Period',
              month: 'Start Month',
              filtre_code: 'Filter by Code',
            },
            message_validation:
              'The conditions have been modified. The periods will be deleted. Do you want to continue ',

            import_budget: 'Import',
            message_confirme_purge_budget:
              'Do you want to delete all « Budget » data from your scenario',
            message_confirme_purge_realisé:
              'Do you want to delete all « Actual » data from your scenario',
            purge_budget: 'Purge Budget',
            purge_realisé: 'Purge Actual',
          },
          visualise: {
            title: 'Scenario View',
            type_placeholder: '- Type -',
            period_placeholder: '- Period -',
            code_nature_placehoder: '- Nature Code -',
            applique: 'Apply',
            action: {
              import_annuel: "Import Previous Years' Data",
              import: 'Import Excel',
              action: 'Action',
              recherche: 'Search by Year',
            },
            modal_import: {
              title: "Import Previous Years' Data",
              annee: 'Year',
            },
          },
        },
        analyste: {
          title: 'Budget Analysis',
          titleDrawer:
            'Scenario: Budget {{year}} - {{ name }} {{label}} {{year}}',
          devise: 'Currency',
          scenario: '- Scenario -',
          total_treso: 'Total Treasury',
          total_depense: 'Total Expenses',
          total_recette: 'Total Revenue',
          culumn: {
            nature: 'Nature',
            label: 'Label',
            devise: 'Currency',
            montant_bud: 'Budget Amount',
            montant_realiser: 'Actual Amount',
            montant_prev: 'Forecast Amount',
            avancement_realiser: 'Actual Progress',
            avancement_realiserPrev: 'Actual and Forecast Progress',
          },
        },
      },
    },
    document: {
      document: {
        document_signataire: {
          title: 'List of colleges documents',
          fiche: {
            title: 'Create a new document college',
            edit_title: 'Modification of a document college',
          },
        },
        authority_signataire: {
          title: 'List of signing authority documents',
          fiche: {
            title: 'Create a new document signing authority',
            edit_title: 'Modification of a document signing authority',
          },
        },
        generation_document: {
          title: 'Update banking power',
          btn_generate: 'Generate',
          bank_placeholder: '- Bank -',
          fiche: {
            bank: 'Bank',
            iban: 'IBAN',
            devise: 'Currency',
            pouvoir_bancaire: 'Banking power',
            date_modif: 'Date of modification',
            flow_name: 'Flow',
          },
          gliss_placeholder: '- Drag here to group -',
          flux_filter: '- Document -',
          pouvoir_filter: '- Power -',
          mandateUser_filter: '- Natural person principals -',
          mandateCompany_filter: '- Legal entity principals -',
          direct_mandate: 'Direct principal',
        },
        validation_document: {
          title: 'List of Powers',
          column: {
            num: 'N°',
            state: 'State',
            account: 'Account',
            society: 'Compagny',
            pouvoir: 'Power',
            currency: 'Currency',
            login: 'Login',
            date: 'Date',
            signatories: 'Signatories',
            bank: 'Bank',
            code: 'Account Code',
            flow: 'Flow',
          },
          audit_validation: {
            date: 'Date',
            login: 'Login',
            action: 'Action',
          },
          btn_imprime: 'Print',
          btn_sendsignatory: 'Send signatories',
          btn_signature: 'Validate',
          btn_attribut: 'Assign',
          btn_carton: 'Signature Boxes',
          btn_identity: 'Identity Documents',
          message_confirm_attibute:
            'Do you really want to assign this account?',
          actions: {
            upload: 'Upload signed document',
          },
        },
        sign_document: {
          title: 'Document Signatures List',
        },
        histo_document: {
          title: 'Document History List',
          date_sign: 'Signature Date',
          date_envoi: 'Bank Send Date',
          date_recep: 'Bank Receipt Date',
          date_retour: 'Bank Return Date',
          button_action: {
            title: 'Action',
            envoi: 'Send to Bank',
            retour: 'Bank Validation',
            recep: 'Bank Receipt',
            refus: 'Bank Refusal',
          },
          send_bank_modal: {
            email: 'Emails',
            bank: 'Bank',
            subject: 'Subject',
            send: 'Send',
          },
        },
        document_authority: {
          titles: {
            by_account: {
              generation: 'Account Document Generation',
              validation: 'Account Document List',
            },
            by_company: {
              generation: 'Company Document Generation',
              validation: 'Company Document List',
            },
          },
        },
        gestion_document: {
          table: {
            title: 'List of signatories',
            tilte_send_mail_bank: 'Send email to banker',
            tilte_send_mail_signataire: 'Send email to signatory',
            head_filtre_placeholder: '- All colleges -',
            email_bank: 'Email',
            icon_mail_bank: 'Send email to bank',
            icon_mail_signataire: 'Send email to signatory',
            culumn: {
              state: 'Status',
              login: 'Login',
              name: 'Name',
              lastname: 'First name',
              mail: 'Email',
              numphone: 'Mobile number',
              date: 'Validity date',
              cn: 'ID card',
              passport: 'Passport',
              signature: 'Signature',
              date_birth: 'Date of birth',
              country_birth: 'Country of birth',
              place_birth: 'Place of birth',
              nationality: 'Nationality',
              num_cin: 'ID card number',
              date_cin: 'Validation date',
              civility: 'Civility',
              function: 'Function',
            },
          },
        },
        mandant: {
          title: 'List of Principals',
          filter: {
            societe: 'Companies',
            societe_mandat: 'Mandating Companies',
            mandant_pers: 'Principal Individuals',
            direct_mandant: 'Direct Principal',
          },
          column: {
            state: 'Status',
            code: 'Code',
            name: 'Name',
            pays: 'Country',
            ordre: 'Order',
            type_lien: 'Principal Link Type',
            name_mandat: 'Principal Name',
            type_mandant: 'Principal Type',
            fonction: 'Function',
            date_start: 'Start Date',
            date_end: 'End Date',
            action: 'Actions',
          },
        },
      },
    },
    user: {
      profile: {
        dashboard_modal: {
          account: 'My Account',
          change_log: 'Release',
          logout: 'Log out',
          settings: 'Configuration',
        },
        title: 'My Account',
        buttons: {
          save: 'Validate',
          blocked_device: 'Block device',
          authorized_device: 'Authorise device',
          change: 'Change password',
          qrCode: 'Activate 2FA',
          edit_qrCode: 'View/Modify',
          disable_qrCode: 'Disable 2FA',
          totpTxt:
            'Scan the QR code via an authentication application, then enter the 6-digit code.',
        },
        tabs: {
          title: {
            informations: 'My information',
            password: 'Password',
            entities: 'My entities',
            connected_devices: 'My connected devices',
            download: 'Download',
            card_title_download: 'OpenCash Parapher Download',
            button_name: 'Download',
            card_title_download_pouvoir: 'OpenCash Power Download',
          },
          champ_titles: {
            login: 'Login',
            email: 'Email',
            last_name: 'Last name',
            first_name: 'First name',
            phone_number: 'Phone',
            fax: 'Fax',
            mobile_number: 'Mobile phone',
            receive_email: 'Email received',
            language: 'Language',
            new_password: 'New password',
            current_password: 'Current password',
            confirm_password: 'Confirm password',
            otp_type: 'Type',
          },
          columns: {
            code: 'Code',
            name: 'Name',
            defined: 'Bookmark',
          },
        },
      },
    },
    composant: {
      modal_select_filiale: {
        title: 'Select subsidiary for creation',
        code: 'Code',
        nom: 'Name',
        left_title: 'Sole signatory',
        middle_title: 'Dual signatories',
        right_title: 'Mobile phones',
        other_title: '',
      },
      details_operation: {
        title: 'Detail of transaction {{name}}',
        libelle: 'Transaction text',
        libelle_complementaire: 'Additional text',
        motif: 'Reason',
        montant: 'Amount',
        exempted: 'Exempt',
        date_operation: 'Transaction date',
        date_valeur: 'Value date',
        reference: 'Reference',
        endtoend: 'Client-to-client reference',
        category: 'Category',
        code_operation: 'Transaction code',
        nom_payeur: 'Payer name',
        id_payeur: 'Payer ID',
        nom_payeur_final: 'Final payer name',
        nom_beneficiaire: 'Beneficiary name',
        id_beneficiaire: 'Beneficiary ID',
        nom_beneficiaire_final: 'Final beneficiary name',
        id_beneficiaire_final: 'Final beneficiary ID',
        reference_remise: 'Remittance reference',
        reference_transaction: 'Operation reference',
        montant_origine: 'Original amount',
        taux_change: 'Exchange rate',
        compte_beneficiaire: 'Beneficiary account',
        compte_debiteur: 'Debtor account',
        num_ecriture: 'Entry No.',
        nature_paiement: 'Payment nature',
        rum: 'UMR',
        libelle_retour: 'Return text',
      },
      reconciliation: {
        rappro_mvt: 'Reconciled transactions',
        rappro_prev: 'Reconciled forecasts',
        rappro_entry: 'Reconciled entries',
        columns: {
          label: 'Text',
          category: 'Category',
          nature: 'Nature',
          value_date: 'Value date',
          flux: 'Accounting flow',
          op_date: 'Transaction Date',
          amount: 'Amount',
          currency: 'Currency',
          compte: 'Account',
        },
        footerRows: {
          num_mvt: 'Number of movements',
          amount_mvt: 'Amount of movements',
          num_prev: 'Number of forecasts',
          amount_prev: 'Amount of forecasts',
          num_entries: 'Number of entries',
          amount_entries: 'Amount of entries',
        },
        user: 'User',
        date: 'Date',
        reconciliation_num: 'No. of Reconciliation',
        nature_code: 'Nature Code',
      },
      modal_structured_adress: {
        title: 'Structured address generation',
        placeholder: 'Enter the address here',
        cancel: 'Cancel',
        send: 'Generate',
        generate: 'Generate structured address',
      },
    },
    Initialise: 'Initialize',
    aSupprimer: 'To be deleted',
    Enter: 'Detail',
    Admin: 'Administer',
    Json_params: 'View json parameter',
    Json: 'View json',
    Json_return: 'View json response',
    down_Json_params: 'Download json parameter',
    down_Json_return: 'Download json response',
    Unlock: 'Unlock',
    Action_validation: 'Action validation',
    yes: 'Yes',
    no: 'No',
    date_validation: 'Action date',
    Message_validation: 'Do you want to validate the action : ',
    remplace_document: 'Do you want to replace the document ? ',
    ValidDelete: 'Validate deleting',
    Refuser: 'Do you want to refuse the message',
    Signer: 'Do you want to sign the message ',
    AdminChange: 'Change client',
    listUserClientDispo: 'Client',
    listUserAdminDispo: 'Admin',
    search_user: 'Search an user name',
    backOffice: {
      title: 'Back Office',
      user: {
        title: 'Back office user list',
        column: {
          state: 'State',
          login: 'Login',
          name: 'Last name',
          firstName: 'First name',
          email: 'Email',
          dateConn: 'Connection date',
        },
        fiche: {
          title: 'User sheet',
          title_pwd: 'Password',
          title_pwd_edit: 'Password change',
          state: 'State',
          mail: 'Email',
          login: 'Login',
          firstName: 'First name',
          name: 'Last name',
          profil_user: 'User profile',
          password: 'Password',
          passwordConfirm: 'Confirm password',
          errormail: 'Your mail is invalid',
          errorPasswrd: 'Password obligatory',
          errorConfirmPass:
            'Password confirmation is obligatory and must be valid',
        },
      },
      groupUser: {
        title: 'Administrator group list',
        column: {
          state: 'State',
          code: 'Code',
          name: 'Name',
          dateModif: 'Modification date',
        },
      },
      profil: {
        fiche: {
          title: 'Administrator group sheet',
          titleModal: 'Add an user',
          addProfile: {
            title: 'Client acces',
            admin_account: 'Administrator profile',
            groupModal: 'Group :',
            userModal: 'User',
            column: {
              client_name: 'Client name',
              login: 'Login',
              mail: 'Mail',
              dateModif: 'Modification date',
              dateCreation: 'Creation date',
            },
          },
        },
      },
      gestionGroup: {
        title: 'Entity list',
        fiche: {
          title: {
            creation: 'Group creating',
            edit: 'Group sheet',
            label_module: 'Module list',
            module: 'Module',
            placeholder_modul: '- Module -',
            to_prod_btn: 'Move to production',
          },
          modal_module: {
            title: 'Format selection',
            title_table: 'Module list',
            title_modale_add: 'Add module',
            title_modale_edit: 'Edit module',
            column: {
              module: 'Module',
              nb: 'Number',
              date: 'Creation date',
              user: 'User Backoffice',
            },
          },
        },
        administer: {
          title: 'Group administration',
          title_card: 'Value balance control',
          button_solde_value: 'Recalculate value balance of selected account',
          button_verification_value: 'Value verification',
          control_remise: 'Remittance contrôle',
          control_valeur: 'Value balance control',
          column: {
            state: 'State',
            code: 'Code',
            name: 'Name',
            dateOP: 'Operation date',
            soldeOP: 'Operation balance',
            dateValue: 'Value date',
            soldeValue: 'Value balance',
          },
        },
        initialiser: {
          title: 'Group initializing',
          title_filiale: 'Entity',
          code: 'Code',
          name: 'Name',
          list: 'List',
          first_title: 'Subsidiary',
          title_initialise: 'Table Initialization',
          label_initialise:
            'Creation of SuperAdministrator Profile/Double Admin/Labels/4 Eyes/Category',
          button_create: 'Create',
          title_create_format: 'Format Creation',
          title_import: 'Company/Accounts Import',
          title_imp_bank: 'Import Banks',
          title_beneficiaire: 'Beneficiaries Import',
          title_mandant: 'Mandate Import',
          title_imp_treso: 'Treasury Plan Import',
          title_cpt_courant: 'Current Account Import',
          title_mvt: 'Current Account Movements Import',
          title_compta: 'Accounting Accounts Import',
          title_soc_tiers_compte:
            'Cubicus Script 1 Integration (Companies/Accounts/Users/Profiles)',
          title_delete_tiers_compte:
            'Cubicus Script 2 Integration (Tiers/Tier Groups)',
          title_tiers: 'Cubicus Script 3 Integration (Batch History)',
          title_histo: 'History Import',
          delete_script: 'Delete Script 1 Integration',
          import_users: 'User Import',
          btn: {
            validate_btn: 'Validate',
            create_btn: 'Create',
            import_btn: 'Import',
          },
          modal_format: {
            title: 'Format Selection',
            title_select: 'Group',
          },
          import_societe: 'Import Companies',
          import_compte: 'Import Accounts',

          title_exodon: 'Exodon integration',
          title_releve: 'Import bank statement',
        },
      },
      adminGenerale: {
        title: {
          admin: 'General Administration',
          controleBd: 'Database Control',
          controleAcces: 'Access Control',
          controleLabs: 'Labels Control',
          controleWidgets: 'Widgets Control',
          controleChamp: 'Fields Control',
          integrationCubus: 'Cubicus Integration',
          ebam: 'eBAM',
          selectGroup: 'Select a group',
          renew_cert: 'HPB Certificate Renewal',
          select_hostId: 'Select HOSTID',
          date: 'Launch date and time',
        },
        btn: {
          admin: 'Administration',
          controleBd: 'Database Verification',
          controleAcces: 'Access Control',
          controleLabs: 'Labels Control',
          controleWidgets: 'Widgets Control',
          controleChamp: 'Fields Control',
          ebam: 'eBAM',
          create_job: 'Create job',
        },
      },
      currency: {
        table: {
          title: 'Currency List',
          DeviseISO: 'CurrencyISO',
          label: 'Label',
          nb_decimal: 'Decimal Number',
          code_cdf: 'BDF Code',
        },
        fiche: {
          title: 'Currency File',
          currency: 'Currency',
          label: 'Name',
        },
      },
      pays: {
        title: 'Back Office Country List',
        column: {
          name: 'Name',
          dansSepa: 'InSepa',
          dansFrance: 'InFrance',
          iban: 'IBAN',
          devise: 'Currency',
          ssid: 'SISIDControl',
          codeP: 'Country code',
        },
        fiche: {
          ficheTitle: 'Country File',
          name: 'Name',
          devise: 'Currency',
          dans_sepa: 'InSepa',
          dans_france: 'InFrance',
          iban: 'IBAN',
          SISIDControl: 'SISIDControl',
          code_pays: 'Country Code',
          bbanRegex: 'Regex format BBAN',
          bbanExample: 'Example BBAN',
          bbanRegexiban: 'Regex format IBAN',
          bbanExampleiban: 'Example IBAN',
        },
      },
      codeOperation: {
        title: 'Back Office Operation Code List',
        table: {
          column: {
            name: 'Original Label',
            sense: 'Sense',
          },
        },
        fiche: {
          title: 'Operation Code File',
          code: 'Code',
          label: 'Original Label',
          sense: 'Sense',
        },
      },
      audit: {
        title: 'User Actions Audit',
        table_list: '- Table -',
        label_or_key: '- Label -',
        table: {
          column: {
            name: 'Table Name',
            key: 'Key',
            date: 'Date',
            label: 'Label',
            login: 'Login',
          },
        },
        fiche: {
          title: 'Operation Code File',
          code: 'Code',
          label: 'Original Label',
          sense: 'Sense',
        },
      },
      releve_compte: {
        title: 'Account statements',
        placeholder: '- Group -',
        detail_title: 'Account statement details {{name}}',
      },
    },
    vue_simple: 'Simple view',
    vue_detail: 'Detailed view',
    next: 'Next',
    prev: 'Previous',
    Taux: 'Rate',
    copied: 'Copy',
    coller: 'Paste',
    valid: 'Validate',
    selection: '- Select -',
    risk: {
      operationChange: {
        Liste: {
          table: {
            title: 'List of foreign exchange operations',
            paid: 'Pago',
            message_confirm_deal: 'Do you want to validate this deal {{code}}',
            message_confirm_denouer: 'Do you want to settle this deal {{code}}',
            message_confirm_soulte: 'Do you want to validate this compensation',
            or: 'OR',
            and: 'AND',
            tree: 'Tree',
            list: 'List',
            culumn: {
              event: 'Event',
              state: 'Status',
              code_deal: 'External Reference',
              date_spot: 'Spot Date',
              compte_dept: 'Debited Account',
              amount1: 'Amount 1',
              availableAmount: 'Remaining Amount Currency 1',
              dev1: 'Currency 1',
              account_credt: 'Credited Account',
              amount2: 'Amount 2',
              dev2: 'Currency 2',
              cotation: 'Listing',
              soult: 'Currency Adjustment 2',
              accountdev1: 'Currency Account 1',
              accountdev2: 'Currency Account 2',
              sens: 'Direction',
              taux1: 'Spot Rate',
              taux2: 'Forward Rate',
              py_terme: 'Forward Points',
              lib: 'Label',
              date_opera: 'Operation Date',
              date_term: 'Maturity Date',
              value_date: 'Value Date',
              balance_date: 'Maturity Date',
              accrual_date: 'Accrual Date',
              business_code: 'Business Code',
              update_timestamp: 'Modification Date',
              create_timestamp: 'Creation Date',
              log: 'User',
              society: 'Company',
              account1: 'Account 1',
              account2: 'Account 2',
              b2b: 'B2B',
              b2baccount1: 'B2B Account 1',
              b2baccount2: 'B2B Account 2',
              counterparty: 'Counterparty',
              type: 'Type',
              origin: 'Origin',
              code: 'Contract',
            },
            actions: {
              visualise: 'View',
              anticipation: 'Anticipate',
              denouement: 'Unwind',
              proro: 'Extend',
              paid_soult: 'Cash payment',
              print_contract: 'Confirmation',
            },
            audit_action: 'List of Actions Performed',
            calendar: 'Calendar',
          },
          fiche: {
            titles: {
              edit_title: 'Foreign exchange operation sheet {{code}}',
              new_title: 'Create a new foreign exchange operation',
              view_title: 'Current account sheet',
            },
            champs: {
              state: 'Status',
              code_deal: 'External reference',
              business_code: 'Deal code',
              date_spot: 'Spot date',
              compte_dept: 'Debited account',
              amount1: 'Amount 1',
              dev1: 'Currency 1',
              date_term: 'Expiry date',
              account_credt: 'Credited account',
              amount2: 'Amount 2',
              dev2: 'Currency 2',
              sens: 'Direction',
              taux1: 'Spot rate',
              taux2: 'Term rate',
              py_terme: 'Forward points',
              lib: 'Label',
              log: 'Login',
              description: 'Description',
              type: 'Type',
              date_opera: 'Operation date',
              comment: 'Comment',
              balance: 'Balance',
              paiement: 'Payment method',
              template: 'Template',
            },
            buttons: {
              back: 'Cancel',
              save: 'Validate',
              create: 'Create',
            },
          },
          drawer_denoue: {
            title: 'Deal validation {{code}}',
            title_maket_room: 'Flow to trading room ',
            title_company: 'Flow to company',
            champs: {
              flow: 'Flow',
              account_company: 'Company account',
              room_market: 'Trading room account',
              account_company2: 'Holding account',
              room_market2: 'Company account',
              label: 'Label',
              nature_debit: 'Debit nature',
              nature_credit: 'Credit nature',
              amount: 'Amount',
              value_date: 'Value date',
              account_intermediary: 'Intermediary account',
            },
            title_intermediaire_company: 'Flow to Intermediary',
          },
          drawer_soult: {
            title: 'Balance Adjustment Modification',
          },
        },
      },
      cotationChange: {
        Liste: {
          table: {
            title: 'List of contracts',
            culumn: {
              state: 'Status',
              market_room: 'Trading room',
              company: 'Company',
              company_intermediaire: 'Intermediary company',
              date_start: 'Start date',
              date_end: 'End date',
              date_edit: 'Modification date',
            },
          },
          fiche: {
            title: 'Create a contract',
            edit_title: 'Contract sheet {{code}}',
            champs: {
              name: 'Name',
              market_room: 'Trading room',
              code: 'Code',
            },
          },
        },
      },
    },
    visu: 'View',
  },
}

